webpackJsonp([1],{

/***/ "/Qki":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lsyl-logo.f3d3d45.png";

/***/ }),

/***/ "/zcj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2lnh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XPw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3iZP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Aig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6vqz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "77Gz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7IJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7sYg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Z+l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9yqV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B3lY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "BjtM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G4+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kcix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KjuC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LUZl":
/***/ (function(module, exports) {

!function (s) {
  var c,
      p = '<svg><symbol id="icon-cataract" viewBox="0 0 1024 1024"><path d="M614.4 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M960 505.6v-44.8c12.8-32 19.2-70.4 19.2-102.4 0-211.2-185.6-358.4-454.4-358.4-128 0-236.8 57.6-326.4 108.8C108.8 160 12.8 230.4 12.8 358.4s89.6 198.4 185.6 249.6c83.2 51.2 198.4 108.8 326.4 108.8 166.4 0 307.2-57.6 384-153.6l6.4-6.4 6.4 6.4 19.2 38.4 51.2-44.8c-12.8-19.2-25.6-38.4-32-51.2z m-537.6 153.6c-83.2-19.2-153.6-57.6-204.8-89.6C102.4 499.2 51.2 441.6 51.2 358.4s44.8-147.2 166.4-211.2C262.4 121.6 320 89.6 384 70.4l32-12.8-32 19.2c-51.2 38.4-96 89.6-140.8 140.8l-25.6 32c-19.2 19.2-51.2 57.6-51.2 108.8 0 57.6 32 89.6 57.6 115.2l51.2 51.2c44.8 44.8 89.6 89.6 147.2 121.6l32 19.2-32-6.4z m275.2-12.8c-38.4 19.2-83.2 25.6-128 25.6-83.2 0-160-25.6-204.8-76.8-57.6-38.4-89.6-83.2-102.4-134.4-6.4-12.8 0-32 12.8-44.8s12.8-32 12.8-57.6c0-19.2-12.8-44.8-19.2-57.6-6.4-12.8-12.8-25.6-12.8-44.8 0-44.8 32-89.6 76.8-128C384 76.8 460.8 44.8 550.4 44.8c32 0 57.6 6.4 89.6 12.8 179.2 38.4 294.4 153.6 294.4 300.8 0 134.4-89.6 236.8-236.8 288z" fill="#212D89" ></path><path d="M224 217.6c19.2-32 76.8-64 70.4-76.8-6.4-6.4-57.6 38.4-96 51.2-32 12.8-44.8 44.8-44.8 51.2 6.4 12.8 44.8 0 70.4-25.6z m0 300.8c-19.2-25.6-57.6-38.4-64-32-6.4 6.4 6.4 38.4 38.4 51.2 38.4 19.2 89.6 57.6 96 51.2 0-6.4-51.2-38.4-70.4-70.4z" fill="#62F6DD" ></path></symbol><symbol id="icon-send" viewBox="0 0 1024 1024"><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512-230.4-512-512-512z m224 512c-6.4 6.4-12.8 6.4-19.2 6.4-6.4 0-19.2-6.4-19.2-6.4L544 358.4v371.2c0 19.2-12.8 32-32 32-6.4 0-12.8 0-19.2-6.4-6.4-6.4-6.4-12.8-6.4-19.2V364.8L332.8 505.6c-6.4 6.4-12.8 12.8-19.2 12.8-12.8 0-19.2-6.4-25.6-12.8-12.8-12.8-12.8-32 0-44.8l204.8-192h32l198.4 198.4c19.2 12.8 19.2 32 12.8 44.8z" fill="#CCCCCC" ></path></symbol><symbol id="icon-ocular-surface" viewBox="0 0 1024 1024"><path d="M396.8 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M614.4 0C384 0 300.8 172.8 198.4 307.2 300.8 448 377.6 608 614.4 614.4c224 6.4 332.8-185.6 409.6-307.2-83.2-128-185.6-307.2-409.6-307.2z m0 569.6c-179.2 0-262.4-140.8-352-262.4C345.6 192 409.6 44.8 614.4 44.8c198.4 0 288 153.6 358.4 262.4-64 96-160 262.4-358.4 262.4z" fill="#212D89" ></path><path d="M640 217.6c0 38.4 32 64 70.4 64 25.6 0 44.8-12.8 57.6-32 32 76.8-6.4 166.4-96 198.4s-179.2-6.4-211.2-83.2 6.4-172.8 89.6-198.4c38.4-12.8 83.2-12.8 121.6 0-19.2 6.4-32 32-32 51.2z" fill="#2558C7" ></path></symbol><symbol id="icon-exclamation-mark" viewBox="0 0 1024 1024"><path d="M0 512c0 281.6 230.4 512 512 512s512-230.4 512-512-230.4-512-512-512-512 230.4-512 512z" fill="#FF3939" ></path><path d="M512 665.6c-25.6 0-51.2-19.2-51.2-51.2V243.2c0-32 25.6-51.2 51.2-51.2s51.2 19.2 51.2 51.2v371.2c0 25.6-25.6 51.2-51.2 51.2zM454.4 774.4c0 32 25.6 57.6 57.6 57.6s57.6-25.6 57.6-57.6-25.6-57.6-57.6-57.6-57.6 25.6-57.6 57.6z" fill="#FFFFFF" ></path></symbol><symbol id="icon-cornea" viewBox="0 0 1024 1024"><path d="M588.8 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M723.2 339.2c6.4-6.4 6.4-19.2 0-25.6 0-6.4-38.4-51.2-89.6-102.4l64-64c6.4-6.4 6.4-19.2 0-32-6.4-6.4-19.2-6.4-32 0l-64 64c-19.2-19.2-38.4-32-64-44.8l38.4-57.6c6.4-12.8 0-25.6-6.4-32-12.8-6.4-25.6 0-32 6.4l-38.4 64c-32-12.8-57.6-25.6-96-25.6v-64C409.6 12.8 396.8 0 384 0c-12.8 0-19.2 6.4-19.2 19.2v64c-32 0-64 12.8-96 25.6L230.4 51.2C224 44.8 211.2 38.4 198.4 44.8c-6.4 6.4-12.8 19.2-6.4 32l38.4 57.6c-19.2 12.8-44.8 25.6-64 44.8l-64-64c-6.4-6.4-19.2-6.4-32 0-6.4 6.4-6.4 19.2 0 32l64 64C83.2 262.4 44.8 307.2 44.8 313.6c-6.4 6.4-6.4 12.8 0 25.6 0 6.4 38.4 51.2 89.6 102.4l-44.8 38.4c-6.4 12.8-6.4 25.6 0 32 6.4 6.4 19.2 6.4 32 0l44.8-44.8c19.2 19.2 44.8 32 70.4 51.2l-19.2 32c-6.4 12.8-6.4 25.6 6.4 32 12.8 6.4 25.6 0 32-6.4l19.2-38.4c32 12.8 57.6 19.2 89.6 25.6v25.6c0 12.8 6.4 19.2 19.2 19.2 12.8 0 19.2-6.4 19.2-19.2v-25.6c32 0 64-12.8 89.6-25.6L512 576c6.4 12.8 19.2 12.8 32 6.4s19.2-19.2 12.8-32l-19.2-32c25.6-12.8 44.8-32 70.4-51.2l38.4 44.8c6.4 6.4 19.2 6.4 32 0 6.4-6.4 6.4-19.2 0-32l-38.4-38.4c51.2-51.2 83.2-102.4 83.2-102.4zM384 518.4c-140.8 0-262.4-147.2-294.4-192C121.6 281.6 243.2 128 384 128c140.8 0 262.4 147.2 294.4 192-32 51.2-153.6 198.4-294.4 198.4zM486.4 627.2c-70.4 25.6-134.4 25.6-198.4 0-12.8-6.4-25.6 0-32 12.8-6.4 12.8 0 25.6 12.8 25.6 38.4 12.8 76.8 25.6 115.2 25.6 38.4 0 76.8-6.4 115.2-25.6 12.8 0 19.2-12.8 12.8-25.6s-19.2-19.2-25.6-12.8z" fill="#212D89" ></path><path d="M384 172.8c-83.2 0-153.6 70.4-153.6 153.6 0 83.2 70.4 153.6 153.6 153.6 83.2 0 153.6-70.4 153.6-153.6S467.2 172.8 384 172.8z m0 262.4c-57.6 0-108.8-51.2-108.8-108.8S326.4 217.6 384 217.6s108.8 51.2 108.8 108.8c0 57.6-51.2 108.8-108.8 108.8z" fill="#2558C7" ></path><path d="M384 364.8c25.6 0 44.8-19.2 44.8-44.8s-19.2-38.4-44.8-38.4c-25.6 0-44.8 19.2-44.8 44.8 0 19.2 19.2 38.4 44.8 38.4z" fill="#2558C7" ></path></symbol><symbol id="icon-oblique-amblyopia" viewBox="0 0 1024 1024"><path d="M588.8 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M371.2 0C288 0 211.2 38.4 166.4 102.4l-6.4-12.8c0-6.4-12.8-12.8-19.2-12.8H57.6c-12.8 0-19.2 6.4-19.2 19.2v345.6c0 12.8 6.4 19.2 19.2 19.2h64V512c0 32 25.6 57.6 57.6 57.6h70.4v89.6h288v-192c57.6-51.2 96-121.6 96-204.8C633.6 115.2 512 0 371.2 0z m0 51.2C473.6 51.2 556.8 121.6 576 217.6H339.2c-19.2-44.8-57.6-76.8-102.4-83.2h-32C243.2 83.2 300.8 51.2 371.2 51.2z m128 384l-6.4 172.8H288V524.8H192c-12.8 0-19.2-12.8-19.2-25.6v-57.6s0-6.4 6.4-6.4l12.8-44.8H243.2c38.4 0 76.8-32 96-76.8H576c-6.4 51.2-38.4 96-76.8 121.6zM345.6 281.6v-32h236.8v32H345.6z" fill="#212D89" ></path></symbol><symbol id="icon-glaucoma" viewBox="0 0 1024 1024"><path d="M409.6 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M761.6 179.2c-102.4 0-179.2 83.2-179.2 179.2 0 102.4 83.2 179.2 179.2 179.2 102.4 0 179.2-83.2 179.2-179.2s-76.8-179.2-179.2-179.2z m0 313.6c-70.4 0-134.4-57.6-134.4-134.4s57.6-134.4 134.4-134.4 134.4 64 134.4 134.4-57.6 134.4-134.4 134.4z" fill="#212D89" ></path><path d="M716.8 358.4c0 44.8 38.4 76.8 76.8 76.8 44.8 0 76.8-38.4 76.8-76.8 0-44.8-38.4-76.8-76.8-76.8s-76.8 32-76.8 76.8z" fill="#2558C7" ></path><path d="M652.8 0c-192 0-358.4 160-358.4 358.4s160 358.4 358.4 358.4 358.4-160 358.4-358.4S851.2 0 652.8 0z m0 665.6c-51.2 0-96-12.8-140.8-32v-25.6h38.4v-64s-6.4-6.4-6.4 0v25.6h-44.8l-32 32C435.2 576 403.2 544 384 512h32l44.8-57.6-38.4 19.2-57.6-19.2c-12.8-32-19.2-64-19.2-102.4l96 19.2c6.4 0 12.8 0 12.8-6.4l32-44.8v-6.4l-44.8 19.2h-6.4l-83.2-32c6.4-44.8 25.6-83.2 44.8-115.2l25.6 44.8h57.6s6.4 0 0-6.4l-25.6-12.8-32-57.6c19.2-19.2 32-32 57.6-51.2l12.8 38.4h32c6.4 0 6.4 0 6.4 6.4l19.2 19.2h6.4v-25.6l-25.6-19.2c-6.4 0-6.4-6.4-6.4-12.8v-32c38.4-19.2 83.2-32 128-32C825.6 44.8 960 185.6 960 352c6.4 179.2-134.4 313.6-307.2 313.6z" fill="#212D89" ></path></symbol><symbol id="icon-eye-traumas" viewBox="0 0 1024 1024"><path d="M435.2 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M262.4 230.4c-51.2 25.6-96 64-128 108.8-6.4 6.4-6.4 25.6 0 38.4 38.4 44.8 76.8 83.2 128 108.8-12.8-38.4-19.2-83.2-19.2-128s6.4-89.6 19.2-128z" fill="#62F6DD" ></path><path d="M492.8 140.8c-19.2 0-32 0-51.2 6.4l-6.4 6.4c-32 32-51.2 64-64 96 32-32 70.4-57.6 121.6-57.6 89.6 0 166.4 70.4 166.4 166.4 0 89.6-70.4 166.4-166.4 166.4-51.2 0-96-19.2-121.6-57.6 12.8 32 32 64 64 89.6l12.8 12.8c19.2 0 32 6.4 51.2 6.4 134.4 0 256-76.8 339.2-185.6 12.8-12.8 12.8-38.4 0-51.2-89.6-115.2-211.2-198.4-345.6-198.4z" fill="#212D89" ></path><path d="M492.8 262.4c51.2 0 96 44.8 96 96S544 448 492.8 448s-89.6-38.4-89.6-89.6c0-12.8 0-25.6 6.4-38.4 6.4 19.2 25.6 38.4 44.8 38.4 25.6 0 44.8-19.2 44.8-44.8 0-19.2-12.8-38.4-32-44.8 6.4-6.4 19.2-6.4 25.6-6.4z" fill="#212D89" ></path><path d="M633.6 0C435.2 0 275.2 160 275.2 358.4c0 198.4 160 358.4 358.4 358.4 198.4 0 358.4-160 358.4-358.4C985.6 160 825.6 0 633.6 0z m0 665.6C460.8 665.6 320 524.8 320 358.4 320 185.6 460.8 51.2 627.2 51.2c172.8 0 307.2 140.8 307.2 307.2 6.4 166.4-134.4 307.2-300.8 307.2z" fill="#212D89" ></path></symbol><symbol id="icon-orbital-disease" viewBox="0 0 1024 1024"><path d="M608 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M320 352c0 57.6 44.8 102.4 102.4 102.4s102.4-44.8 102.4-102.4-44.8-102.4-102.4-102.4c-57.6 0-102.4 44.8-102.4 102.4z" fill="#62F6DD" ></path><path d="M960 396.8c0-32-6.4-57.6-12.8-89.6 0-6.4-6.4-12.8-12.8-12.8-12.8-6.4-25.6 0-25.6 12.8-25.6-25.6-51.2-57.6-83.2-76.8-96-76.8-211.2-121.6-339.2-121.6s-236.8 51.2-332.8 121.6c-25.6 19.2-44.8 38.4-64 57.6 0-6.4-6.4-6.4-12.8-12.8-12.8-6.4-25.6 0-25.6 12.8-12.8 32-19.2 57.6-25.6 89.6V384c0 6.4-6.4 12.8-6.4 25.6 0 38.4 57.6 115.2 134.4 179.2 96 76.8 211.2 121.6 339.2 121.6 121.6 0 243.2-44.8 339.2-121.6 70.4-64 128-140.8 128-179.2v-12.8c0 6.4 0 6.4 0 0z m-166.4 153.6c-89.6 70.4-192 108.8-300.8 108.8-108.8 0-217.6-38.4-300.8-108.8-64-51.2-115.2-121.6-115.2-140.8C76.8 384 121.6 320 192 268.8c89.6-70.4 192-108.8 300.8-108.8s217.6 38.4 300.8 108.8c64 51.2 115.2 115.2 115.2 140.8 0 19.2-51.2 89.6-115.2 140.8z" fill="#212D89" ></path><path d="M492.8 198.4c-121.6 0-217.6 96-217.6 217.6s96 217.6 217.6 217.6 217.6-96 217.6-217.6-96-217.6-217.6-217.6z m0 390.4C396.8 588.8 313.6 512 313.6 416s76.8-172.8 172.8-172.8 172.8 76.8 172.8 172.8-70.4 172.8-166.4 172.8z" fill="#212D89" ></path><path d="M492.8 544c-12.8 0-19.2-6.4-19.2-19.2s6.4-19.2 19.2-19.2c51.2 0 89.6-38.4 89.6-89.6 0-12.8 6.4-19.2 19.2-19.2 12.8 0 19.2 6.4 19.2 19.2 6.4 70.4-57.6 128-128 128zM915.2 224c6.4 12.8 0 25.6-6.4 25.6-12.8 6.4-19.2 0-25.6-6.4-12.8-25.6-32-44.8-44.8-64-6.4-6.4-6.4-19.2 0-32 6.4-6.4 19.2-6.4 32 0 12.8 32 32 51.2 44.8 76.8zM793.6 96c12.8 6.4 12.8 19.2 6.4 32s-19.2 12.8-32 6.4c-19.2-12.8-44.8-32-70.4-38.4-12.8-6.4-12.8-19.2-6.4-25.6 6.4-12.8 19.2-12.8 25.6-12.8 32 6.4 57.6 19.2 76.8 38.4zM640 19.2c12.8 6.4 19.2 12.8 12.8 25.6 0 12.8-12.8 19.2-25.6 12.8C601.6 51.2 576 44.8 550.4 44.8c-12.8 0-19.2-12.8-19.2-25.6 0-6.4 12.8-19.2 25.6-19.2 25.6 6.4 57.6 12.8 83.2 19.2zM467.2 0c12.8 0 19.2 6.4 19.2 19.2 0 12.8-6.4 19.2-19.2 19.2-25.6 0-51.2 6.4-76.8 12.8-12.8 0-25.6-6.4-25.6-12.8 0-12.8 6.4-25.6 12.8-25.6 25.6-6.4 57.6-12.8 89.6-12.8zM294.4 44.8c12.8-6.4 25.6 0 25.6 12.8 6.4 6.4 0 19.2-12.8 25.6-19.2 12.8-44.8 25.6-64 38.4-12.8 6.4-25.6 6.4-32-6.4-6.4-6.4-6.4-19.2 6.4-25.6 25.6-19.2 51.2-32 76.8-44.8zM147.2 147.2c6.4-6.4 19.2-6.4 32 0 6.4 6.4 6.4 19.2 0 32-19.2 12.8-38.4 38.4-51.2 57.6-6.4 12.8-19.2 12.8-32 6.4s-6.4-19.2 0-32c12.8-19.2 32-44.8 51.2-64z" fill="#212D89" ></path></symbol><symbol id="icon-fundi-disease" viewBox="0 0 1024 1024"><path d="M627.2 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M364.8 0C512 38.4 627.2 172.8 627.2 332.8c0 185.6-153.6 339.2-339.2 339.2h-25.6c25.6 6.4 44.8 6.4 70.4 6.4 185.6 0 339.2-153.6 339.2-339.2 0-179.2-134.4-320-307.2-339.2z" fill="#62F6DD" ></path><path d="M339.2 0C153.6 0 0 153.6 0 339.2s153.6 339.2 339.2 339.2c128 0 243.2-70.4 300.8-179.2 25.6-51.2 38.4-102.4 38.4-160C678.4 153.6 524.8 0 339.2 0z m256 473.6c-51.2 96-147.2 153.6-256 153.6-160 0-288-128-288-288S179.2 51.2 339.2 51.2s288 128 288 288c0 44.8-12.8 96-32 134.4z" fill="#212D89" ></path><path d="M716.8 556.8h-19.2c-32-6.4-64-25.6-83.2-64-6.4-6.4 0-12.8 6.4-12.8s19.2 0 19.2 6.4c19.2 25.6 38.4 44.8 64 51.2 25.6 6.4 51.2-12.8 51.2-12.8 6.4-6.4 12.8-6.4 19.2 0 6.4 6.4 6.4 12.8 0 12.8 0 0-25.6 19.2-57.6 19.2z" fill="#212D89" ></path><path d="M70.4 288c0 102.4 83.2 192 192 192s192-83.2 192-192-83.2-192-192-192c-108.8 6.4-192 89.6-192 192z" fill="#62F6DD" ></path><path d="M198.4 268.8m-83.2 0a83.2 83.2 0 1 0 166.4 0 83.2 83.2 0 1 0-166.4 0Z" fill="#2558C7" ></path><path d="M198.4 377.6c-57.6 0-102.4-44.8-102.4-102.4 0-57.6 44.8-102.4 102.4-102.4s102.4 44.8 102.4 102.4c6.4 51.2-38.4 102.4-102.4 102.4z m0-179.2c-38.4 0-70.4 32-70.4 70.4 0 44.8 32 76.8 76.8 76.8s76.8-32 76.8-76.8-38.4-70.4-83.2-70.4z" fill="#212D89" ></path><path d="M256 499.2C140.8 499.2 44.8 403.2 44.8 288S140.8 83.2 256 83.2c115.2 0 211.2 96 211.2 211.2 0 6.4-6.4 12.8-12.8 12.8s-12.8-6.4-12.8-12.8C435.2 192 352 108.8 256 108.8S76.8 192 76.8 294.4c0 102.4 83.2 179.2 179.2 179.2 76.8 0 140.8-44.8 166.4-115.2 0-6.4 12.8-12.8 19.2-6.4 6.4 6.4 12.8 12.8 6.4 19.2-32 76.8-108.8 128-192 128zM652.8 332.8s-6.4 0 0 0l-89.6-25.6c-6.4 0-12.8-12.8-12.8-19.2 0-6.4 12.8-12.8 19.2-12.8l83.2 25.6c6.4 0 12.8 12.8 12.8 19.2 0 6.4-6.4 12.8-12.8 12.8zM358.4 76.8c-6.4 0-12.8-6.4-12.8-12.8V12.8c0-6.4 6.4-12.8 12.8-12.8s12.8 6.4 12.8 12.8v44.8c0 12.8-6.4 19.2-12.8 19.2zM556.8 224c-6.4 0-12.8-6.4-12.8-12.8v-6.4l38.4-51.2c6.4-6.4 12.8-6.4 19.2-6.4 6.4 6.4 6.4 12.8 6.4 19.2l-38.4 51.2c0 6.4-6.4 6.4-12.8 6.4zM486.4 640s-6.4 0 0 0l-134.4-38.4c-12.8-6.4-12.8-12.8-12.8-25.6 0-6.4 12.8-12.8 19.2-12.8l128 38.4 51.2-25.6h12.8c6.4 0 89.6 64 160-12.8 6.4-6.4 12.8-19.2 19.2-25.6 32-25.6 44.8-44.8 102.4 6.4 51.2 38.4 70.4 32 70.4 32l12.8 32c-6.4 6.4-38.4 19.2-102.4-38.4-19.2-19.2-32-25.6-38.4-25.6-6.4 0-12.8 12.8-25.6 25.6-6.4 6.4-12.8 19.2-25.6 25.6-70.4 76.8-160 32-185.6 19.2l-51.2 25.6z" fill="#212D89" ></path><path d="M492.8 601.6c-6.4 0-12.8-6.4-12.8-12.8L454.4 512c0-6.4 0-12.8 12.8-19.2 6.4 0 12.8 0 19.2 12.8L512 588.8c-6.4 0-6.4 12.8-19.2 12.8z m-134.4 76.8h-6.4L243.2 601.6c-6.4-6.4-6.4-12.8 0-19.2 0-12.8 12.8-12.8 19.2-6.4l108.8 76.8c6.4 6.4 6.4 12.8 6.4 19.2-6.4 6.4-12.8 6.4-19.2 6.4z m268.8-172.8c-6.4 0-6.4 0-12.8-6.4l-64-76.8c-6.4-6.4-6.4-12.8 0-19.2 6.4-6.4 12.8-6.4 19.2 0L640 480c6.4 6.4 6.4 12.8 0 19.2-6.4 6.4-6.4 6.4-12.8 6.4zM480 128c-6.4 0-12.8-6.4-12.8-19.2 0-6.4 0-12.8 6.4-12.8l51.2-32c6.4-6.4 12.8 0 19.2 6.4 6.4 6.4 0 12.8-6.4 19.2l-51.2 32c0 6.4-6.4 6.4-6.4 6.4zM198.4 288c-12.8 0-25.6-12.8-25.6-25.6s12.8-25.6 25.6-25.6 25.6 12.8 25.6 25.6c0 19.2-12.8 25.6-25.6 25.6z m0-25.6c-6.4 0-6.4 0 0 0-6.4 6.4-6.4 6.4 0 6.4v-6.4z" fill="#212D89" ></path></symbol><symbol id="icon-doctor" viewBox="0 0 1024 1024"><path d="M0 512c0 282.624 229.376 512 512 512s512-229.376 512-512S794.624 0 512 0 0 229.376 0 512z" fill="#FFFFFF" ></path><path d="M1005.056 601.6c0-313.856-217.6-569.856-486.4-569.856s-486.4 256-486.4 569.856c0 36.864 2.56 73.728 8.192 109.568 19.456 46.592 45.568 89.088 77.312 127.488h788.48c43.008-52.224 76.288-113.152 96.256-179.712 1.536-19.456 2.56-38.4 2.56-57.344z" fill="#1857E4" opacity=".2" ></path><path d="M889.344 806.4h-742.4c-6.144 0-6.144-6.656-6.144-6.656 0-6.656 6.144-6.656 6.144-6.656h742.4c6.656 0 6.656 6.656 6.656 6.656 0 6.656 0 6.656-6.656 6.656z m-761.344 0h-25.6c-6.656 0-6.656-6.656-6.656-6.656 0-6.656 6.656-6.656 6.656-6.656h25.6c6.656 0 6.656 6.656 6.656 6.656-0.512 6.656-0.512 6.656-6.656 6.656z m799.744 0h-25.6c-6.656 0-6.656-6.656-6.656-6.656 0-6.656 6.656-6.656 6.656-6.656h25.6c6.656 0 6.656 6.656 6.656 6.656 6.144 6.656 0 6.656-6.656 6.656z" fill="#1857E4" ></path><path d="M428.544 544.256c-115.2 0-211.456 89.6-211.456 211.456v45.056H640v-45.056c0-115.712-96.256-211.456-211.456-211.456z" fill="#D6DAFF" ></path><path d="M640 806.4H210.944c-6.656 0-6.656-6.656-6.656-6.656v-45.056c0-57.856 25.6-115.2 64-153.6 44.544-38.4 96.256-64 153.6-64s115.2 19.456 153.6 64c45.056 38.4 64 96.256 64 153.6v45.056c6.656 6.656 0.512 6.656 0.512 6.656zM223.744 793.6h409.6v-38.4c0-51.2-19.456-102.4-57.856-140.8-44.544-38.4-96.256-64-147.456-57.856-57.856-6.656-108.544 19.456-147.456 57.856-38.4 38.4-57.856 89.6-57.856 140.8 1.024 0 1.024 38.4 1.024 38.4z" fill="#1857E4" ></path><path d="M287.744 806.4c-6.656 0-6.656-6.656-6.656-6.656v-64c0-6.656 6.656-6.656 6.656-6.656 6.144 0 6.144 6.656 6.144 6.656v64c6.656 6.656 0.512 6.656-6.144 6.656z m275.456 0c-6.656 0-6.656-6.656-6.656-6.656v-64c0-6.656 6.656-6.656 6.656-6.656 6.656 0 6.656 6.656 6.656 6.656v64c-0.512 6.656-6.656 6.656-6.656 6.656z" fill="#1857E4" ></path><path d="M473.6 550.4c-12.8 0-32.256-6.656-44.544-6.656-19.456 0-32.256 0-51.2 6.656L358.4 621.056l64 179.2 64-179.2-12.8-70.656z" fill="#FFFFFF" ></path><path d="M428.544 806.4c-6.144 0-6.144 0 0 0l-76.8-185.856V614.4l12.8-70.656 6.656-6.656c19.456-6.656 32.256-6.656 51.2-6.656s32.256 0 51.2 6.656c0 0 6.656 0 6.656 6.656l12.8 70.656v6.656l-64.512 185.344z m-64-185.344l57.856 166.4 57.856-166.4-12.8-64c-12.8 0-32.256-6.656-45.056-6.656s-32.256 0-45.056 6.656l-12.8 64z" fill="#4550E5" ></path><path d="M428.544 512h-51.2v70.656l51.2 38.4 45.056-38.4V512h-45.056z" fill="#FFFFFF" ></path><path d="M428.544 627.2c-6.144 0-6.144 0 0 0l-57.856-32.256-6.656-6.656v-76.8c0-6.656 6.656-6.656 6.656-6.656h102.4c6.656 0 6.656 6.656 6.656 6.656v76.8s0 6.656-6.656 6.656l-44.544 32.256z m-44.544-44.544l38.4 25.6 38.4-25.6v-64H384v64z" fill="#1857E4" ></path><path d="M428.544 621.056l-38.4 134.144 38.4 45.056 32.256-45.056-32.256-134.144z" fill="#FFFFFF" ></path><path d="M428.544 806.4h-6.656l-38.4-45.056v-6.656l38.4-134.144c0-6.656 6.656-6.656 6.656-6.656s6.656 0 6.656 6.656l38.4 134.656v6.656l-38.4 45.056-6.656-0.512z m-31.744-51.2l25.6 32.256 25.6-32.256-25.6-96.256-25.6 96.256z" fill="#1857E4" ></path><path d="M473.6 678.4s-6.656 0 0 0l-44.544-44.544-51.2 19.456c-6.144 0-6.144 0-12.8-6.656 0-6.656 0-6.656 6.656-12.8l57.856-25.6H435.2l44.544 44.544c0 12.8 0 19.456-6.144 25.6 6.144 0 0 0 0 0z" fill="#1857E4" ></path><path d="M569.344 352.256v-32.256c0-76.8-64-140.8-140.8-140.8S281.6 243.2 281.6 320V358.4c-12.8-6.656-25.6 6.656-25.6 25.6s12.8 25.6 25.6 25.6c12.8 70.656 70.144 121.856 140.8 121.856s128-51.2 140.8-121.856c12.8 0 25.6-12.8 25.6-25.6s-6.656-31.744-19.456-31.744z" fill="#FFFFFF" ></path><path d="M428.544 537.6C358.4 537.6 294.4 486.4 281.6 415.744c-19.456 0-32.256-12.8-32.256-32.256s12.8-32.256 25.6-38.4v-25.6c0-83.456 70.656-153.6 153.6-153.6 76.8 0 147.456 70.656 147.456 153.6v25.6c19.456 6.656 25.6 19.456 25.6 38.4s-12.8 32.256-32.256 38.4C556.544 486.4 499.2 537.6 428.544 537.6zM287.744 403.456c6.144 0 6.144 0 6.144 6.656C307.2 473.6 358.4 524.8 428.544 524.8s121.344-51.2 134.144-115.2c0-6.144 6.656-6.144 6.656-6.144 6.656 0 19.456-12.8 19.456-19.456 0-12.8-6.656-19.456-19.456-19.456-6.656 0-6.656-6.656-6.656-6.656v-38.4c0-70.656-57.856-134.656-134.656-134.656S294.4 243.2 294.4 320V358.4c0 6.656-6.656 6.656-6.656 6.656-12.8 0-25.6 6.656-25.6 19.456 0 6.144 12.8 18.944 25.6 18.944-6.144 0-6.144 0 0 0z" fill="#1857E4" ></path><path d="M326.144 409.6c0 10.752 8.704 19.456 18.944 19.456 10.752 0 19.456-8.704 19.456-18.944 0-10.752-8.704-19.456-18.944-19.456-10.752-0.512-18.944 8.192-19.456 18.944zM486.4 409.6c0 10.752 8.704 19.456 18.944 19.456 10.752 0 19.456-8.704 19.456-18.944 0-10.752-8.704-19.456-18.944-19.456-10.752-0.512-19.456 8.192-19.456 18.944z" fill="#D6DAFF" ></path><path d="M428.544 467.456c-19.456 0-38.4-6.656-51.2-19.456-6.656 0-6.656-6.656 0-12.8 0-6.656 6.656-6.656 12.8 0 19.456 19.456 51.2 19.456 76.8 0h12.8v12.8c-18.944 12.8-38.4 19.456-51.2 19.456z m-38.4-102.4s-6.144 0 0 0c-6.656-6.656-12.8-12.8-19.456-12.8-6.656 0-12.8 6.656-19.456 12.8 0 0-6.656 6.656-6.656 0 0 0-6.656-6.656 0-6.656 6.656-12.8 12.8-19.456 25.6-19.456s19.456 6.144 25.6 19.456c1.024 6.656 1.024 6.656-5.632 6.656z m115.2 0c-6.144 0-6.144 0 0 0-12.8-6.656-19.456-12.8-25.6-12.8s-12.8 6.656-12.8 12.8c0 0-6.656 6.656-6.656 0 0 0-6.656-6.656 0-6.656 6.656-12.8 12.8-19.456 25.6-19.456s19.456 6.144 25.6 19.456c0.512 0 0.512 6.656-6.144 6.656z" fill="#1857E4" ></path><path d="M524.8 160.256c-25.6-38.4-179.2-38.4-204.8 0-115.2 25.6-70.656 217.6-64 204.8 6.144-6.656 19.456-12.8 32.256-6.656 25.6-25.6 32.256-25.6 32.256-70.656 12.8 6.656 185.344 6.656 198.656-64-7.168 57.856 11.776 96.256 37.376 134.656 12.8-6.656 25.6 0 32.256 6.656 12.8 12.288 51.2-179.2-64-204.8z" fill="#FFFFFF" ></path><path d="M377.344 544.256l-19.456 76.8 64 179.2h-32.256L332.8 761.856c-6.656-6.656-6.656-12.8-6.656-19.456l19.456-38.4-51.2-45.056c-6.144-6.656-6.144-12.8-6.144-12.8 18.944-38.4 31.744-89.088 89.088-101.888z" fill="#D6DAFF" ></path><path d="M428.544 806.4H384L332.8 768c-12.8-6.656-12.8-19.456-6.656-25.6l19.456-32.256-44.544-38.4c-6.656-6.656-12.8-12.8-6.656-25.6 0-6.656 0-6.656 6.656-12.8 12.8-38.4 25.6-83.456 82.944-96.256h6.656v6.656l-19.456 76.8 64 179.2v6.656h-6.656z m-38.4-12.8H409.6l-64-172.544V614.4l12.8-57.856c-32.256 12.8-38.4 45.056-51.2 76.8 0 6.656 0 6.656-6.656 12.8v6.656l51.2 44.544s6.656 6.656 0 12.8l-19.456 38.4v6.656l57.856 38.4z" fill="#1857E4" ></path><path d="M473.6 544.256l19.456 76.8-64 179.2h38.4l57.344-38.4c6.656-6.656 6.656-12.8 6.656-19.456l-19.456-38.4 51.2-45.056c6.656-6.656 6.656-12.8 6.656-12.8-26.112-37.888-32.256-89.088-96.256-101.888z" fill="#D6DAFF" ></path><path d="M460.8 806.4h-32.256s-6.656 0-6.656-6.656V793.6L486.4 614.4l-19.456-64v-6.656h6.656c57.344 12.8 70.656 57.856 83.456 96.256 0 6.656 0 6.656 6.656 12.8 0 6.656 0 19.456-6.656 25.6l-45.056 32.256 19.456 32.256c6.656 12.8 0 25.6-6.656 32.256L460.8 806.4c6.144 0 0 0 0 0z m-25.6-12.8h19.456l57.856-38.4v-6.656l-19.456-38.4v-12.8l51.2-45.056v-6.656c0-6.656 0-6.656-6.656-12.8-12.8-32.256-19.456-64-57.856-76.8l12.8 57.344v6.656L435.2 793.6z" fill="#1857E4" ></path><path d="M537.088 964.608c0 7.168 51.712 12.8 115.2 12.8 32.256 0 60.928-1.536 81.92-3.584 8.704-4.096 17.408-8.704 26.112-13.312-16.384-4.608-58.368-8.192-108.032-8.192-64-0.512-115.2 5.12-115.2 12.288z" fill="#F0F2FF" ></path><path d="M850.944 755.2c0-6.656-6.656-12.8-12.8-12.8h-89.6c-6.656 0-12.8-6.656-12.8-12.8V640c0-6.656-6.656-12.8-12.8-12.8h-70.656c-12.8-6.656-19.456 0-19.456 12.8v89.6c0 6.656-6.656 12.8-12.8 12.8h-96.256c-6.656 0-12.8 6.656-12.8 12.8v76.8c0 6.656 6.656 12.8 12.8 12.8H614.4c6.656 0 12.8 6.656 12.8 12.8V947.2c0 6.656 6.656 12.8 12.8 12.8h70.656c6.656 0 12.8-6.656 12.8-12.8v-89.6c0-6.656 6.656-12.8 12.8-12.8h89.6c6.656 0 12.8-6.656 12.8-12.8v-76.8h12.288z" fill="#FFFFFF" ></path><path d="M716.8 972.8h-70.656c-12.8 0-25.6-12.8-25.6-25.6v-89.6s0-6.656-6.656-6.656h-89.6c-12.8 0-25.6-12.8-25.6-25.6v-70.656c0-12.8 12.8-25.6 25.6-25.6H614.4s6.656 0 6.656-6.656V640c0-12.8 12.8-25.6 25.6-25.6H716.8c12.8 0 25.6 12.8 25.6 25.6v89.6s0 6.656 6.656 6.656h89.6c12.8 0 25.6 12.8 25.6 25.6v70.656c0 12.8-12.8 25.6-25.6 25.6h-89.6s-6.656 0-6.656 6.656v89.6c-6.656 5.632-12.8 18.432-25.6 18.432z m-192-217.6s-6.656 0 0 0l-6.144 76.8s0 6.656 6.656 6.656H614.4c12.8 0 25.6 12.8 25.6 25.6v89.6s0 6.656 6.656 6.656H716.8s6.656 0 6.656-6.656v-89.6c0-12.8 12.8-25.6 25.6-25.6h89.6s6.656 0 6.656-6.656v-70.656s0-6.656-6.656-6.656h-89.6c-12.8 0-25.6-12.8-25.6-25.6V640s0-6.656-6.656-6.656h-70.656s-6.656 0-6.656 6.656v89.6c0 12.8-12.8 25.6-25.6 25.6h-89.088zM588.8 377.856h-6.656s-6.656-6.656-19.456 0c-6.656 0-6.656 0-12.8-6.656-19.456-38.4-38.4-70.144-44.544-108.544-6.656 6.656-12.8 12.8-25.6 19.456-45.056 19.456-121.856 25.6-153.6 19.456 0 25.6-6.656 32.256-19.456 51.2 0 6.144-6.656 6.144-6.656 12.8s-6.144 6.656-12.8 0c-12.8-6.656-19.456 0-19.456 0s-6.144 6.656-12.8 0c-12.8 0-19.456-57.856-19.456-102.4C243.2 204.8 274.944 166.4 320 153.6c19.456-18.944 64-25.6 108.544-25.6 38.4 0 83.456 6.144 102.4 25.6 45.056 12.8 76.8 51.2 83.456 109.056 0 44.544-6.656 102.4-25.6 115.2 6.144 0 0 0 0 0zM428.544 140.8c-45.056 0-83.456 12.8-96.256 25.6l-6.656 6.656c-32.256 0-51.2 19.456-64 51.2-18.944 44.544-6.144 109.056 0 128 6.656-6.656 19.456-6.656 25.6-6.656l6.144-6.656c12.8-12.8 19.456-19.456 19.456-51.2 0 0 0-6.656 6.656-6.656h6.144c12.8 6.656 102.4 6.656 153.6-19.456 19.456-6.656 25.6-19.456 25.6-32.256 0-6.656 6.656-6.656 6.656-6.656 6.656 0 6.656 6.656 6.656 6.656 0 44.544 12.8 82.944 38.4 121.856 12.8 0 19.456 0 25.6 6.656 6.656-19.456 12.8-76.8 0-128-6.656-38.4-25.6-57.856-57.344-64 0 0-6.656 0-6.656-6.656-6.144-5.632-44.544-18.432-89.6-18.432z" fill="#1857E4" ></path></symbol><symbol id="icon-shortsightedness" viewBox="0 0 1024 1024"><path d="M614.4 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M492.8 140.8c19.2 0 32 0 51.2 6.4l12.8 12.8c19.2 19.2 38.4 51.2 57.6 83.2-32-32-76.8-57.6-121.6-57.6-89.6 0-160 70.4-160 160s70.4 160 160 160c44.8 0 89.6-19.2 121.6-57.6-19.2 38.4-38.4 64-64 89.6 0 6.4-6.4 12.8-12.8 12.8-19.2 0-32 6.4-51.2 6.4-134.4 0-249.6-76.8-332.8-185.6-6.4-12.8-6.4-38.4 6.4-51.2 83.2-102.4 198.4-179.2 332.8-179.2z" fill="#212D89" ></path><path d="M364.8 0C172.8 0 19.2 153.6 19.2 345.6s153.6 345.6 345.6 345.6 345.6-153.6 345.6-345.6c6.4-192-153.6-345.6-345.6-345.6z m0 640c-160 0-294.4-128-294.4-294.4S204.8 51.2 364.8 51.2c166.4 0 294.4 134.4 294.4 294.4 6.4 166.4-128 294.4-294.4 294.4z" fill="#212D89" ></path><path d="M416 345.6a102.4 89.6 90 1 0 179.2 0 102.4 89.6 90 1 0-179.2 0Z" fill="#2558C7" ></path><path d="M793.6 358.4h192c12.8 0 19.2-12.8 19.2-25.6s-6.4-25.6-19.2-25.6h-192c-12.8 0-19.2 12.8-19.2 25.6s6.4 25.6 19.2 25.6zM889.6 492.8c6.4 0 12.8-6.4 19.2-12.8 6.4-12.8 6.4-25.6-6.4-32l-108.8-76.8c-12.8-6.4-25.6 0-32 12.8s-6.4 25.6 6.4 32l108.8 76.8h12.8zM774.4 627.2s6.4 0 0 0c19.2-6.4 25.6-19.2 25.6-32l-25.6-128c0-12.8-19.2-19.2-32-19.2s-19.2 19.2-19.2 32l25.6 128c6.4 12.8 12.8 19.2 25.6 19.2zM780.8 288c6.4 0 6.4 0 12.8-6.4l108.8-70.4c12.8-6.4 12.8-25.6 6.4-32-6.4-12.8-25.6-12.8-32-6.4L768 243.2c-12.8 6.4-12.8 25.6-6.4 32 6.4 6.4 12.8 12.8 19.2 12.8zM748.8 204.8c12.8 0 19.2-6.4 25.6-19.2l32-128c6.4-12.8-6.4-25.6-19.2-32s-25.6 6.4-32 19.2l-32 128c-6.4 12.8 6.4 25.6 25.6 32-6.4 0-6.4 0 0 0z" fill="#62F6DD" ></path><path d="M32 614.4c-12.8 0-12.8-6.4-12.8-19.2 0-38.4 12.8-64 38.4-70.4 25.6-19.2 64 12.8 70.4 12.8 6.4 6.4 6.4 12.8 0 19.2-6.4 6.4-12.8 6.4-19.2 0-6.4 0-32-12.8-44.8-6.4-6.4 6.4-12.8 19.2-19.2 44.8 0 12.8-6.4 19.2-12.8 19.2z" fill="#212D89" ></path><path d="M102.4 678.4c-6.4 0-6.4 0-12.8-6.4-51.2-51.2-6.4-128 0-134.4s12.8-6.4 19.2-6.4c6.4 6.4 6.4 12.8 6.4 19.2 0 0-38.4 57.6 0 96 6.4 6.4 6.4 12.8 0 19.2l-12.8 12.8z" fill="#212D89" ></path></symbol><symbol id="icon-plastic" viewBox="0 0 1024 1024"><path d="M0.00128 627.456991a396.799008 396.543009 0 1 0 793.598016 0 396.799008 396.543009 0 1 0-793.598016 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M585.727816 235.265972l25.087937-38.527904a8.06398 8.06398 0 0 0-3.199992-11.647971 82.111795 82.111795 0 0 0-116.09571 52.479869 80.383799 80.383799 0 0 0 59.583851 97.599756 82.111795 82.111795 0 0 0 99.455752-58.559854 78.079805 78.079805 0 0 0-1.727996-44.223889 8.12798 8.12798 0 0 0-11.071972-4.799988l-41.919896 19.327952c-7.295982 3.391992-14.463964-4.863988-10.111974-11.647971z" fill="#62F6DD" ></path><path d="M692.223549 192.00208a7.93598 7.93598 0 0 0-4.671988 10.879973c7.93598 16.447959 12.415969 34.815913 12.415969 54.207864 0 69.951825-57.727856 126.719683-128.959678 126.719683s-129.023677-56.767858-129.023677-126.719683 57.791856-126.719683 129.023677-126.719683c21.951945 0 42.559894 5.503986 60.607849 15.039962a8.12798 8.12798 0 0 0 11.199972-3.455991l12.991967-26.687933a7.99998 7.99998 0 0 0-3.391991-10.623974 176.639558 176.639558 0 0 0-81.407797-19.83995H570.879853c-96.895758 0-175.359562 77.183807-175.359562 172.287569 0 95.167762 78.527804 172.287569 175.359562 172.28757 96.895758 0 175.423561-77.119807 175.487561-172.28757a168.319579 168.319579 0 0 0-15.615961-70.655823 7.99998 7.99998 0 0 0-9.855975-4.09599l-28.735928 9.599976zM936.958938 178.882113l44.159889 45.055887c3.199992 3.199992 8.255979 3.199992 11.391972 0.064a7.99998 7.99998 0 0 0 0.127999-11.327972l-44.287889-44.991887a7.99998 7.99998 0 1 0-11.455971 11.263972zM947.96691 156.802168l55.487861 56.511859 7.807981-7.679981a40.447899 40.447899 0 0 0 1.727996-57.215857 40.511899 40.511899 0 0 0-57.215857 0.703998l-7.807981 7.679981zM981.246827 235.073972l-49.919875-50.751873a7.99998 7.99998 0 0 0-11.327972-0.127999c-38.783903 37.951905-262.783343 257.087357-266.239334 260.863347-1.983995 2.239994 0.192 6.271984 2.687993 9.535977 2.431994 3.199992 2.175995 7.679981-0.639999 10.559973l-139.77565 139.519651c-4.735988 4.671988-1.919995 12.927968 4.671988 13.631966 94.911763 10.047975 121.727696-88.319779 131.711671-105.343736 7.103982-12.15997 19.519951-24.19194 26.687933-30.591924a7.99998 7.99998 0 0 1 10.751973 0.064l16.12796 14.719963c3.199992 2.879993 8.06398 2.815993 11.071972-0.191999l264.511339-262.207345-0.319999 0.319999zM601.919775 585.281097c-23.359942 24.19194-62.207844 25.983935-62.207844 25.983935s17.407956-9.599976 41.599896-20.22395c24.319939-10.623973 49.279877-41.727896 49.279877-41.727895s-5.375987 11.83997-28.671929 35.96791z m119.9997-104.959738a7.99998 7.99998 0 0 1-11.327971-0.064l-4.735989-4.799988s41.151897-30.079925 63.039843-51.519871c21.887945-21.503946 103.167742-90.879773 103.167742-90.879773L721.919475 480.257359z" fill="#212D89" ></path><path d="M607.359762 477.249367a7.93598 7.93598 0 0 0-6.207985-13.503966 449.918875 449.918875 0 0 1-394.175014-182.463544 34.175915 34.175915 0 0 1 0-40.319899A449.918875 449.918875 0 0 1 571.007852 57.346417c120.639698 0 229.887425 47.039882 310.399224 123.135692 3.199992 3.071992 8.19198 3.007992 11.263972-0.192l27.199932-28.351929a8.12798 8.12798 0 0 0-0.127999-11.327972A499.774751 499.774751 0 0 0 570.879853 0.00256a499.198752 499.198752 0 0 0-397.759006 195.455511c-11.583971 15.231962-22.335944 31.231922-32.06392 47.743881a35.071912 35.071912 0 0 0 0 35.775911c9.727976 16.575959 20.479949 32.511919 32.06392 47.74388a499.006752 499.006752 0 0 0 387.647031 195.199512c2.239994 0.064 4.479989-0.831998 6.015985-2.495994l40.575899-42.239894zM785.471316 456.961418c-6.207984 6.527984 1.343997 16.767958 9.407977 12.799968a496.318759 496.318759 0 0 0 173.887565-143.039643c14.911963-19.455951 28.223929-40.1279 40.0639-61.695846a8.255979 8.255979 0 0 0 0-7.87198 465.918835 465.918835 0 0 0-6.655983-11.711971 8.06398 8.06398 0 0 0-12.799968-1.407996L785.535316 456.961418z" fill="#212D89" ></path></symbol><symbol id="icon-guide" viewBox="0 0 1024 1024"><path d="M708.48 827.52v167.488H579.584v-264.064a382.976 382.976 0 0 0 315.52-315.52H1024c-19.328 186.752-148.096 347.776-315.52 412.16zM321.984 827.52C148.096 763.264 25.792 602.24 0 415.36h128.832a382.976 382.976 0 0 0 315.52 315.584v264.064H321.984v-167.424z" fill="#212D89" ></path><path d="M656.896 28.992c103.04 0 180.352 70.848 180.352 180.288 0 90.24-77.312 186.816-135.232 238.336-38.656 38.592-103.04 77.248-186.816 122.368C431.488 524.8 367.104 486.208 328.448 447.616 264.064 389.632 193.28 299.456 193.28 209.28c0-109.44 77.248-180.288 180.288-180.288 57.984 0 103.04 25.728 141.696 70.848C553.856 54.72 598.912 28.992 656.896 28.992z" fill="#F35A48" ></path></symbol><symbol id="icon-go-back" viewBox="0 0 1024 1024"><path d="M947.4 864C893.2 697.7 736.2 578.9 551 575.5c-23.1-0.4-44.9 0.1-65.6 1.5v164.3c0.1 0.5 0.2 1 0.2 1.5 0 4-3.3 7.3-7.3 7.3-2.7 0-5-1.4-6.2-3.5v0.7L68.8 465.4h2.1c-4 0-7.3-3.3-7.3-7.3 0-2.9 1.7-5.4 4.1-6.6L472 169v0.7c1.3-2.1 3.6-3.5 6.2-3.5 4 0 7.3 3.3 7.3 7.3 0 0.5-0.1 1-0.2 1.5v159.4c18.5-0.9 37.9-1.2 58.3-0.8 230.1 3.9 416.7 196.9 416.7 427.1 0.1 35.5-4.5 70.2-12.9 103.3z m-462-704.4v0.2h-0.4l0.4-0.2z m0 596.9l-0.3-0.2h0.3v0.2z" fill="#FFAD33" ></path></symbol><symbol id="icon-send-ok" viewBox="0 0 1024 1024"><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512-230.4-512-512-512z m224 512c-6.4 6.4-12.8 6.4-19.2 6.4-6.4 0-19.2-6.4-19.2-6.4L544 358.4v371.2c0 19.2-12.8 32-32 32-6.4 0-12.8 0-19.2-6.4-6.4-6.4-6.4-12.8-6.4-19.2V364.8L332.8 505.6c-6.4 6.4-12.8 12.8-19.2 12.8-12.8 0-19.2-6.4-25.6-12.8-12.8-12.8-12.8-32 0-44.8l204.8-192h32l198.4 198.4c19.2 12.8 19.2 32 12.8 44.8z" fill="#1857E4" ></path></symbol><symbol id="icon-vistel" viewBox="0 0 1024 1024"><path d="M588.8 627.2m-396.8 0a396.8 396.8 0 1 0 793.6 0 396.8 396.8 0 1 0-793.6 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M371.2 0C288 0 211.2 38.4 166.4 102.4l-6.4-12.8c0-6.4-12.8-12.8-19.2-12.8H57.6c-12.8 0-19.2 6.4-19.2 19.2v345.6c0 12.8 6.4 19.2 19.2 19.2h64V512c0 32 25.6 57.6 57.6 57.6h70.4v89.6h288v-192c57.6-51.2 96-121.6 96-204.8C633.6 115.2 512 0 371.2 0z m0 51.2C473.6 51.2 556.8 121.6 576 217.6H339.2c-19.2-44.8-57.6-76.8-102.4-83.2h-32C243.2 83.2 300.8 51.2 371.2 51.2z m128 384l-6.4 172.8H288V524.8H192c-12.8 0-19.2-12.8-19.2-25.6v-57.6s0-6.4 6.4-6.4l12.8-44.8H243.2c38.4 0 76.8-32 96-76.8H576c-6.4 51.2-38.4 96-76.8 121.6zM345.6 281.6v-32h236.8v32H345.6z" fill="#212D89" ></path></symbol><symbol id="icon-delete" viewBox="0 0 1024 1024"><path d="M874.239454 149.759906C674.559578-49.919969 349.439782-49.919969 149.759906 149.759906c-199.679875 199.743875-199.679875 524.735672 0 724.479548A510.591681 510.591681 0 0 0 511.99968 1023.99936c131.199918 0 262.399836-49.919969 362.239774-149.759906 199.679875-199.743875 199.679875-524.735672 0-724.479548z m-193.727879 478.975701a48.831969 48.831969 0 1 1-69.119957 69.119957l-103.679935-103.679935-103.679936 103.679935a48.70397 48.70397 0 0 1-69.119956 0 48.831969 48.831969 0 0 1 0-69.119957l103.679935-103.679935-103.679935-103.679935a48.831969 48.831969 0 1 1 69.119956-69.119957l103.679936 103.679935 112.319929-112.38393a48.831969 48.831969 0 1 1 69.119957 69.119957L576.831639 524.991672l103.679936 103.679935z"  ></path></symbol><symbol id="icon-none" viewBox="0 0 1274 1024"><path d="M390.264427 77.167762l181.263209 55.102021 230.256635 431.466277a24.933041 24.933041 0 0 1-10.222547 33.659606L360.594108 827.465303a24.1383 24.1383 0 0 1-11.71853 2.991965 24.668128 24.668128 0 0 1-21.941076-13.276844L45.440467 289.347943A25.057706 25.057706 0 0 1 43.632822 270.398831a24.496713 24.496713 0 0 1 12.092525-14.710494L390.264427 77.167762m-1.371318-13.276844L49.866082 244.842464a37.165814 37.165814 0 0 0-15.33382 50.364743l281.556367 527.832481A37.196981 37.196981 0 0 0 349.062576 842.736791a36.558072 36.558072 0 0 0 17.453129-4.363282l430.780618-229.88264a37.165814 37.165814 0 0 0 15.333821-50.364743L580.00487 121.922571z m0 0" fill="#B2B2B2" ></path><path d="M60.898953 249.704407a37.165814 37.165814 0 0 0-15.33382 50.364743L327.246165 827.901631a37.165814 37.165814 0 0 0 50.364743 15.333821L808.391527 613.352812a37.165814 37.165814 0 0 0 15.33382-50.364743L591.100073 126.909179 399.988313 68.815194z m0 0" fill="#FFFFFF" ></path><path d="M474.912101 192.981738a25.229121 25.229121 0 0 1-7.479912-1.121986 25.696616 25.696616 0 0 1-15.209155-12.466521l-53.294376-99.732165 10.908206-5.859264 53.232043 99.732164a13.136596 13.136596 0 0 0 7.791575 6.482591 13.90017 13.90017 0 0 0 10.222547-0.997322l99.732165-53.232042 5.859264 10.908205-99.732164 53.232043a26.865352 26.865352 0 0 1-12.217191 2.991965z m0 0" fill="#BDE3F4" ></path><path d="M142.554663 358.786462a22.190407 22.190407 0 0 0 11.095203 19.214025 22.15924 22.15924 0 0 0 22.190407 0 22.190407 22.190407 0 0 0 11.157536-19.214025 22.20599 22.20599 0 0 0-11.095204-19.214025 22.190407 22.190407 0 0 0-22.190406 0 22.190407 22.190407 0 0 0-11.095204 19.214025z m0 0M222.215729 311.289019a22.190407 22.190407 0 0 0 11.095204 19.214025 22.20599 22.20599 0 0 0 22.190406 0 22.190407 22.190407 0 0 0 11.095203-19.214025 22.174823 22.174823 0 0 0-11.03287-19.214025 22.174823 22.174823 0 0 0-22.190407 0 22.174823 22.174823 0 0 0-11.095203 19.214025z m0 0M302.001461 263.66691a22.190407 22.190407 0 0 0 22.128074 22.190407 22.190407 22.190407 0 0 0 22.252739-22.190407A22.190407 22.190407 0 0 0 324.129535 241.538836a22.190407 22.190407 0 0 0-22.128074 22.128074z m0 0M527.894814 291.404918L215.04748 459.515948a21.255418 21.255418 0 0 1-28.672997-8.601899l-0.124666-0.24933a21.255418 21.255418 0 0 1 8.539567-28.672998L507.69905 254.005357a21.255418 21.255418 0 0 1 28.672998 8.539566l0.124665 0.249331a21.099586 21.099586 0 0 1-8.601899 28.610664z m74.175797 110.827368L289.160945 570.343316a21.255418 21.255418 0 0 1-28.672998-8.601899l-0.124665-0.24933a21.239834 21.239834 0 0 1 8.601899-28.672998l312.909667-168.048697a21.255418 21.255418 0 0 1 28.672997 8.601899l0.124665 0.249331a21.239834 21.239834 0 0 1-8.601899 28.672997z m-72.80448 152.901875L336.596056 658.606282a21.255418 21.255418 0 0 1-28.672998-8.601899l-0.124665-0.249331a21.255418 21.255418 0 0 1 8.539567-28.672997l192.732408-103.472121a21.255418 21.255418 0 0 1 28.672997 8.601899l0.124665 0.249331a21.02167 21.02167 0 0 1-8.601899 28.672997z m0 0" fill="#B2B2B2" ></path><path d="M398.741661 841.490139a40.859021 40.859021 0 0 1-40.765523-40.765522V46.874117a40.859021 40.859021 0 0 1 40.765523-40.765522h481.83102l174.281957 174.281958v620.209398a40.859021 40.859021 0 0 1-40.765522 40.765523H398.741661z m0 0" fill="#FFFFFF" ></path><path d="M877.954711 12.341855L1048.746043 183.133187v617.59143A34.532262 34.532262 0 0 1 1014.213781 835.256879h-615.534453a34.532262 34.532262 0 0 1-34.532262-34.532262V46.874117a34.532262 34.532262 0 0 1 34.594595-34.532262H877.954711M883.19065 0H398.741661a47.029949 47.029949 0 0 0-46.998783 46.998783v753.725834A47.029949 47.029949 0 0 0 398.741661 847.723399h615.347455a47.029949 47.029949 0 0 0 46.998783-46.998782V177.897249z m0 0" fill="#B2B2B2" ></path><path d="M1050.304358 178.520575h-142.429997a24.652544 24.652544 0 0 1-24.683711-24.683711V11.469199" fill="#FFFFFF" ></path><path d="M1050.304358 184.62917h-142.429997a30.854638 30.854638 0 0 1-30.792306-30.792306V11.469199h12.466521v142.367665a18.403701 18.403701 0 0 0 18.45045 18.45045H1050.304358v12.341856z m0 0M615.783784 234.869248a9.505722 9.505722 0 0 1-5.360604-1.745313L548.215242 188.556124a9.34989 9.34989 0 0 1-2.119308-12.965182 9.34989 9.34989 0 0 1 12.965181-2.119308l62.207938 44.630143a9.34989 9.34989 0 0 1 2.056976 12.902849 9.552471 9.552471 0 0 1-7.604578 3.864622z m0 0" fill="#B2B2B2" ></path><path d="M537.120039 286.231312a9.568055 9.568055 0 0 1-7.791575-4.238617 9.147309 9.147309 0 0 1 2.680302-12.840516l77.791088-50.614073a9.256392 9.256392 0 0 1 12.840516 2.742634 9.240808 9.240808 0 0 1-2.742634 12.840516l-77.791089 50.614074a8.975895 8.975895 0 0 1-4.986608 1.558315z m0 0M797.171658 234.869248a9.552471 9.552471 0 0 1-7.604577-3.864622 9.34989 9.34989 0 0 1 2.056975-12.965181l62.332603-44.630144a9.34989 9.34989 0 0 1 12.965182 2.119309 9.34989 9.34989 0 0 1-2.181641 13.027514L802.532262 233.123935a9.474556 9.474556 0 0 1-5.360604 1.745313z m0 0" fill="#B2B2B2" ></path><path d="M875.77307 286.231312a9.708303 9.708303 0 0 1-5.111273-1.558315l-77.728756-50.676406a9.34989 9.34989 0 0 1-2.742634-12.840516 9.34989 9.34989 0 0 1 12.840516-2.742635l77.791088 50.614074a9.34989 9.34989 0 0 1 2.742635 12.840516 9.069394 9.069394 0 0 1-7.791576 4.363282z m0 0M706.415388 286.106647c14.024836 0 26.055028 15.707816 26.055028 34.158267s-11.96786 34.158266-26.055028 34.158266-26.055028-15.707816-26.055028-34.158266 11.96786-34.158266 26.055028-34.158267m0-18.575115c-24.683711 0-44.630144 23.686389-44.630143 52.858047s19.946433 52.858047 44.630143 52.858047S751.107865 349.561237 751.107865 320.389579s-20.008766-52.858047-44.692477-52.858047z m0 0M471.920136 466.621865a22.190407 22.190407 0 1 0 22.190407-22.190407 22.190407 22.190407 0 0 0-22.190407 22.190407z m0 0M919.842221 487.939615H564.671049a21.177502 21.177502 0 0 1-21.193085-21.193085v-0.24933a21.161919 21.161919 0 0 1 21.193085-21.193085h355.171172a21.161919 21.161919 0 0 1 21.193085 21.193085v0.24933a21.177502 21.177502 0 0 1-21.193085 21.193085z m0 0M471.920136 608.7402a22.190407 22.190407 0 1 0 22.190407-22.190407 22.190407 22.190407 0 0 0-22.190407 22.190407z m0 0M919.842221 630.05795H564.671049a21.177502 21.177502 0 0 1-21.193085-21.193085v-0.249331a21.161919 21.161919 0 0 1 21.193085-21.193085h355.171172a21.177502 21.177502 0 0 1 21.193085 21.193085v0.249331a21.177502 21.177502 0 0 1-21.193085 21.193085z m0 0M471.920136 750.858534a22.190407 22.190407 0 1 0 22.190407-22.190406 22.190407 22.190407 0 0 0-22.190407 22.190406z m0 0M919.842221 772.176284H564.671049a21.177502 21.177502 0 0 1-21.193085-21.193085v-0.24933a21.177502 21.177502 0 0 1 21.193085-21.193085h355.171172a21.177502 21.177502 0 0 1 21.193085 21.193085v0.24933a21.177502 21.177502 0 0 1-21.193085 21.193085z m0 0M1096.679815 851.08936H181.138544a9.34989 9.34989 0 0 1-9.34989-9.349891 9.34989 9.34989 0 0 1 9.34989-9.34989h915.665936a9.34989 9.34989 0 0 1 9.349891 9.34989 9.521305 9.521305 0 0 1-9.474556 9.349891z m-937.856343 0H64.950572a9.34989 9.34989 0 0 1-9.34989-9.349891 9.34989 9.34989 0 0 1 9.34989-9.34989h93.8729a9.34989 9.34989 0 0 1 9.349891 9.34989 9.34989 9.34989 0 0 1-9.349891 9.349891z m0 0" fill="#B2B2B2" ></path><path d="M46.375457 851.08936H9.34989a9.34989 9.34989 0 0 1-9.34989-9.349891 9.34989 9.34989 0 0 1 9.34989-9.34989h37.025567a9.34989 9.34989 0 0 1 9.34989 9.34989 9.34989 9.34989 0 0 1-9.34989 9.349891z m1160.259069 0h-91.379595a9.34989 9.34989 0 0 1 0-18.699781h91.379595a9.34989 9.34989 0 0 1 0 18.699781z m58.093986 0h-37.025566a9.34989 9.34989 0 0 1 0-18.699781h37.025566a9.34989 9.34989 0 0 1 0 18.699781z m0 0M335.598734 909.05868H294.833212a9.34989 9.34989 0 0 1-9.349891-9.34989 9.34989 9.34989 0 0 1 9.349891-9.349891h40.765522a9.34989 9.34989 0 0 1 9.34989 9.349891 9.34989 9.34989 0 0 1-9.34989 9.34989z m254.441685 0H366.39104a9.34989 9.34989 0 0 1-9.349891-9.34989 9.34989 9.34989 0 0 1 9.349891-9.349891h223.649379a9.34989 9.34989 0 1 1 0 18.699781z m305.305089 0H634.545897a9.34989 9.34989 0 0 1 0-18.699781h260.674945a9.34989 9.34989 0 0 1 9.349891 9.349891 9.225225 9.225225 0 0 1-9.225225 9.34989z m104.968103 0h-67.942537a9.34989 9.34989 0 0 1 0-18.699781h67.942537a9.34989 9.34989 0 0 1 0 18.699781z m0 0M748.240565 1024H529.577794a9.34989 9.34989 0 0 1 0-18.699781h218.662771a9.34989 9.34989 0 1 1 0 18.699781z m67.942537 0h-17.328464a9.34989 9.34989 0 0 1 0-18.699781h17.328464a9.34989 9.34989 0 0 1 0 18.699781z m-324.877526 0h-30.916971a9.34989 9.34989 0 0 1 0-18.699781h30.916971a9.34989 9.34989 0 0 1 0 18.699781z m0 0M1069.814463 40.765522h-30.916971a6.23326 6.23326 0 0 1-6.23326-6.23326 6.23326 6.23326 0 0 1 6.23326-6.23326h30.916971a6.23326 6.23326 0 0 1 6.23326 6.23326 6.23326 6.23326 0 0 1-6.23326 6.23326z m0 0" fill="#B2B2B2" ></path><path d="M1054.355978 56.224008a6.23326 6.23326 0 0 1-6.233261-6.23326V19.073776a6.23326 6.23326 0 0 1 6.233261-6.23326 6.23326 6.23326 0 0 1 6.23326 6.23326v30.916972a6.23326 6.23326 0 0 1-6.23326 6.23326z m-15.957147 59.340638a6.23326 6.23326 0 0 1-6.23326-6.233261v-1.558315a6.23326 6.23326 0 0 1 6.23326-6.23326 6.23326 6.23326 0 0 1 6.233261 6.23326v1.558315a6.326759 6.326759 0 0 1-6.233261 6.233261z m0 0M1154.337473 103.098125H1123.545167a6.23326 6.23326 0 0 1-6.23326-6.23326 6.23326 6.23326 0 0 1 6.23326-6.23326h30.916971a6.23326 6.23326 0 0 1 6.23326 6.23326 6.23326 6.23326 0 0 1-6.357925 6.23326z m0 0" fill="#B2B2B2" ></path><path d="M1138.878987 118.556611a6.23326 6.23326 0 0 1-6.23326-6.233261V81.406379a6.23326 6.23326 0 0 1 6.23326-6.23326 6.23326 6.23326 0 0 1 6.23326 6.23326v30.916971a6.23326 6.23326 0 0 1-6.23326 6.233261z m0 0M152.527879 763.948381H103.160458a9.34989 9.34989 0 0 1-9.349891-9.349891 9.34989 9.34989 0 0 1 9.349891-9.34989h49.367421a9.34989 9.34989 0 0 1 9.349891 9.34989 9.34989 9.34989 0 0 1-9.349891 9.349891z m0 0" fill="#B2B2B2" ></path><path d="M127.781836 788.756757a9.34989 9.34989 0 0 1-9.349891-9.349891v-49.367421a9.34989 9.34989 0 0 1 9.349891-9.349891 9.256392 9.256392 0 0 1 9.34989 9.349891v49.367421a9.34989 9.34989 0 0 1-9.34989 9.349891z m39.892866-200.586316H118.30728a9.34989 9.34989 0 0 1-9.34989-9.349891 9.34989 9.34989 0 0 1 9.34989-9.34989h49.367422a9.34989 9.34989 0 0 1 9.34989 9.34989 9.34989 9.34989 0 0 1-9.34989 9.349891z m0 0" fill="#B2B2B2" ></path><path d="M142.928658 612.854151a9.34989 9.34989 0 0 1-9.34989-9.34989V554.13684a9.34989 9.34989 0 0 1 9.34989-9.349891 9.256392 9.256392 0 0 1 9.349891 9.349891v49.367421a9.34989 9.34989 0 0 1-9.349891 9.34989z m0 0M186.56148 779.780862a9.34989 9.34989 0 0 1-8.477234-5.485269 9.34989 9.34989 0 0 1 4.674946-12.341855l1.121986-0.498661a9.34989 9.34989 0 0 1 12.341856 4.674945 9.34989 9.34989 0 0 1-4.674945 12.341855l-1.121987 0.498661a11.266618 11.266618 0 0 1-3.864622 0.747991z m0 0" fill="#B2B2B2" ></path></symbol><symbol id="icon-more" viewBox="0 0 1024 1024"><path d="M512 51.2c-253.44 0-460.8 207.36-460.8 460.8s207.36 460.8 460.8 460.8 460.8-207.36 460.8-460.8-207.36-460.8-460.8-460.8z m0 870.4c-225.28 0-409.6-184.32-409.6-409.6s184.32-409.6 409.6-409.6 409.6 184.32 409.6 409.6-184.32 409.6-409.6 409.6z" fill="#212D89" ></path><path d="M512 512m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#212D89" ></path><path d="M307.2 512m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#212D89" ></path><path d="M716.8 512m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z" fill="#212D89" ></path></symbol><symbol id="icon-right" viewBox="0 0 1024 1024"><path d="M767.707 519.451l-459.642-447.973-52.012 50.73200001 407.574 397.21099999-407.542 397.21 51.975 50.733z" fill="#7F8693" ></path></symbol><symbol id="icon-search" viewBox="0 0 1024 1024"><path d="M928.128 890.88l-200.384-206.272a364.8 364.8 0 0 0 101.44-252.032C829.184 229.312 662.144 64 456.768 64S84.352 229.312 84.352 432.576c0 203.2 167.04 368.512 372.48 368.512a372.992 372.992 0 0 0 208.768-63.552l204.096 210.112a40.64 40.64 0 0 0 57.6 0.832 40.704 40.704 0 0 0 0.832-57.6zM165.76 432.64c0-158.336 130.56-287.104 290.944-287.104 160.448 0 291.008 128.768 291.008 287.104s-130.56 287.04-291.008 287.04c-160.448 0-290.944-128.768-290.944-287.04z" fill="#7F8693" ></path></symbol><svg><symbol id="icon-general-1" viewBox="0 0 1024 1024"><path d="M512 626.144m-393.216 0a393.216 393.216 0 1 0 786.432 0 393.216 393.216 0 1 0-786.432 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M888.128 189.568C802.4 77.28 665.856 4.608 512 4.608S221.6 77.312 135.872 189.6c-14.912 19.52-28.224 40.32-39.872 62.08 11.648 21.792 24.96 42.56 39.872 62.112 85.728 112.32 222.272 184.96 376.128 184.96s290.4-72.64 376.128-184.96A460.8 460.8 0 0 0 928 251.68c-11.648-21.76-24.96-42.56-39.872-62.08zM512 444.416A425.024 425.024 0 0 1 154.688 251.68C229.888 135.84 361.76 58.88 512 58.88s282.08 76.896 357.312 192.768A425.024 425.024 0 0 1 512 444.416z" fill="#212D89" ></path><path d="M511.648 249.28l42.432-65.344a78.048 78.048 0 0 0-23.296-9.952c-41.536-10.208-83.616 14.624-93.984 55.424-10.368 40.832 14.88 82.176 56.416 92.352 41.536 10.208 83.616-14.624 93.984-55.424a74.432 74.432 0 0 0-4.736-49.792L511.648 249.28z" fill="#62F6DD" ></path><path d="M618.24 189.12c9.952 17.344 15.744 37.376 15.744 58.752 0 66.176-54.624 119.84-121.984 119.84s-121.984-53.664-121.984-119.84S444.64 128.032 512 128.032c23.68 0 45.664 6.72 64.352 18.176l19.008-39.072A167.104 167.104 0 0 0 512 84.896h-0.064c-91.584 0-165.856 72.992-165.824 163.008 0 90.016 74.272 162.976 165.888 162.944 91.584 0 165.824-72.96 165.856-162.944 0-26.24-6.464-50.944-17.664-72.928l-41.952 14.112z" fill="#212D89" ></path></symbol><symbol id="icon-general-2" viewBox="0 0 1024 1024"><path d="M512 625.024m-389.344 0a389.344 389.344 0 1 0 778.688 0 389.344 389.344 0 1 0-778.688 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M883.104 226.048c-0.256-0.608-0.32-1.216-0.64-1.792v-0.192C805.632 93.504 611.712 17.28 441.056 50.464c-147.648 28.736-260.416 149.568-280.64 300.672v0.512a16.64 16.64 0 0 0 0.768 7.136c0.416 0.8 0.864 1.6 1.376 2.336a18.24 18.24 0 0 0 2.88 4.48c0.16 0.128 0.16 0.32 0.32 0.448 83.36 87.296 207.168 138.784 338.688 140.928 36.256 0 72.32-4.16 107.296-12.224 107.84-24.832 233.824-114.08 272.544-257.536a16.192 16.192 0 0 0 0.224-3.456 17.312 17.312 0 0 0 0.16-2.656 17.28 17.28 0 0 0-1.536-5.056z m-371.52 111.808a101.312 101.312 0 1 1 0-202.624 101.312 101.312 0 0 1 0 202.624z" fill="#62F6DD" ></path><path d="M896.768 242.944a24.128 24.128 0 0 0-1.632-6.272c-0.256-0.736-0.32-1.504-0.64-2.208V234.24C812.8 72.512 606.816-21.856 425.472 19.2 268.608 54.816 148.832 204.48 127.328 391.584v0.64a23.84 23.84 0 0 0 0.832 8.832 24.864 24.864 0 0 0 1.44 2.88c0.768 1.984 1.792 3.84 3.04 5.536 0.192 0.192 0.192 0.416 0.352 0.608a476.992 476.992 0 0 0 359.84 174.496c38.496-0.032 76.8-5.12 113.984-15.168 114.56-30.72 248.416-141.248 289.536-318.912a23.2 23.2 0 0 0 0.256-4.288 24.768 24.768 0 0 0 0.16-3.264z m-302.336 280c-147.2 39.616-300.48-9.6-413.248-131.392a449.344 449.344 0 0 1 326.24-212.16 503.456 503.456 0 0 1 57.28-4.992 95.968 95.968 0 1 1-160.096 81.28c-49.408 20.48-94.4 50.24-132.512 87.744A247.776 247.776 0 0 0 743.296 199.36c37.024 12.192 71.68 30.688 102.4 54.656-40.128 149.76-153.824 242.784-251.264 268.96z" fill="#212D89" ></path></symbol><symbol id="icon-general-3" viewBox="0 0 1024 1024"><path d="M512 626.432m-394.176 0a394.176 394.176 0 1 0 788.352 0 394.176 394.176 0 1 0-788.352 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M426.368 533.056a241.216 241.216 0 0 1-154.24-224.064A240.064 240.064 0 0 1 375.328 112a14.304 14.304 0 0 0 4.736-18.56 14.08 14.08 0 0 0-17.504-7.04 458.336 458.336 0 0 0-257.28 220.256l-1.248 2.368 1.28 2.4a457.696 457.696 0 0 0 316.928 236.32 7.456 7.456 0 0 0 8.768-5.376 7.616 7.616 0 0 0-4.608-9.28zM918.72 306.624a458.304 458.304 0 0 0-257.408-220.32 14.08 14.08 0 0 0-17.504 7.04 14.272 14.272 0 0 0 4.736 18.56 240 240 0 0 1 103.296 197.12 241.184 241.184 0 0 1-154.304 224.032 7.616 7.616 0 0 0-4.608 9.28 7.456 7.456 0 0 0 8.768 5.376 457.664 457.664 0 0 0 317.056-236.32l1.248-2.4-1.28-2.368z" fill="#212D89" ></path><path d="M646.912 182.24L514.624 3.392l-132.288 178.88c-33.856 33.824-54.784 80.608-54.784 132.256s20.928 98.464 54.784 132.32c33.856 33.856 80.64 54.784 132.288 54.784s98.432-20.928 132.288-54.784c33.856-33.856 54.816-80.64 54.816-132.32s-20.96-98.432-54.816-132.288z m-132.288 240.416a105.984 105.984 0 1 1 0-211.968 105.984 105.984 0 0 1 0 211.968z" fill="#2558C7" ></path><path d="M573.504 236.288m-42.88 0a42.88 42.88 0 1 0 85.76 0 42.88 42.88 0 1 0-85.76 0Z" fill="#62F6DD" ></path></symbol><symbol id="icon-general-4" viewBox="0 0 1024 1024"><path d="M512 625.024m-389.344 0a389.344 389.344 0 1 0 778.688 0 389.344 389.344 0 1 0-778.688 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M134.144 315.296a176.416 115.52 90 1 0 231.04 0 176.416 115.52 90 1 0-231.04 0Z" fill="#62F6DD" opacity=".5" ></path><path d="M219.104 315.296a117.152 76.704 90 1 0 153.408 0 117.152 76.704 90 1 0-153.408 0Z" fill="#2558C7" ></path><path d="M351.68 35.712a305.664 305.664 0 0 0 0 559.168 317.056 317.056 0 0 0 167.36-279.584 317.056 317.056 0 0 0-167.36-279.584zM295.776 479.328c-59.328 0-107.424-73.44-107.424-164.032 0-90.56 48.096-164.032 107.424-164.032 59.328 0 107.392 73.44 107.392 164.032 0 90.56-48.064 164.032-107.392 164.032z" fill="#212D89" ></path><path d="M888.384 520.928c-47.136-118.72-78.944-117.312-120.16-118.72A305.664 305.664 0 0 0 406.528 17.472c91.296 67.36 150.528 175.68 150.528 297.824s-59.232 230.464-150.528 297.824a305.568 305.568 0 0 0 340.512-158.208c14.176 24.224 26.464 29.952 21.984 110.144a20.832 20.832 0 0 0 19.616 21.952l1.184 0.032a20.8 20.8 0 0 0 20.8-19.648c4.352-78.4-4.928-88.672-20.992-121.056 31.776 7.584 29.184 12.16 60.032 89.952a20.832 20.832 0 0 0 38.72-15.36z" fill="#212D89" ></path></symbol><symbol id="icon-general-5" viewBox="0 0 1024 1024"><path d="M512 625.792m-392 0a392 392 0 1 0 784 0 392 392 0 1 0-784 0Z" fill="#D2E6FF" opacity=".5" ></path><path d="M646.08 215.04c0-14.88-5.76-28.48-15.136-38.592l-3.168-3.168a56.704 56.704 0 0 0-38.624-15.104c-14.912 0-28.48 5.728-38.624 15.104l-3.136 3.168a56.704 56.704 0 0 0-15.136 38.624c0 14.912 5.76 28.48 15.136 38.624l3.136 3.136c10.144 9.376 23.712 15.136 38.624 15.136 14.912 0 28.48-5.76 38.624-15.136l3.168-3.136c9.376-10.144 15.104-23.712 15.104-38.624zM423.2 280.768a31.04 31.04 0 0 0-8.32-21.12l-1.696-1.76a31.04 31.04 0 0 0-42.304 0l-1.728 1.728a31.04 31.04 0 0 0 0 42.304l1.728 1.728a31.04 31.04 0 0 0 42.304 0l1.728-1.728a31.04 31.04 0 0 0 8.288-21.12z" fill="#62F6DD" ></path><path d="M639.52 269.504a73.888 73.888 0 0 1-50.368 19.744 73.92 73.92 0 0 1-50.336-19.744l-4.096-4.096a73.92 73.92 0 0 1-9.152-88.416 134.176 134.176 0 0 0-101.984 35.296l-7.456 7.456c-4.768 5.12-9.024 10.72-12.928 16.544 7.584 1.92 14.432 5.632 20 10.784l2.56 2.56a45.76 45.76 0 0 1 0 62.304l-2.56 2.56a45.76 45.76 0 0 1-42.08 10.848 134.144 134.144 0 0 0 35.008 77.184l7.456 7.488c24 22.208 56.128 35.776 91.392 35.776s67.392-13.568 91.392-35.776l7.488-7.488a134.144 134.144 0 0 0 28.224-135.552l-2.56 2.56z" fill="#2558C7" ></path><path d="M735.872 104.16l-16.896-16.896A303.808 303.808 0 0 0 512 6.208a303.808 303.808 0 0 0-206.976 81.056l-16.896 16.896A303.808 303.808 0 0 0 207.04 311.136c0 79.904 30.784 152.64 81.088 206.976l16.896 16.928L512 742.016l206.976-207.008 16.896-16.896a303.808 303.808 0 0 0 81.088-206.976 303.808 303.808 0 0 0-81.088-206.976z m-57.216 361.056l-12.576 12.576c-40.48 37.44-94.592 60.352-154.08 60.352s-113.6-22.912-154.08-60.352l-12.576-12.576a226.144 226.144 0 0 1-60.352-154.08c0-59.488 22.912-113.6 60.352-154.08l12.576-12.576C398.4 107.04 452.512 84.16 512 84.16s113.6 22.912 154.08 60.352l12.576 12.576a226.144 226.144 0 0 1 60.352 154.08c0 59.52-22.912 113.6-60.352 154.08z" fill="#212D89" ></path></symbol><symbol id="icon-eye-protection" viewBox="0 0 1024 1024"><path d="M880.832 126.72c-8.768 0.32-17.408 0.416-25.856 0.416-222.112 0-319.936-101.92-320.8-102.784L512 0.032l-22.176 24.32c-0.96 1.088-104.192 110.592-346.656 102.368L112 125.632V587.52c0 120.96 40.256 297.312 389.184 432.256L512 1024l10.816-4.224C871.616 884.8 912 708.48 912 587.52V125.632l-31.168 1.088zM475.2 744l-232.96-206.56 61.92-50.24 123.776 91.456s170.944-177.024 336.064-259.584l23.584 26.624S581.248 516.8 475.2 744z" fill="#ffffff" ></path></symbol><symbol id="icon-cataract1" viewBox="0 0 1024 1024"><path d="M996.096 665.536c-2.944-8.832-2.944-23.52 1.472-44.096 11.744-35.232 17.6-72 17.6-110.176 0-220.384-196.864-374.624-478.944-374.624-129.28 0-246.816 57.28-342.304 113.12C98.432 307.04 0 380.48 0 512.736s96.96 207.136 192.448 262.976c89.6 52.896 210.112 111.68 342.336 111.68 173.344 0 321.728-60.256 405.472-164.576l4.416-5.856 5.856 5.856c8.832 10.304 16.16 29.376 20.576 39.68L1024 712.544c-5.888-8.832-22.048-30.848-27.904-47.04z m-581.088 136.96c-76.32-18.752-144.64-54.912-195.52-84.384-111.2-65.6-156.736-124.544-156.736-204.928 0-80.352 45.536-139.296 156.704-203.584C260.992 285.44 315.904 256 376.192 235.936l32.128-10.72-26.784 20.096c-52.224 37.504-95.104 85.728-136.64 132.608l-28.096 32.128c-17.44 18.752-48.224 52.256-48.224 107.168 0 53.568 29.44 87.04 53.568 108.48a989.376 989.376 0 0 1 54.912 50.88c44.192 41.536 88.416 84.416 141.984 116.544l29.44 17.408-33.472-8z m295.776-16.768c-37.12 15.904-79.52 23.872-121.92 23.872-78.208 0-149.76-26.528-197.44-72.896-50.4-33.12-82.208-75.52-95.456-125.888-3.968-14.592 4-29.184 11.936-45.056 7.936-15.936 15.904-30.496 15.904-49.056 0-21.184-9.28-39.744-18.56-55.68-7.936-14.56-14.56-27.808-14.56-42.368 1.312-45.056 27.84-87.488 75.52-121.92 46.4-50.368 123.264-80.864 206.72-80.864 27.84 0 57.024 4 83.52 10.624 172.288 34.432 279.616 144.448 279.616 287.552 0 124.576-83.52 226.624-225.28 271.68z" fill="#ffffff" ></path><path d="M220.096 369.216c21.6-31.04 75.616-66.144 70.208-74.24-5.408-6.72-56.704 36.48-93.152 51.296-32.416 13.504-47.264 45.92-41.856 52.672 5.408 9.44 44.544-1.376 64.8-29.728z m0 298.368c-20.256-28.352-59.392-37.792-64.8-31.04s9.44 39.136 41.856 52.64c36.448 16.192 87.744 59.392 93.12 51.296 5.44-5.408-48.576-40.512-70.176-72.896z" fill="#ffffff" ></path></symbol><symbol id="icon-more1" viewBox="0 0 1024 1024"><path d="M339.84224 498.624H125.05824A125.216 125.216 0 0 1 0.00224 372.64V158.72a125.216 125.216 0 0 1 125.024-125.024h214.848a125.216 125.216 0 0 1 125.024 125.024v213.888a125.216 125.216 0 0 1-125.024 125.984zM339.84224 1017.92H125.05824A125.216 125.216 0 0 1 0.00224 892V678.08a125.216 125.216 0 0 1 125.024-125.024h214.848a125.216 125.216 0 0 1 125.024 125.024v213.888a125.216 125.216 0 0 1-125.024 125.984zM871.87424 1017.92H657.28224a125.216 125.216 0 0 1-125.024-124.992V678.08a125.216 125.216 0 0 1 125.024-125.024h214.624a125.216 125.216 0 0 1 125.024 125.024v213.888a125.216 125.216 0 0 1-125.024 125.984zM764.57824 525.152a124.064 124.064 0 0 1-88.48-36.544l-134.656-134.624a125.216 125.216 0 0 1 0-176.768l134.656-134.656a125.216 125.216 0 0 1 176.736 0l134.656 134.656a125.216 125.216 0 0 1 0 176.768l-134.656 134.624a124.064 124.064 0 0 1-88.256 36.544z" fill="#ffffff" ></path></symbol><symbol id="icon-laser-surgery" viewBox="0 0 1024 1024"><path d="M513.92 226.24C232.192 226.24 122.56 388.8 0 510.912c122.56 131.072 217.792 282.88 513.92 286.784 281.664 3.712 411.2-175.232 510.08-285.76-102.496-119.552-228.352-285.76-510.08-285.76z m-87.712 288.32l62.88-166.72a12.736 12.736 0 0 1 16.352-7.36l8.992-23.84a12.736 12.736 0 0 1 16.416-7.424l47.616 17.952c6.56 2.496 9.92 9.856 7.392 16.416l-8.96 23.808h0.032a12.736 12.736 0 0 1 7.392 16.416l-5.28 14.016a50.784 50.784 0 0 1-3.424 101.44 50.4 50.4 0 0 1-30.848-10.688l-0.064 0.224a50.72 50.72 0 0 1-18.432-27.904l-0.032-0.16a12.736 12.736 0 1 0-24.64 6.4 75.968 75.968 0 0 0 33.92 45.984l-14.08 37.344a12.736 12.736 0 0 1-16.384 7.424l-71.456-26.944a12.736 12.736 0 0 1-7.392-16.384z m200.32 137.408c5.44 0 10.336 3.52 12.064 8.704l12.736 38.176a12.736 12.736 0 0 1-12.096 16.768h-216.32a12.736 12.736 0 0 1-12.064-16.768l12.704-38.176a12.736 12.736 0 0 1 12.096-8.704h30.08a114.304 114.304 0 0 1-23.232-25.44h-57.76a12.736 12.736 0 0 1 0-25.44h139.968a12.736 12.736 0 0 1 0 25.44H475.2a88.96 88.96 0 0 0 137.312-111.36c7.52-4.16 14.304-9.6 20.032-16.064a114.272 114.272 0 0 1-23.296 152.864h17.28z" fill="#ffffff" ></path></symbol><symbol id="icon-strabismus" viewBox="0 0 1024 1024"><path d="M567.872 10.304c-126.08 0-238.272 60.608-310.4 154.368l-9.28-20.352a28.608 28.608 0 0 0-26.048-16.928H90.752a28.992 28.992 0 0 0-28.736 29.184v520.032a28.896 28.896 0 0 0 28.64 29.152h101.056v77.504c0 50.496 40.416 91.52 90.08 91.52h102.336v136.032l436.896 2.88v-296.832c89.76-76.352 140.992-187.328 140.992-306.56 0-220.64-176.864-400-394.144-400z m0.48 78.304c151.84 0 279.232 107.328 313.216 250.976H520.448c-26.656-65.216-87.168-113.376-159.68-120.64a25.376 25.376 0 0 0-6.912-0.96h-41.6c58.944-78.4 151.68-129.376 256.096-129.376z m198.784 584.896l-9.568 7.584v251.616h-312.896v-128.704h-146.56a35.584 35.584 0 0 1-35.2-35.808v-83.552a27.424 27.424 0 0 0 5.248-11.136l18.752-63.264h66.912c2.4 0 4.8-0.32 7.104-0.96 71.68-7.168 131.616-54.4 158.688-118.528H882.24a326.464 326.464 0 0 1-115.136 182.72z m-233.76-233.408c2.176-16.512 2.272-33.28 0.256-49.824h355.808c0.768 8.544 1.184 17.088 1.28 25.632 0 8.096-0.736 16.128-1.28 24.192H533.376z" fill="#ffffff" ></path></symbol><symbol id="icon-glaucoma1" viewBox="0 0 1024 1024"><path d="M651.776 254.56c-141.888 0-257.44 115.392-257.44 257.44 0 141.888 115.392 257.44 257.44 257.44 141.888 0 257.44-115.552 257.44-257.44s-115.552-257.44-257.44-257.44z m113.92 257.536a69.312 69.312 0 1 1-138.656-0.064 69.312 69.312 0 0 1 138.656 0.064z" fill="#ffffff" ></path><path d="M512 0C229.664 0 0 229.664 0 512s229.664 512 512 512 512-229.664 512-512S794.336 0 512 0z m0 954.816c-70.624 0-137.44-16.672-196.8-46.368l3.328-35.52c0.16-1.92 1.92-3.52 3.84-3.52h58.88a3.84 3.84 0 0 0 3.776-3.808v-93.952c0-3.808-4.768-5.248-6.976-2.24l-28.736 41.12a4.16 4.16 0 0 1-3.168 1.6H287.104a4.16 4.16 0 0 0-2.688 1.12l-46.048 46.496a446.784 446.784 0 0 1-111.552-129.664l45.216-4.48a3.712 3.712 0 0 0 2.72-1.568s59.648-81.28 60.48-82.528c0.928-1.28 0.928-2.368-0.96-1.44-1.92 0.96-57.472 27.168-57.472 27.168-0.64 0.32-1.44 0.448-2.24 0.32l-81.888-13.504A438.528 438.528 0 0 1 69.184 512c0-1.28 0.16-2.56 0.16-3.808l135.872 27.936a19.136 19.136 0 0 0 18.88-6.976l47.456-61.12c2.24-2.88-0.48-6.976-3.968-6.016l-59.36 16.192a18.944 18.944 0 0 1-12.544-0.96L77.76 426.304a442.4 442.4 0 0 1 64.928-158.08l35.392 66.976c0.64 1.28 2.048 2.048 3.488 2.048 0 0 81.408-1.408 83.968-1.408 2.528 0 5.536-2.56 1.28-5.248l-45.44-28.576a3.52 3.52 0 0 1-2.528-2.368l-37.12-82.24a452.224 452.224 0 0 1 79.52-70.112l21.568 51.712c0.64 1.44 1.92 2.24 3.328 2.4l48.896 2.048a19.008 19.008 0 0 1 12.384 5.248l31.264 29.536c2.368 2.208 6.496 0.64 6.496-2.72V196.8a4.16 4.16 0 0 0-2.56-3.648L336 177.28a15.2 15.2 0 0 1-10.336-14.432V110.464a440.192 440.192 0 0 1 186.656-41.44c244.096 0 442.784 198.72 442.784 442.816-0.32 244.256-198.848 442.976-443.104 442.976z" fill="#ffffff" ></path></symbol><symbol id="icon-sugar-net" viewBox="0 0 1024 1024"><path d="M131.552 938.784c-15.296 23.2-18.56 33.984-20.576 49.184a23.2 23.2 0 0 1-25.856 19.84 23.2 23.2 0 0 1-19.84-25.824c7.872-59.008 75.616-143.232 186.88-250.08 33.28-31.84 56.256-55.424 78.4-81.024a23.104 23.104 0 0 1 35.04 30.048c-23.328 27.04-47.264 51.456-81.344 84.224-49.44 47.36-89.984 90.56-119.424 127.552h198.272a1040.448 1040.448 0 0 0-53.504-61.376 23.04 23.04 0 1 1 33.6-31.584c71.104 75.744 113.344 136.288 119.456 182.112a22.88 22.88 0 0 1-19.84 25.856 22.816 22.816 0 0 1-25.888-19.872c-1.792-13.056-8.96-29.568-20.928-49.184H131.552v0.128zM636.864 595.488l148.608 85.92v171.584l-148.608 85.76-148.48-85.76v-171.584zM164.8 131.328c14.976 18.912 32.96 39.488 53.504 61.408a23.136 23.136 0 0 1-0.96 32.544 22.944 22.944 0 0 1-32.544-0.96c-71.04-75.744-113.28-136.32-119.424-182.112a23.04 23.04 0 1 1 45.728-6.112c1.92 13.504 15.296 46.304 17.344 49.664 0.256 0.32 263.616-0.384 264.32-0.384 11.968-19.52 19.136-36 20.8-49.28a23.2 23.2 0 0 1 25.856-19.84c12.704 1.76 21.44 13.248 19.872 25.92-7.904 59.008-75.616 143.232-186.88 250.112-44.16 42.336-79.936 80.64-106.624 115.936h106.496v46.08l-136.544-0.128c-24.896 43.52-32.192 79.68-21.664 115.456h153.536v46.08H139.104c2.4 2.88 4.8 5.856 7.52 8.736 26.816 28.832 48.608 48.96 71.808 64.384 10.528 7.04 13.504 21.408 6.464 31.936a23.104 23.104 0 0 1-31.968 6.464c-26.88-17.952-51.2-40.096-80.16-71.552-59.712-64.512-61.248-140.736-17.472-222.464 30.272-56.448 73.472-105.632 145.28-174.432C289.76 211.392 330.432 168.32 359.744 131.2H164.832v0.096z" fill="#ffffff" ></path><path d="M464.928 296.576l149.216 86.176v172.288l-149.216 86.144-149.216-86.144v-172.288l149.216-86.176z m344.96 0l149.216 86.176v172.288l-149.216 86.144-149.216-86.144v-172.288l149.216-86.176z" fill="#ffffff" ></path></symbol><symbol id="icon-species1" viewBox="0 0 1024 1024"><path d="M926.368 509.504c-35.84 0-68.8 19.616-85.888 51.136l-118.368-11.04a246.304 246.304 0 0 0-245.792-232.384 244.736 244.736 0 0 0-121.536 32.16L266.624 236.8a134.208 134.208 0 1 0-57.504 45.12l88.192 112.512A245.664 245.664 0 0 0 230.08 563.52c0 50.208 15.104 96.864 40.832 135.84l-165.248 148.832A78.656 78.656 0 0 0 0 921.92c0 43.328 35.2 78.496 78.464 78.496a78.528 78.528 0 0 0 76.096-97.792l165.248-148.928a245.216 245.216 0 0 0 156.48 56.16c115.648 0 212.736-79.872 239.136-187.392l116.8 10.88A97.696 97.696 0 0 0 1024 607.04a97.632 97.632 0 0 0-97.632-97.568z m-573.28 160.128a36.224 36.224 0 0 1-17.088 4.256 36.832 36.832 0 0 1-32.256-19.424c-66.592-125.76 2.528-202.368 5.44-205.6 6.048-6.496 13.76-10.24 21.888-11.328a36.48 36.48 0 0 1 32.128 60.576c-2.112 2.496-34.08 42.688 2.112 116.288 0.96 1.984 1.92 3.84 2.976 5.92a36.48 36.48 0 0 1-15.168 49.312z m75.872-225.664z" fill="#ffffff" ></path></symbol><symbol id="icon-species2" viewBox="0 0 1024 1024"><path d="M1024 439.936a32.096 32.096 0 0 0-2.176-8.352c-0.352-0.96-0.416-1.984-0.864-2.912v-0.32c-108.704-215.232-382.816-340.8-624.096-286.08C188.16 189.632 28.736 388.704 0.16 637.696v0.864a31.712 31.712 0 0 0 1.088 11.776c0.544 1.344 1.184 2.624 1.92 3.84a31.04 31.04 0 0 0 4.064 7.36c0.224 0.224 0.256 0.544 0.448 0.768a634.72 634.72 0 0 0 478.816 232.224c51.2-0.032 102.208-6.816 151.68-20.16 152.416-40.896 330.56-187.968 385.28-424.384a30.848 30.848 0 0 0 0.32-5.696 32.96 32.96 0 0 0 0.224-4.352zM621.664 812.48c-195.84 52.736-399.776-12.8-549.888-174.848a597.952 597.952 0 0 1 434.112-282.272c25.28-3.68 50.72-5.92 76.256-6.72a127.68 127.68 0 1 1-213.024 108.192 553.824 553.824 0 0 0-176.352 116.8c71.424 167.488 265.152 245.344 432.64 173.888a329.728 329.728 0 0 0 194.4-365.664c49.28 16.224 95.36 40.832 136.256 72.736-53.44 199.264-204.704 323.072-334.4 357.888z" fill="#ffffff" ></path></symbol><symbol id="icon-species3" viewBox="0 0 1024 1024"><path d="M227.616 316.096a121.216 121.216 0 0 0-121.088 121.12c0 66.752 54.304 121.088 121.088 121.088s121.088-54.336 121.088-121.088a121.216 121.216 0 0 0-121.088-121.12z m-6.08 137.28a23.68 23.68 0 0 1-23.584-23.552c0-12.992 10.56-23.552 23.552-23.584a23.68 23.68 0 0 1 23.584 23.584 23.68 23.68 0 0 1-23.584 23.584z" fill="#ffffff" ></path><path d="M1008 773.312l-1.856-4.128-3.584 1.088c-0.224 0.096-23.616 7.36-73.472-37.28-44.128-39.552-71.072-44.992-99.04-19.744-11.008 4.576-27.68 9.248-45.76 6.112-22.4-3.712-42.816-18.432-60.704-43.712 24.32-50.976 37.12-107.488 37.12-163.648 0-197.984-154.432-364.384-351.712-379.2a20 20 0 0 0-10.88-0.704 364.48 364.48 0 0 0-17.76-0.448C170.624 131.648 0 302.272 0 512c0 209.728 170.624 380.352 380.352 380.352 4.96 0 9.92-0.224 14.816-0.448l2.56-0.128c1.344 0.32 2.848 0.576 4.416 0.576a20.48 20.48 0 0 0 6.24-1.056 379.52 379.52 0 0 0 183.936-63.52l9.28-5.024c31.872 18.72 129.92 64.288 211.008-23.136 10.24-11.008 18.368-20.896 25.568-29.664 10.784-13.152 20.16-24.512 25.696-25.376 2.88-0.448 12.416 1.088 38.912 24.8 71.456 64 110.336 47.264 117.408 43.264l3.808-2.144-16-37.184z m-442.4-5.696l-22.944-77.632a20.864 20.864 0 0 0-26.08-14.176 20.992 20.992 0 0 0-14.208 26.08l26.24 88.672a314.464 314.464 0 0 1-12 6.048l-114.24-37.536a58.368 58.368 0 0 0-0.576-0.192l-0.16-0.064a18.944 18.944 0 0 0-14.56 1.728 22.912 22.912 0 0 0-10.848 14.656c-3.04 12.256 3.392 25.088 14.304 28.704l52.608 17.28c-20.8 4.256-41.888 6.4-62.784 6.4l-3.552-0.096-80.64-57.408a20.576 20.576 0 0 0-15.68-3.616 20.8 20.8 0 0 0-13.6 8.544 20.832 20.832 0 0 0 4.928 29.248l11.008 7.84a313.728 313.728 0 0 1-215.68-261.28 236.928 236.928 0 0 0 219.84 146.752 237.44 237.44 0 0 0 220.608-148.256 21.28 21.28 0 0 0-27.744-27.456 21.024 21.024 0 0 0-11.52 11.456 195.168 195.168 0 0 1-181.376 121.856 196.064 196.064 0 0 1-195.84-195.84 196.064 196.064 0 0 1 195.84-195.84 196.064 196.064 0 0 1 195.84 195.84 21.216 21.216 0 0 0 42.4 0c0-131.36-106.88-238.24-238.24-238.24-11.648 0-23.232 0.864-34.72 2.56a315.008 315.008 0 0 1 128.128-27.2h0.832v6.848a21.024 21.024 0 0 0 41.984 0V199.36a311.488 311.488 0 0 1 112.064 37.76l-9.312 5.12a20.96 20.96 0 0 0 10.048 39.36h0.064c3.52 0 7.008-0.896 10.08-2.56l28.416-15.616a317.216 317.216 0 0 1 57.12 57.92l-24.704 33.92a21.024 21.024 0 0 0 16.96 33.312l0.064 0.032c6.72 0 13.024-3.2 16.928-8.64l15.296-21.056a312.16 312.16 0 0 1 33.12 88.64c0.544 3.52 1.056 7.04 1.504 10.592l-51.04-14.176a21.088 21.088 0 0 0-23.584 30.24c2.624 4.928 7.008 8.576 12.48 10.24l65.12 18.112 0.032 2.176c0 39.104-6.144 77.632-18.272 114.656l-35.68-41.728a20.96 20.96 0 1 0-31.904 27.264l49.568 57.984a317.856 317.856 0 0 1-91.936 104.64z m217.824-1.6c-50.88 54.752-110.08 40.864-144.576 24.96a380.992 380.992 0 0 0 64.32-77.888c20.992 22.24 45.504 35.744 72.928 40.224 5.6 0.928 11.392 1.44 17.216 1.6-3.072 3.552-6.336 7.232-9.92 11.072z" fill="#ffffff" ></path></symbol><symbol id="icon-species4" viewBox="0 0 1024 1024"><path d="M734.4 690.048a210.688 210.688 0 0 1-180.448-119.488 176.864 176.864 0 0 1 30.72-200.448 152.64 152.64 0 0 1 150.944-51.2 214.272 214.272 0 0 1 152.448 137.76 178.08 178.08 0 0 1-2.72 117.984c-26.624 70.496-79.392 112.512-144.768 115.232l-6.144 0.16z m-31.904-277.44a57.696 57.696 0 0 0-43.872 21.888 79.552 79.552 0 0 0-15.552 93.024 112 112 0 0 0 91.36 64.032h2.56c24.928-1.024 44.032-18.24 56.64-51.2a81.792 81.792 0 0 0 0.896-53.12 116.096 116.096 0 0 0-78.88-72.544 59.936 59.936 0 0 0-13.152-1.536v-0.512z" fill="#ffffff" ></path><path d="M358.816 426.464a139.296 139.296 0 0 1-104.128-44.224 106.016 106.016 0 0 1-24.768-105.504c19.968-68.288 98.336-125.312 162.56-141.536a166.624 166.624 0 0 1 102.4 4.288c69.152 27.456 79.392 76.288 79.392 102.4 0 73.28-73.408 141.888-142.4 169.024a198.56 198.56 0 0 1-73.056 15.552z m52.928-214.784c-45.568 11.456-96.128 53.12-106.176 87.264a27.328 27.328 0 0 0 6.656 29.344c27.296 29.024 68.288 18.624 90.976 9.92 52.768-21.024 92.384-68.288 92.384-95.776 0-4.48 0-17.92-29.728-29.728a89.984 89.984 0 0 0-54.08-1.024zM451.2 870.72a211.52 211.52 0 0 1-112.192-34.496c-50.176-34.144-73.6-84.32-62.464-135.04a89.632 89.632 0 0 1 62.304-68.288c57.184-18.784 130.08 8.384 169.696 43.36a136.576 136.576 0 0 1 44.896 71.872c10.08 44.736-2.368 82.816-34.144 104.832a116.96 116.96 0 0 1-67.072 18.624l-1.024-0.864z m-73.088-165.952a48.128 48.128 0 0 0-15.52 2.24 11.936 11.936 0 0 0-9.728 10.24c-5.312 23.552 13.312 41.824 29.696 52.928 35.008 23.552 78.016 25.92 91.168 17.056 5.12-3.584 4.096-13.984 2.24-22.368a63.52 63.52 0 0 0-20.16-30.208 131.808 131.808 0 0 0-77.696-29.696v-0.192z" fill="#ffffff" ></path><path d="M219.2 625.024a49.856 49.856 0 0 1-10.272-0.864 70.688 70.688 0 0 1-53.28-54.624 50.016 50.016 0 0 1 27.68-56.32 57.184 57.184 0 0 1 50.016-1.376 70.688 70.688 0 0 1 40.128 58.56c0.864 12.288-2.88 24.48-10.592 34.144-10.336 13.28-26.208 21.088-43.04 21.152l-0.64-0.672z" fill="#ffffff" ></path><path d="M513.856 1024c-202.336 0-383.808-120.704-470.72-322.848S-11.968 213.76 263.424 64.672A537.792 537.792 0 0 1 673.12 22.56c126.336 39.936 227.232 129.76 291.616 259.328a520.896 520.896 0 0 1 9.728 461.984 500.224 500.224 0 0 1-353.408 268.896c-35.424 7.424-71.52 11.2-107.712 11.264h0.512z m8-945.632c-77.088 0.064-152.96 19.2-220.896 55.648C68.576 260.16 39.904 494.72 115.712 670.08c88.096 204.864 280.512 309.376 489.824 265.472a422.72 422.72 0 0 0 298.56-226.208c58.24-119.488 54.816-263.072-9.376-392.64-54.784-109.792-139.488-185.6-245.664-219.072a422.048 422.048 0 0 0-127.872-19.264h0.672z" fill="#ffffff" ></path></symbol><symbol id="icon-species5" viewBox="0 0 1024 1024"><path d="M70.464 512a166.528 109.056 90 1 0 218.112 0 166.528 109.056 90 1 0-218.112 0Z" fill="#ffffff" ></path><path d="M258.912 114.56C106.432 182.016 0 334.528 0 512s106.432 329.984 258.912 397.44c141.632-76 237.952-225.44 237.952-397.44 0-171.968-96.32-321.44-237.952-397.44z m-79.36 630.624C95.168 745.184 26.816 640.768 26.816 512S95.2 278.816 179.52 278.816c84.352 0 152.704 104.416 152.704 233.184s-68.352 233.184-152.704 233.184z" fill="#ffffff" ></path><path d="M1021.92 804.32c-67.008-168.736-112.224-166.784-170.816-168.736 11.584-39.2 17.92-80.64 17.92-123.584 0-240-194.56-434.528-434.496-434.528-33.6 0-66.24 3.936-97.6 11.136 129.76 95.776 213.984 249.728 213.984 423.392s-84.224 327.616-213.984 423.36c31.36 7.232 64 11.168 97.6 11.168 168.416 0 314.368-95.936 386.496-236.064 20.128 34.432 37.568 42.56 31.2 156.608a29.632 29.632 0 0 0 27.904 31.2l1.664 0.032c15.584 0 28.64-12.16 29.536-27.936 6.24-111.392-6.976-126.08-29.76-172.096 45.12 10.816 41.44 17.312 85.312 127.872a29.632 29.632 0 0 0 55.04-21.824z" fill="#ffffff" ></path></symbol><symbol id="icon-species6" viewBox="0 0 1024 1024"><path d="M791.904 292.64c-29.248 0-57.152 5.6-82.944 15.552 100.544 53.568 169.28 159.36 169.28 281.088 0 59.84-16.928 115.616-45.696 163.456C941.12 733.504 1024 638.848 1024 524.704c0-128-104.192-232.064-232.096-232.064zM240 589.12c0-81.696 31.04-156.032 81.6-212.576a261.12 261.12 0 0 0-59.68-6.976C117.6 369.6 0 486.848 0 631.36s117.568 261.92 261.92 261.92c46.432 0 89.92-12.48 127.776-33.824C299.936 802.752 240 702.944 240 589.12zM96.96 733.184c-36.8 0-66.656-45.568-66.656-101.76s29.824-101.824 66.656-101.824c36.8 0 66.624 45.6 66.624 101.792s-29.824 101.792-66.624 101.792z" fill="#ffffff" ></path><path d="M809.728 752.64a296.64 296.64 0 0 0 48.96-163.36c0-134.08-88.96-247.264-210.752-284.992 0.64-30.88 12.16-118.528 119.52-150.4a27.008 27.008 0 1 0-15.36-51.84c-94.528 28.064-136.224 94.304-151.232 151.52A361.28 361.28 0 0 0 535.168 188.8c-39.04-29.504-82.304-48.576-128.64-56.64-57.408-9.856-119.008-2.496-183.04 22.08a18.144 18.144 0 0 0-10.144 9.984 18.112 18.112 0 0 0 0.032 13.44c0.192 0.448 16.32 40.288 54.464 82.56 26.24 28.864 67.008 62.944 124.288 81.792a298.432 298.432 0 0 0-131.168 247.072c0 164.864 134.176 298.88 298.88 298.88a297.728 297.728 0 0 0 207.168-83.904c6.208 28.16 8.192 65.92-12.672 96.928a14.176 14.176 0 0 0 23.488 15.808c31.84-47.36 22.464-103.616 12.16-137.184 0.736-0.928 1.408-1.92 2.176-2.88 35.392 10.624 91.808 38.816 89.6 110.784a14.176 14.176 0 1 0 28.32 0.864c2.368-77.984-51.936-118.4-100.352-135.744z m-416.608-47.296c-42.016 0-76.064-52-76.064-116.16s34.048-116.128 76.064-116.128 76.032 52 76.032 116.16-34.016 116.16-76.032 116.16z m166.72-414.912a296.96 296.96 0 0 0-121.568 26.08c-55.296-9.28-103.552-36.096-143.456-80.096A300.608 300.608 0 0 1 255.04 180.96c97.056-32 183.84-19.936 258.08 35.936 33.28 25.024 56.96 53.984 71.488 74.784a299.616 299.616 0 0 0-24.8-1.248z" fill="#ffffff" ></path></symbol><symbol id="icon-species7" viewBox="0 0 1024 1024"><path d="M753.56256 483.936h-161.056c-10.24 0.032-19.424 5.76-24 14.976l-16.224 32.512-56.544-113.216a26.848 26.848 0 1 0-48 0.064l-32.832 65.664H270.49056a26.912 26.912 0 0 0-19.072 45.76 26.72 26.72 0 0 0 19.072 7.872h161.088a26.56 26.56 0 0 0 23.936-14.816l16.256-32.512 56.48 112.96a26.592 26.592 0 0 0 35.712 12.32 26.688 26.688 0 0 0 12.32-12.256l32.832-65.696h144.384a28.32 28.32 0 0 0 18.944-7.68 26.912 26.912 0 0 0-18.88-45.952z" fill="#ffffff" ></path><path d="M964.82656 180.288l-0.064-0.064a260.512 260.512 0 0 0-197.248-90.24h-0.64a248.032 248.032 0 0 0-51.904 5.024 267.776 267.776 0 0 0-138.112 76.256L512.02656 236.288l-64.96-64.96A267.712 267.712 0 0 0 308.82656 95.04a321.632 321.632 0 0 0-52.256-5.024A260.64 260.64 0 0 0 59.22656 180.288 251.744 251.744 0 0 0 0.02656 346.08a280.416 280.416 0 0 0 80 198.272l359.904 359.776c19.2 19.264 44.768 29.888 72 29.92h0.064c27.2 0 52.736-10.56 72.128-29.92l360-359.808a280.448 280.448 0 0 0 79.872-198.08 251.392 251.392 0 0 0-59.2-165.952zM494.17056 849.856L134.52256 490.048a206.08 206.08 0 0 1-57.44-144.064 173.6 173.6 0 0 1 40.512-115.104 182.688 182.688 0 0 1 138.88-63.872c12.736 0.736 25.6 1.152 37.856 3.552a191.2 191.2 0 0 1 97.76 55.296l92.096 92.128c14.848 15.04 39.168 15.2 54.624 0l92.256-92.256a191.552 191.552 0 0 1 97.44-55.104c12.384-2.368 24.928-3.552 37.376-3.616h0.608c53.536 0 104.224 23.264 139.072 63.808a174.688 174.688 0 0 1 40.384 115.36 205.984 205.984 0 0 1-56.384 143.84l-359.68 359.84a25.6 25.6 0 0 1-35.712 0z" fill="#ffffff" ></path></symbol><symbol id="icon-species8" viewBox="0 0 1024 1024"><path d="M1004.608 481.696c-99.936-157.024-224.32-352.48-490.528-352.48-242.88 0-358.976 163.84-461.376 308.416A2916.896 2916.896 0 0 1 4.48 504.416L0 510.4l4.288 6.112c14.4 20.608 28.448 41.6 42.464 62.592 102.144 152.928 207.808 311.04 467.136 315.584l8.544 0.096c251.36 0 379.008-195.456 472.48-338.56 8.704-13.376 17.12-26.24 25.344-38.528l3.744-5.6-19.392-30.4z m-67.104 30.176c-5.248 7.68-10.688 15.616-16.256 23.84-81.088 119.168-192.128 282.432-409.376 282.432-192.544 0-292.928-140.704-389.984-276.8l-21.728-30.336a2057.728 2057.728 0 0 0 47.616-65.792c82.816-117.76 168.448-239.456 364.096-239.456 220.224 0 326.016 157.696 411.008 284.384l14.624 21.76z" fill="#ffffff" ></path><path d="M700.736 423.264l-10.784 15.712c-13.376 19.584-36.288 31.264-61.312 31.264h-0.128c-40-0.128-72.448-30.336-72.352-67.392 0.032-22.848 12.448-43.872 33.152-56.32l18.624-11.136-20.448-7.36a222.368 222.368 0 0 0-150.56 0c-54.176 19.52-96.288 58.016-118.56 108.32a185.056 185.056 0 0 0-1.92 146.72c32.128 77.984 111.808 125.952 196.064 125.952a220.48 220.48 0 0 0 74.976-13.12c54.176-19.52 96.288-57.984 118.56-108.32a184.992 184.992 0 0 0 1.92-146.688l-7.232-17.632z" fill="#ffffff" ></path></symbol><symbol id="icon-conjunctivitis" viewBox="0 0 1024 1024"><path d="M985.824 502.592a36.352 36.352 0 0 0 0-40.512c-1.856-2.816-45.952-68.352-117.152-137.984l83.136-83.52c14.08-14.144 14.08-37.184 0-51.36a35.936 35.936 0 0 0-25.536-10.656h-0.096c-9.6 0-18.656 3.744-25.6 10.656L814.624 275.52a694.528 694.528 0 0 0-82.752-58.976l46.88-70.624a36.48 36.48 0 0 0-10.016-50.368 35.936 35.936 0 0 0-50.24 10.112L667.2 182.88c-39.808-17.184-79.776-27.936-119.008-32.032v-84.48a36 36 0 0 0-10.4-25.728 35.936 35.936 0 0 0-25.536-10.784c-9.536 0.064-18.784 3.584-25.696 10.368s-10.72 15.872-10.816 26.08v84.544c-39.2 4.096-79.168 14.848-118.976 32L305.472 105.696a36.16 36.16 0 0 0-50.272-10.112A36.48 36.48 0 0 0 245.12 145.92l46.88 70.624A697.472 697.472 0 0 0 209.28 275.488L123.456 189.216a35.904 35.904 0 0 0-25.536-10.656h-0.096c-9.6 0-18.656 3.744-25.632 10.656a36.48 36.48 0 0 0 0 51.392l83.136 83.52c-71.424 69.792-115.296 135.168-117.152 137.952a36.352 36.352 0 0 0 0 40.512c1.856 2.816 45.76 68.16 117.152 137.984L101.792 694.4a36.512 36.512 0 0 0 0 51.392 36.224 36.224 0 0 0 51.232 0l56.32-56.576a693.024 693.024 0 0 0 84.8 60.224l-21.632 43.52c-4.352 8.64-5.056 18.464-2.016 27.68 3.04 9.184 9.472 16.64 18.144 20.992 8.64 4.32 18.464 5.056 27.648 2.016 9.216-3.04 16.64-9.472 21.024-18.144l21.344-42.88c39.2 16.672 78.56 27.168 117.12 31.2v25.088c-0.096 9.664 3.616 18.816 10.4 25.696 6.784 6.912 15.84 10.752 25.536 10.816H512a36.256 36.256 0 0 0 36.192-36.48v-25.12c38.528-4.032 77.888-14.528 117.12-31.2l21.344 42.88c4.32 8.64 11.776 15.104 20.992 18.144 9.184 3.04 19.008 2.304 27.648-2.016s15.104-11.808 18.144-20.992a35.968 35.968 0 0 0-2.016-27.648l-21.632-43.52a694.56 694.56 0 0 0 84.8-60.256l56.32 56.576c6.816 6.816 15.872 10.624 25.504 10.656 9.824 0.256 18.752-3.68 25.76-10.656 14.08-14.176 14.08-37.216 0-51.392l-53.568-53.76c71.232-69.664 115.296-135.168 117.184-138.016z m-74.816-20.224c-49.92 66.304-212.384 260.768-399.008 260.768-186.336 0-349.024-194.528-399.008-260.8C162.912 416 325.376 221.504 512 221.504c186.336 0 349.024 194.56 399.04 260.832zM646.72 894.176c-91.936 36.16-177.568 36.16-269.568 0.032a36 36 0 0 0-27.808 0.96 36.096 36.096 0 0 0-18.944 20.352 36.608 36.608 0 0 0 20.512 46.496c54.4 21.312 108.576 32.096 161.024 32.096 52.576 0 106.816-10.816 161.152-32.192a36.384 36.384 0 0 0-26.368-67.744z" fill="#ffffff" ></path><path d="M512 267.712c-117.856 0-213.728 96.288-213.728 214.624s95.872 214.656 213.728 214.656 213.76-96.288 213.76-214.656S629.824 267.712 512 267.712z m0 356.544c-77.888 0-141.28-63.68-141.28-141.92 0-78.24 63.36-141.92 141.28-141.92s141.28 63.68 141.28 141.92c0 78.272-63.36 141.92-141.28 141.92z" fill="#ffffff" ></path><path d="M512.544 416.288c-18.112-0.096-34.24 6.72-46.784 19.136s-19.52 28.992-19.584 46.912A66.016 66.016 0 0 0 512 548.416h0.32c36.256 0 65.888-29.44 66.048-65.792a65.632 65.632 0 0 0-19.168-46.784 65.6 65.6 0 0 0-46.624-19.552z" fill="#ffffff" ></path></symbol></svg><symbol id="icon-guide-green" viewBox="0 0 1024 1024"><path d="M710.4 825.6v166.4h-128v-262.4C742.4 704 870.4 576 896 416h128c-19.2 185.6-147.2 345.6-313.6 409.6z m-390.4 0c-172.8-64-294.4-224-320-409.6h128C153.6 576 281.6 704 441.6 729.6v262.4H320v-166.4z" fill="#109B73" ></path><path d="M659.2 32c102.4 0 179.2 70.4 179.2 179.2 0 89.6-76.8 185.6-134.4 236.8-38.4 38.4-102.4 76.8-185.6 121.6-89.6-44.8-153.6-83.2-192-121.6C262.4 390.4 192 300.8 192 211.2 192 102.4 268.8 32 371.2 32 428.8 32 473.6 57.6 512 102.4 556.8 57.6 601.6 32 659.2 32z" fill="#F35A48" ></path></symbol><symbol id="icon-consult" viewBox="0 0 1024 1024"><path d="M313.6 608c-44.8 0-76.8-32-76.8-70.4V300.8H76.8C32 300.8 0 332.8 0 377.6V768c0 44.8 32 76.8 76.8 76.8h32v140.8c0 19.2 19.2 25.6 32 12.8l166.4-153.6h326.4c44.8 0 76.8-32 76.8-76.8V608H313.6z" fill="#109B73" ></path><path d="M947.2 19.2H358.4c-44.8 0-76.8 32-76.8 76.8v390.4c0 44.8 32 76.8 76.8 76.8h358.4l166.4 153.6c12.8 12.8 32 0 32-12.8V563.2h32c44.8 0 76.8-32 76.8-76.8V96c0-38.4-32-76.8-76.8-76.8zM460.8 352c-32 0-57.6-25.6-57.6-57.6s25.6-57.6 57.6-57.6 57.6 25.6 57.6 57.6-25.6 57.6-57.6 57.6z m192 0c-32 0-57.6-25.6-57.6-57.6s25.6-57.6 57.6-57.6 57.6 25.6 57.6 57.6-25.6 57.6-57.6 57.6z m192 0c-32 0-57.6-25.6-57.6-57.6s25.6-57.6 57.6-57.6 57.6 25.6 57.6 57.6-25.6 57.6-57.6 57.6z" fill="#F35A48" ></path></symbol><symbol id="icon-popularization" viewBox="0 0 1026 1024"><path d="M546.42112 217.6l358.4 192-108.8 57.6-249.6 128c-19.2 12.8-38.4 12.8-57.6 0l-262.4-128c-6.4 0-6.4-6.4-12.8-6.4l-76.8-57.6 345.6-185.6c19.2-12.8 44.8-12.8 64 0z" fill="#F35A48" ></path><path d="M1020.02112 326.4c-6.4-19.2-19.2-38.4-38.4-44.8L552.82112 44.8C527.22112 32 501.62112 32 482.42112 44.8L40.82112 281.6c-12.8 6.4-19.2 12.8-32 25.6-19.2 38.4-6.4 89.6 32 108.8l32 12.8v217.6c0 25.6 19.2 44.8 44.8 44.8s44.8-19.2 44.8-44.8V473.6l32 12.8V832l12.8 12.8c102.4 89.6 204.8 134.4 313.6 134.4 102.4 0 211.2-44.8 313.6-134.4l12.8-12.8V492.8l147.2-76.8c12.8-6.4 25.6-19.2 32-32 0-19.2 0-38.4-6.4-57.6z m-89.6 19.2L514.42112 569.6 98.42112 345.6 514.42112 121.6l416 224z m-652.8 192l204.8 108.8c25.6 12.8 51.2 12.8 70.4 0l204.8-108.8v262.4c-83.2 64-160 102.4-236.8 102.4-76.8 0-160-32-236.8-102.4V537.6z" fill="#109B73" ></path></symbol></svg>',
      l = (c = document.getElementsByTagName("script"))[c.length - 1].getAttribute("data-injectcss");if (l && !s.__iconfont__svg__cssinject__) {
    s.__iconfont__svg__cssinject__ = !0;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (c) {
      console && console.log(c);
    }
  }!function (c) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) setTimeout(c, 0);else {
        var l = function l() {
          document.removeEventListener("DOMContentLoaded", l, !1), c();
        };document.addEventListener("DOMContentLoaded", l, !1);
      }
    } else document.attachEvent && (t = c, a = s.document, h = !1, i = function i() {
      h || (h = !0, t());
    }, (_p = function p() {
      try {
        a.documentElement.doScroll("left");
      } catch (c) {
        return void setTimeout(_p, 50);
      }i();
    })(), a.onreadystatechange = function () {
      "complete" == a.readyState && (a.onreadystatechange = null, i());
    });var t, a, h, i, _p;
  }(function () {
    var c, l, t, a, h, i;(c = document.createElement("div")).innerHTML = p, p = null, (l = c.getElementsByTagName("svg")[0]) && (l.setAttribute("aria-hidden", "true"), l.style.position = "absolute", l.style.width = 0, l.style.height = 0, l.style.overflow = "hidden", t = l, (a = document.body).firstChild ? (h = t, (i = a.firstChild).parentNode.insertBefore(h, i)) : a.appendChild(t));
  });
}(window);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-wechat-title/vue-wechat-title.js
var vue_wechat_title = __webpack_require__("YqKu");
var vue_wechat_title_default = /*#__PURE__*/__webpack_require__.n(vue_wechat_title);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/api/index.js

// 配置API接口地址
var root = "https://oiqas.vistel.cn/api";
// 引用axios
var axios = __webpack_require__("mtWM");
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}

// 接口处理函数
function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: root,
    withCredentials: false
  }).then(function (res) {
    if (res.data.status === '200') {
      if (success) {
        success(res.data);
      }
    } else {
      if (failure) {
        failure(res.data);
      } else {
        console.log('error: ' + stringify_default()(res.data));
      }
    }
  }).catch(function (err) {
    if (failure) {
      failure(err);
    } else {
      console.log('【api error】' + err);
    }
  });
}

// 返回在vue模板中的调用接口
/* harmony default export */ var api = ({
  get: function get(url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure);
  },
  post: function post(url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure);
  },
  put: function put(url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure);
  },
  delete: function _delete(url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure);
  }
});

var service = axios.create({
  baseURL: root,
  withCredentials: false
});
function request(params) {
  return service(params);
}
function axiosGet(req) {
  return request({
    method: 'GET',
    url: req.url,
    params: req.data
  });
}
// CONCATENATED MODULE: ./src/utils/constant.js
var iconNames = ['glaucoma', 'ocular-surface', 'cornea', 'cataract', 'oblique-amblyopia', 'fundi-disease', 'orbital-disease', 'eye-traumas', 'shortsightedness', 'plastic', 'general-1', 'general-2', 'general-3', 'general-4', 'general-5'];

var responsiveStyleValue = {
  // 隐藏“猜您想问”时，聊天内容距离底部的padding距离
  HIDDEN_KEYWORDS_PADDING_BOTTOM: 45,
  // 显示“猜您想问”时，聊天内容距离底部的padding距离
  SHOW_KEYWORDS_PADDING_BOTTOM: 80,
  // 显示“您可能想问”时，聊天内容的relative-top距离
  SHOW_QUESTIONS_RELATIVE_TOP: -33

  // 换肤模版iconName
};var iconNamesColor = ['eye-protection', 'cataract1', 'laser-surgery', 'strabismus', 'glaucoma1', 'sugar-net', 'conjunctivitis', 'species1', 'species2', 'species3', 'species4', 'species5', 'species6', 'species7', 'species8'];

// 中山模版
var TEMPLATE_ZHONG_SHAN = 'zhongshan';

// 通用模版
var TEMPLATE_VISTEL = 'vistel';

// 可换颜色模版
var TEMPLATE_COLOR_THEME = 'colortheme';

// 可换颜色+导诊模版
var TEMPLATE_COLOR_THEME_GUIDE = 'colorful-guide';

// 通用+导诊模版
var TEMPLATE_GUIDE = 'guide';

// 河南省立眼科模版（基于可换颜色模版）
var TEMPLATE_LI_YAN_KE = 'liyanke';

// 后台返回的模版映射,后续添加模版需在这里配置
var TEMPLATE_REPLECT = {
  'zhongshan': TEMPLATE_ZHONG_SHAN,
  'vistel': TEMPLATE_VISTEL,
  'colorful-theme': TEMPLATE_COLOR_THEME,
  'colorful-guide': TEMPLATE_COLOR_THEME_GUIDE,
  'guide': TEMPLATE_GUIDE,
  'liyanke': TEMPLATE_LI_YAN_KE

  // 康明眼科医院人工客服链接
};var KMYK_SERVICE_URL = 'https://dvt.zoosnet.net/LR/Chatpre.aspx?id=DVT16479667';

// 再次打开调查问卷的有效期为1天
var REOPEN_QUESTIONNAIRE_EXPIRE_TIME = 1;
// 累计使用时间不能少于15秒
var MIN_USE_TIME = 15000;

// 河南省立眼科医院的调查问卷链接
var HNSRMYY_QUESTIONNAIRE_URL = "https://www.wjx.cn/m/76934079.aspx";
// 河南省立眼科医院的机构ID
var HNSRMYY_ORGANIZATION_UID = "hnsrmyy";
// 干眼门诊的中文名称
var DRY_EYE_CLINIC_CN_NAME = "干眼门诊";
// CONCATENATED MODULE: ./src/store/module/colortheme.js




var colortheme = {
  state: {
    theme: '',
    fontColor: '',
    iconColor: '',
    bannerColorStart: '',
    bannerColorEnd: ''
  },
  mutations: {
    SET_THEME: function SET_THEME(state, theme) {
      state.theme = theme;
    },
    SET_FONT_COLOR: function SET_FONT_COLOR(state, fontColor) {
      state.fontColor = fontColor;
    },
    SET_ICON_COLOR: function SET_ICON_COLOR(state, iconColor) {
      state.iconColor = iconColor;
    },
    SET_BANNER_COLOR_START: function SET_BANNER_COLOR_START(state, bannerColorStart) {
      state.bannerColorStart = bannerColorStart;
    },
    SET_BANNER_COLOR_END: function SET_BANNER_COLOR_END(state, bannerColorEnd) {
      state.bannerColorEnd = bannerColorEnd;
    }
  },
  actions: {
    // 获取主题及颜色
    getTheme: function getTheme(_ref, orgUid) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.theme) {
        return { theme: state.theme };
      }
      if (orgUid === 'zhongshan') {
        return { theme: TEMPLATE_ZHONG_SHAN };
      }
      var url = 'organization/' + orgUid;
      return axiosGet({
        url: url
      }).then(function (res) {
        if (res.data.status === '200') {
          var data = res.data.data || {};
          // 如果没有配置模板，默认为vistel通用模板
          var theme = data.template && TEMPLATE_REPLECT[data.template] || TEMPLATE_VISTEL;
          commit('SET_THEME', theme);
          var color = data.themeColor;
          var themeColor = color && color.length > 3 && JSON.parse(color) || {};
          var banner = themeColor.banner || {};
          if (theme === TEMPLATE_COLOR_THEME || theme === TEMPLATE_COLOR_THEME_GUIDE) {
            commit('SET_FONT_COLOR', themeColor.font || '#1ACC9D');
            commit('SET_ICON_COLOR', themeColor.icon || '#2BD8AA');
            commit('SET_BANNER_COLOR_START', banner.start || '#29E4B2');
            commit('SET_BANNER_COLOR_END', banner.end || '#08C693');
          } else if (theme === TEMPLATE_LI_YAN_KE) {
            commit('SET_FONT_COLOR', themeColor.font || '#109B73');
            commit('SET_ICON_COLOR', themeColor.icon || '#109B73');
            commit('SET_BANNER_COLOR_START', banner.start || '#4CB590');
            commit('SET_BANNER_COLOR_END', banner.end || '#109B73');
          }
          return { theme: theme };
        } else {
          console.log('error: ' + stringify_default()(res.data));
          return { theme: 'error' };
        }
      }).catch(function (err) {
        console.log('err', err);
        return { theme: 'error' };
      });
    }
  }
};

/* harmony default export */ var module_colortheme = (colortheme);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/store/module/zhongshan.js



var zhongshan = {
  state: {
    hasShowQuestionnaire: js_cookie_default.a.get('hasShowQuestionnaire') || false,
    showQuestionnaire: false
  },
  mutations: {
    SET_HAS_SHOW_QUESTIONNAIRE: function SET_HAS_SHOW_QUESTIONNAIRE(state, hasShowQuestionnaire) {
      state.hasShowQuestionnaire = hasShowQuestionnaire;
    },
    SET_SHOW_QUESTIONNAIRE: function SET_SHOW_QUESTIONNAIRE(state, showQuestionnaire) {
      state.showQuestionnaire = showQuestionnaire;
    }
  },
  actions: {
    // 打开调查问卷弹窗
    openQuestionnaireDialog: function openQuestionnaireDialog(_ref) {
      var commit = _ref.commit;

      commit('SET_HAS_SHOW_QUESTIONNAIRE', true);
      commit('SET_SHOW_QUESTIONNAIRE', true);
      // 缓存弹窗flag到cookie，24小时的有效期内不再弹出调查问卷
      js_cookie_default.a.set('hasShowQuestionnaire', true, { expires: REOPEN_QUESTIONNAIRE_EXPIRE_TIME });
    },
    closeQuestionnaireDialog: function closeQuestionnaireDialog(_ref2) {
      var commit = _ref2.commit;

      commit('SET_SHOW_QUESTIONNAIRE', false);
    }
  }
};

/* harmony default export */ var module_zhongshan = (zhongshan);
// CONCATENATED MODULE: ./src/store/getters.js
var getters = {
  theme: function theme(state) {
    return state.colortheme.theme;
  },
  fontColor: function fontColor(state) {
    return state.colortheme.fontColor;
  },
  iconColor: function iconColor(state) {
    return state.colortheme.iconColor;
  },
  bannerColorStart: function bannerColorStart(state) {
    return state.colortheme.bannerColorStart;
  },
  bannerColorEnd: function bannerColorEnd(state) {
    return state.colortheme.bannerColorEnd;
  },
  hasShowQuestionnaire: function hasShowQuestionnaire(state) {
    return state.zhongshan.hasShowQuestionnaire;
  },
  showQuestionnaire: function showQuestionnaire(state) {
    return state.zhongshan.showQuestionnaire;
  }
};

/* harmony default export */ var store_getters = (getters);
// CONCATENATED MODULE: ./src/store/index.js






vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  modules: {
    colortheme: module_colortheme,
    zhongshan: module_zhongshan
  },
  getters: store_getters
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: group_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("qHQD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && Object({"APP_ENV":"production","BASE_API":"https://oiqas.vistel.cn/api","VUE_APP_UA_ID":"UA-157434648-1"}).NODE_ENV === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && Object({"APP_ENV":"production","BASE_API":"https://oiqas.vistel.cn/api","VUE_APP_UA_ID":"UA-157434648-1"}).NODE_ENV === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca2d6776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("7sYg")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("2lnh")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (Object({"APP_ENV":"production","BASE_API":"https://oiqas.vistel.cn/api","VUE_APP_UA_ID":"UA-157434648-1"}).NODE_ENV === 'development') {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (Object({"APP_ENV":"production","BASE_API":"https://oiqas.vistel.cn/api","VUE_APP_UA_ID":"UA-157434648-1"}).NODE_ENV === 'development') {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        width: this.labelWidthComputed || this.$parent.labelWidth || this.labelWidthComputed,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }

      var selection = this.$refs.input.selectionStart;
      var direction = newVal.length - oldVal.length;
      selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
      this.lastDirection = direction;
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6629626","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("d4qF")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("RMDY")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99a60e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("G4+f")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  components_scroller,
  src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_scroller = (scroller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137803b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("c9+y")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// CONCATENATED MODULE: ./src/utils/commonUtil.js

/**
 *  判断是否有可用关键字
 */
function hasTag(keywords, diseaseName) {
  // 如果keywords只包含一个keyword，且该keyword为病种名，则不显示“猜您想问”
  return keywords !== null && keywords.length > 0 && (keywords.length > 1 || keywords[0].name != diseaseName);
}

/**
 *  监控iframe内部点击事件（跨域）
 *  eg: iFrameOnClickHandler.track(document.getElementById("iFrame"), function() { do something... });
 **/
var iFrameOnClickHandler = {
  resolution: 200,
  iframes: [],
  interval: null,
  Iframe: function Iframe() {
    this.element = arguments[0];
    this.cb = arguments[1];
    this.hasTracked = false;
  },
  track: function track(element, cb) {
    this.iframes.push(new this.Iframe(element, cb));
    if (!this.interval) {
      var _this = this;
      this.interval = setInterval(function () {
        _this.checkClick();
      }, this.resolution);
    }
  },
  checkClick: function checkClick() {
    if (document.activeElement) {
      var activeElement = document.activeElement;
      for (var i in this.iframes) {
        if (activeElement === this.iframes[i].element) {
          // current iFrame
          if (this.iframes[i].hasTracked === false) {
            console.log(this.iframes[i]);
            console.log(this.iframes[i].cb);
            this.iframes[i].cb.apply(window, []);
            this.iframes[i].hasTracked = true;
          }
        } else {
          this.iframes[i].hasTracked = false;
        }
      }
    }
  }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/Chat.vue














/* harmony default export */ var Chat = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    InlineLoading: vux_src_components_inline_loading,
    Toast: toast["a" /* default */]
  },
  data: function data() {
    return {
      message: '',
      chattingRecords: [],
      keywords: [],
      questions: [],
      disease: '',
      diseaseId: '',
      questionNone: true,
      top: 0,
      paddingBottom: 115,
      position: 'default',
      showPositionValue: false,
      tips: '',
      title: ''
    };
  },

  methods: {
    backMiniProgram: function backMiniProgram() {
      weixin_js_sdk_default.a.miniProgram.navigateBack();
    },
    alert: function alert(tips) {
      this.position = 'bottom';
      this.showPositionValue = true;
      this.tips = tips;
    },
    send: function send() {
      this.keyword(this.message);
      this.message = '';
    },
    removeSpecialCharacter: function removeSpecialCharacter(key) {
      return key.replace(/\?/g, "").replace(/ /g, "");
    },
    keyword: function keyword(key) {
      var _this = this;

      if (key) {
        var timestamp = new Date().getTime();
        this.chattingRecords.push({ direction: 2, type: 1, content: key, id: timestamp });
        var that = this;
        var url = 'solr/allContent/' + this.removeSpecialCharacter(key) + '/0/5' + '?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';

        this.$http.get(url, null, function (req) {
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          if (req.data && req.data.length > 0) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(req.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                var title = item.title;

                if (title.indexOf(_this.title) < 0 || title.length != that.title.length + 9) {
                  var answer = { direction: 1, type: 1 };
                  answer.title = title;
                  answer.content = item.content_html;
                  that.chattingRecords.push(answer);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            that.chattingRecords.push({ direction: 4, type: 1, title: '', content: '' });
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    question: function question(key) {
      var _this2 = this;

      if (key) {
        var timestamp = new Date().getTime();
        this.chattingRecords.push({ direction: 2, type: 1, content: key, id: timestamp });
        var that = this;
        var url = 'solr/title?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan&key=' + this.removeSpecialCharacter(key);
        this.$http.get(url, null, function (req) {
          if (req.data && req.data.length > 0) {
            document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
            var answer = { direction: 3, type: 1 };
            answer.title = req.data[0].title;
            answer.content = req.data[0].content_html;
            that.chattingRecords.push(answer);
          } else {
            _this2.tags(key, timestamp);
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    tags: function tags(key, timestamp) {
      if (key) {
        var that = this;
        var url = 'solr/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';
        this.$http.get(url, null, function (req) {
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          if (req.data && req.data.length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(req.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                var answer = { direction: 1, type: 1 };
                answer.title = item.title;
                answer.content = item.content_html;
                that.chattingRecords.push(answer);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            that.chattingRecords.push({ direction: 4, type: 1, title: '', content: '' });
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    detail: function detail(title, content) {
      this.chattingRecords.push({ direction: 3, type: 1, title: title, content: content });
    },
    upInput: function upInput() {
      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    downInput: function downInput() {
      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    getParams: function getParams() {
      this.title = this.$route.query.cnName;
      this.$route.meta.title = this.title;
      this.disease = this.$route.query.enName;
      this.diseaseId = this.$route.query.id;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      var url = 'keyword/list?departmentId=' + this.diseaseId;
      this.$http.get(url, null, function (res) {
        _this3.keywords = res.data;
        _this3.paddingBottom = responsiveStyleValue.SHOW_KEYWORDS_PADDING_BOTTOM;
        if (!_this3.showKeyword()) {
          _this3.paddingBottom = responsiveStyleValue.HIDDEN_KEYWORDS_PADDING_BOTTOM;
        }
      }, null);

      var questionUrl = 'question/list?departmentId=' + this.diseaseId;
      this.$http.get(questionUrl, null, function (res) {
        _this3.questions = res.data;
        if (_this3.questions.length > 0) {
          _this3.questionNone = false;
          _this3.top = responsiveStyleValue.SHOW_QUESTIONS_RELATIVE_TOP;
        }
      }, null);
    },
    blurOrFocus: function blurOrFocus() {

      var obj = document.getElementsByTagName('input')[0];
      var docTouchend = function docTouchend(event) {
        if (event.target != obj) {
          setTimeout(function () {
            obj.blur();
            document.removeEventListener('touchend', docTouchend, false);
          }, 100);
        }
      };
      if (obj) {
        obj.addEventListener('touchstart', function () {
          document.addEventListener('touchend', docTouchend, false);
        }, false);
      }
    },
    preventAndStopEvent: function preventAndStopEvent() {

      var that = this;
      var preventAndStop = function preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
        that.send();
      };
      document.querySelector('.input-send').addEventListener('touchend', preventAndStop, false);
    },
    showKeyword: function showKeyword() {
      return hasTag(this.keywords, this.title);
    }
  },
  watch: {
    chattingRecords: function chattingRecords(newQuestion, oldQuestion) {
      this.$nextTick(function () {
        var container = document.querySelector("#chatContainer");
        container.scrollTop = container.scrollHeight;
      });
    },
    $route: 'getParams'
  },
  mounted: function mounted() {

    this.$nextTick(function () {
      var container = document.querySelector("#chatContainer");
      container.scrollTop = container.scrollHeight;
    });
    this.getParams();
    this.blurOrFocus();
    this.preventAndStopEvent();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/Chat.vue














/* harmony default export */ var zhongshan_Chat = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    InlineLoading: vux_src_components_inline_loading,
    Toast: toast["a" /* default */]
  },
  data: function data() {
    return {
      message: '',
      chattingRecords: [],
      keywords: [],
      questions: [],
      disease: '',
      diseaseId: '',
      questionNone: true,
      top: 0,
      paddingBottom: 115,
      position: 'default',
      showPositionValue: false,
      tips: '',
      title: ''
    };
  },

  methods: {
    backMiniProgram: function backMiniProgram() {
      weixin_js_sdk_default.a.miniProgram.navigateBack();
    },
    alert: function alert(tips) {
      this.position = 'bottom';
      this.showPositionValue = true;
      this.tips = tips;
    },
    send: function send() {
      this.keyword(this.message);
      this.message = '';
    },
    removeSpecialCharacter: function removeSpecialCharacter(key) {
      return key.replace(/\?/g, "").replace(/ /g, "");
    },
    keyword: function keyword(key) {
      var _this = this;

      if (key) {
        var timestamp = new Date().getTime();
        this.chattingRecords.push({ direction: 2, type: 1, content: key, id: timestamp });
        var that = this;
        var url = 'solr/allContent/' + this.removeSpecialCharacter(key) + '/0/5' + '?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';

        this.$http.get(url, null, function (req) {
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          if (req.data && req.data.length > 0) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(req.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                var title = item.title;

                if (title.indexOf(_this.title) < 0 || title.length != that.title.length + 9) {
                  var answer = { direction: 1, type: 1 };
                  answer.title = title;
                  answer.content = item.content_html;
                  that.chattingRecords.push(answer);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            that.chattingRecords.push({ direction: 4, type: 1, title: '', content: '' });
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    question: function question(key) {
      var _this2 = this;

      if (key) {
        var timestamp = new Date().getTime();
        this.chattingRecords.push({ direction: 2, type: 1, content: key, id: timestamp });
        var that = this;
        var url = 'solr/title?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan&key=' + this.removeSpecialCharacter(key);
        this.$http.get(url, null, function (req) {
          if (req.data && req.data.length > 0) {
            document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
            var answer = { direction: 3, type: 1 };
            answer.title = req.data[0].title;
            answer.content = req.data[0].content_html;
            that.chattingRecords.push(answer);
          } else {
            _this2.tags(key, timestamp);
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    tags: function tags(key, timestamp) {
      if (key) {
        var that = this;
        var url = 'solr/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=zhongshan';
        this.$http.get(url, null, function (req) {
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          if (req.data && req.data.length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(req.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                var answer = { direction: 1, type: 1 };
                answer.title = item.title;
                answer.content = item.content_html;
                that.chattingRecords.push(answer);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            that.chattingRecords.push({ direction: 4, type: 1, title: '', content: '' });
          }
        }, function (error) {
          console.log(error);
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
        });
      } else {
        console.log("信息不能为空");
      }
    },
    detail: function detail(title, content) {
      this.chattingRecords.push({ direction: 3, type: 1, title: title, content: content });
    },
    upInput: function upInput() {
      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    downInput: function downInput() {
      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    },
    getParams: function getParams() {
      this.title = this.$route.query.cnName;
      this.$route.meta.title = this.title;
      this.disease = this.$route.query.enName;
      this.diseaseId = this.$route.query.id;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;

      var url = 'keyword/list?departmentId=' + this.diseaseId;
      this.$http.get(url, null, function (res) {
        _this3.keywords = res.data;
        _this3.paddingBottom = responsiveStyleValue.SHOW_KEYWORDS_PADDING_BOTTOM;
        if (!_this3.showKeyword()) {
          _this3.paddingBottom = responsiveStyleValue.HIDDEN_KEYWORDS_PADDING_BOTTOM;
        }
      }, null);

      var questionUrl = 'question/list?departmentId=' + this.diseaseId;
      this.$http.get(questionUrl, null, function (res) {
        _this3.questions = res.data;
        if (_this3.questions.length > 0) {
          _this3.questionNone = false;
          _this3.top = responsiveStyleValue.SHOW_QUESTIONS_RELATIVE_TOP;
        }
      }, null);
    },
    blurOrFocus: function blurOrFocus() {

      var obj = document.getElementsByTagName('input')[0];
      var docTouchend = function docTouchend(event) {
        if (event.target != obj) {
          setTimeout(function () {
            obj.blur();
            document.removeEventListener('touchend', docTouchend, false);
          }, 100);
        }
      };
      if (obj) {
        obj.addEventListener('touchstart', function () {
          document.addEventListener('touchend', docTouchend, false);
        }, false);
      }
    },
    preventAndStopEvent: function preventAndStopEvent() {

      var that = this;
      var preventAndStop = function preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
        that.send();
      };
      document.querySelector('.input-send').addEventListener('touchend', preventAndStop, false);
    },
    showKeyword: function showKeyword() {
      return hasTag(this.keywords, this.title);
    }
  },
  watch: {
    chattingRecords: function chattingRecords(newQuestion, oldQuestion) {
      this.$nextTick(function () {
        var container = document.querySelector("#chatContainer");
        container.scrollTop = container.scrollHeight;
      });
    },
    $route: 'getParams'
  },
  mounted: function mounted() {

    this.$nextTick(function () {
      var container = document.querySelector("#chatContainer");
      container.scrollTop = container.scrollHeight;
    });
    this.getParams();
    this.blurOrFocus();
    this.preventAndStopEvent();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b274c91c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhongshan/Chat.vue
var Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat zhongshan",attrs:{"id":"chatContainer"}},[_c('div',{staticClass:"chat-header",class:{questionNone: _vm.questionNone}},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-doctor"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("您好，请用一句话描述您的问题。")])]),_vm._v(" "),(_vm.questions.length > 0)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-content"},[_c('p',{staticClass:"questions-title"},[_vm._v("您可能想问：")]),_vm._v(" "),_vm._l((_vm.questions),function(item,index){return _c('p',{staticClass:"questions-item",on:{"click":function($event){_vm.question(item.question)}}},[_vm._v(_vm._s(item.question))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"},style:({top: _vm.top + 'px', 'padding-bottom': _vm.paddingBottom +'px'})},_vm._l((_vm.chattingRecords),function(record){return _c('div',[(record.direction == 2)?_c('div',{staticClass:"chat-user-question"},[_c('div',{staticStyle:{"align-self":"center","margin-bottom":"3px"},attrs:{"id":record.id + '-loading'}},[_c('inline-loading')],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":record.id + '-fail'}},[_c('svg',{staticClass:"exclamation-mark",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-exclamation-mark"}})])]),_vm._v(" "),_c('div',{staticClass:"chat-user-question-content"},[_vm._v("\n          "+_vm._s(record.content)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]):_vm._e(),_vm._v(" "),(record.direction == 1)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item",on:{"click":function($event){_vm.detail(record.title,record.content)}}},[_c('p',{domProps:{"innerHTML":_vm._s(record.content)}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(record.direction == 4)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-title"},[_vm._v("\n            您的问题有点复杂哦，小AI还没有学习到这个知识，请您点击"),_c('span',{staticStyle:{"color":"#1857E4"},on:{"click":function($event){_vm.backMiniProgram()}}},[_vm._v("人工咨询")]),_vm._v("由在线的医生回答吧!\n          ")])])]):_vm._e(),_vm._v(" "),(record.direction == 3)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[(record.title)?_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}):_vm._e(),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item-detail",domProps:{"innerHTML":_vm._s(record.content)}}):_vm._e()])]):_vm._e()])}),0),_vm._v(" "),_c('div',[_c('div',{staticClass:"chat-bottom"},[(_vm.showKeyword())?_c('div',{staticClass:"guest"},[_c('div',{staticClass:"guest-title"},[_vm._v("猜您想问")]),_vm._v(" "),_c('div',{staticClass:"guest-option"},_vm._l((_vm.keywords),function(item,index){return (item.name != _vm.title)?_c('div',{key:index,staticClass:"guest-btn-item",on:{"click":function($event){_vm.question(item.name)}}},[_c('x-button',{staticClass:"guest-button",attrs:{"mini":"","plain":"","type":"warn"}},[_vm._v(_vm._s(item.name))])],1):_vm._e()}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-input"},[_c('div',{staticClass:"chat-form"},[_c('form',{attrs:{"action":"javascript:return true;"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"},{name:"fixedInput",rawName:"v-fixedInput"}],staticClass:"input",attrs:{"type":"text","placeholder":"请简短描述您的问题"},domProps:{"value":(_vm.message)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.send()},"focus":function($event){_vm.upInput()},"blur":function($event){_vm.downInput()},"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"input-send"},[(!_vm.message)?_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("uWuI")}}):_vm._e(),_vm._v(" "),(_vm.message)?_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("6vqz")}}):_vm._e()])])])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var Chat_staticRenderFns = []
var Chat_esExports = { render: Chat_render, staticRenderFns: Chat_staticRenderFns }
/* harmony default export */ var views_zhongshan_Chat = (Chat_esExports);
// CONCATENATED MODULE: ./src/views/zhongshan/Chat.vue
function Chat_injectStyle (ssrContext) {
  __webpack_require__("Rc8k")
}
var Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chat___vue_template_functional__ = false
/* styles */
var Chat___vue_styles__ = Chat_injectStyle
/* scopeId */
var Chat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chat___vue_module_identifier__ = null
var Chat_Component = Chat_normalizeComponent(
  zhongshan_Chat,
  views_zhongshan_Chat,
  Chat___vue_template_functional__,
  Chat___vue_styles__,
  Chat___vue_scopeId__,
  Chat___vue_module_identifier__
)

/* harmony default export */ var src_views_zhongshan_Chat = (Chat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var flexbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var flexbox_staticRenderFns = []
var flexbox_esExports = { render: flexbox_render, staticRenderFns: flexbox_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (flexbox_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function flexbox_injectStyle (ssrContext) {
  __webpack_require__("cqo/")
}
var flexbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox___vue_template_functional__ = false
/* styles */
var flexbox___vue_styles__ = flexbox_injectStyle
/* scopeId */
var flexbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox___vue_module_identifier__ = null
var flexbox_Component = flexbox_normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  flexbox___vue_template_functional__,
  flexbox___vue_styles__,
  flexbox___vue_scopeId__,
  flexbox___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = (flexbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var flexbox_item_staticRenderFns = []
var flexbox_item_esExports = { render: flexbox_item_render, staticRenderFns: flexbox_item_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (flexbox_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox_item___vue_template_functional__ = false
/* styles */
var flexbox_item___vue_styles__ = null
/* scopeId */
var flexbox_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox_item___vue_module_identifier__ = null
var flexbox_item_Component = flexbox_item_normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  flexbox_item___vue_template_functional__,
  flexbox_item___vue_styles__,
  flexbox_item___vue_scopeId__,
  flexbox_item___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = (flexbox_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("3iZP")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideService.vue




/* harmony default export */ var GuideService = ({
  name: 'GuideService',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideService.vue




/* harmony default export */ var components_GuideService = ({
  name: 'GuideService',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item
  },
  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81938596","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideService.vue
var GuideService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-service"},[_c('div',{staticClass:"guide-service-title"},[_vm._v("了解挂号科室，您可能需要")]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',[_c('div',{staticClass:"guide-service-box",on:{"click":function($event){_vm.guide()}}},[_c('svg',{staticStyle:{"width":"30px","height":"30px"},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide"}})]),_vm._v(" "),_c('span',[_vm._v("导诊服务")])])])],1)],1)}
var GuideService_staticRenderFns = []
var GuideService_esExports = { render: GuideService_render, staticRenderFns: GuideService_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_GuideService = (GuideService_esExports);
// CONCATENATED MODULE: ./src/components/GuideService.vue
function GuideService_injectStyle (ssrContext) {
  __webpack_require__("d9PG")
}
var GuideService_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GuideService___vue_template_functional__ = false
/* styles */
var GuideService___vue_styles__ = GuideService_injectStyle
/* scopeId */
var GuideService___vue_scopeId__ = "data-v-81938596"
/* moduleIdentifier (server only) */
var GuideService___vue_module_identifier__ = null
var GuideService_Component = GuideService_normalizeComponent(
  components_GuideService,
  selectortype_template_index_0_src_components_GuideService,
  GuideService___vue_template_functional__,
  GuideService___vue_styles__,
  GuideService___vue_scopeId__,
  GuideService___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideService = (GuideService_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/Home.vue









/* harmony default export */ var Home = ({
  name: 'Home',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      diseaseCategory: [],
      position: 'default',
      showPositionValue: false,
      tips: '',
      showLoading: false,
      content: '',
      iconNames: iconNames
    };
  },

  methods: {
    alert: function alert(tips) {
      this.position = 'bottom';
      this.showPositionValue = true;
      this.tips = tips;
    },
    loading: function loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    chat: function chat(cnName, enName, id) {
      this.$router.push({ path: '/zhongshan/chat/zhongshan', query: { cnName: cnName, enName: enName, id: id } });
    },
    initPage: function initPage() {
      var _this = this;

      this.$route.meta.title = '中山眼科智能问答';
      this.loading(true, '');
      var url = 'department/all/zhongshan';
      this.$http.get(url, null, function (res) {
        _this.diseaseCategory = res.data;
        _this.loading(false, '');
      }, function (error) {
        console.log(error);
        _this.loading(false, '');
        _this.alert('连接不上服务器，请检查网络');
      });
    }
  },
  mounted: function mounted() {
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/Home.vue









/* harmony default export */ var zhongshan_Home = ({
  name: 'Home',
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      diseaseCategory: [],
      position: 'default',
      showPositionValue: false,
      tips: '',
      showLoading: false,
      content: '',
      iconNames: iconNames
    };
  },

  methods: {
    alert: function alert(tips) {
      this.position = 'bottom';
      this.showPositionValue = true;
      this.tips = tips;
    },
    loading: function loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    chat: function chat(cnName, enName, id) {
      this.$router.push({ path: '/zhongshan/chat/zhongshan', query: { cnName: cnName, enName: enName, id: id } });
    },
    initPage: function initPage() {
      var _this = this;

      this.$route.meta.title = '中山眼科智能问答';
      this.loading(true, '');
      var url = 'department/all/zhongshan';
      this.$http.get(url, null, function (res) {
        _this.diseaseCategory = res.data;
        _this.loading(false, '');
      }, function (error) {
        console.log(error);
        _this.loading(false, '');
        _this.alert('连接不上服务器，请检查网络');
      });
    }
  },
  mounted: function mounted() {
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5678d1c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhongshan/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"home"},[_vm._m(0),_vm._v(" "),_c('guide-service'),_vm._v(" "),_c('div',{staticClass:"department"},[_c('div',{staticClass:"department-title"},[_vm._v("术后咨询服务")]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((_vm.diseaseCategory),function(item,index){return (index < 15)?_c('flexbox-item',{key:index,attrs:{"span":1/3}},[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.chat(item.cnName, item.enName, item.id)}}},[_c('div',{staticClass:"department-icon"},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.iconNames[index]}})])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.cnName))])])]):_vm._e()}),1)],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"greeting"},[_vm._v("Hi，您好")]),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("智能问诊，不惧疫情！小AI很高兴为您服务")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"powered-by"},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("WzKy")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title"},[_vm._v("Powered by 致远慧图")])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var views_zhongshan_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/views/zhongshan/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("QOUr")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-5678d1c6"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  zhongshan_Home,
  views_zhongshan_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_views_zhongshan_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/views/mixins/guide/SymptomMixin.js



/* harmony default export */ var SymptomMixin = ({
  data: function data() {
    return {
      departmentList: [],
      source: '',
      orgUid: null
    };
  },

  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    initPage: function initPage() {
      this.$route.meta.title = '导诊服务';
      this.getGuideJsonData();
    },
    detail: function detail(parent, departments) {
      localStorage.setItem("parent", parent);
      localStorage.setItem("departments", stringify_default()(departments));
      this.$router.push({ path: '/' + this.template + '/detail/' + this.orgUid, query: { departments: departments, parent: parent, source: this.source } });
    },
    getGuideJsonData: function getGuideJsonData() {
      var _this = this;

      console.log('获取导诊数据');
      var href = window.location.href;
      var host = window.location.origin;
      console.log(href);
      console.log(host);
      // 河南省人民医院定制导诊内容
      var jsonFile = this.orgUid === 'hnsrmyy' ? 'hnsrmyy-guide.json' : 'general-guide.json';
      axiosGet({
        url: host + '/json/' + jsonFile
      }).then(function (res) {
        console.log(res.data);
        _this.departmentList = res.data;
      }).catch(function (err) {
        console.log('err', err);
      });
    }
  },
  mounted: function mounted() {
    this.source = this.$route.query.source;
    this.orgUid = this.$route.params.orgUid;
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Symptom.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Symptom = ({
  name: 'Symptom',
  mixins: [SymptomMixin]
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Symptom.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var vistel_Symptom = ({
  name: 'Symptom',
  mixins: [SymptomMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1b39a9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/vistel/Symptom.vue
var Symptom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("请选择与您的情况最相符的一项")])]),_vm._v(" "),_c('div',{staticClass:"box"},_vm._l((_vm.departmentList),function(department){return _c('div',{staticClass:"answer",on:{"click":function($event){_vm.detail(department.describe, department.children)}}},[_vm._v(_vm._s(department.describe))])}),0)])}
var Symptom_staticRenderFns = []
var Symptom_esExports = { render: Symptom_render, staticRenderFns: Symptom_staticRenderFns }
/* harmony default export */ var guide_vistel_Symptom = (Symptom_esExports);
// CONCATENATED MODULE: ./src/views/guide/vistel/Symptom.vue
function Symptom_injectStyle (ssrContext) {
  __webpack_require__("77Gz")
}
var Symptom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Symptom___vue_template_functional__ = false
/* styles */
var Symptom___vue_styles__ = Symptom_injectStyle
/* scopeId */
var Symptom___vue_scopeId__ = "data-v-d1b39a9a"
/* moduleIdentifier (server only) */
var Symptom___vue_module_identifier__ = null
var Symptom_Component = Symptom_normalizeComponent(
  vistel_Symptom,
  guide_vistel_Symptom,
  Symptom___vue_template_functional__,
  Symptom___vue_styles__,
  Symptom___vue_scopeId__,
  Symptom___vue_module_identifier__
)

/* harmony default export */ var views_guide_vistel_Symptom = (Symptom_Component.exports);

// CONCATENATED MODULE: ./src/views/mixins/guide/SymptomDetailMixin.js
/* harmony default export */ var SymptomDetailMixin = ({
  name: 'SymptomDetail',
  data: function data() {
    return {
      departments: [],
      parent: '',
      source: ''
    };
  },

  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    initPage: function initPage() {
      this.departments = JSON.parse(localStorage.getItem("departments"));
      this.parent = localStorage.getItem("parent");
    },
    showDepartment: function showDepartment(departmentInfo) {
      var orgUid = this.$route.params.orgUid;
      this.$router.push({
        path: '/' + this.template + '/department/' + orgUid,
        query: { department: departmentInfo.department, source: this.source, address: departmentInfo.address }
      });
    }
  },
  mounted: function mounted() {
    this.source = this.$route.query.source;
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Detail = ({
  name: 'SymptomDetail',
  mixins: [SymptomDetailMixin]
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var vistel_Detail = ({
  name: 'SymptomDetail',
  mixins: [SymptomDetailMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d7e6f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/vistel/Detail.vue
var Detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("请选择与您的情况最相符的一项")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.parent))]),_vm._v(" "),_vm._l((_vm.departments),function(item){return _c('div',{staticClass:"item",on:{"click":function($event){_vm.showDepartment(item)}}},[_vm._v(_vm._s(item.describe))])})],2)])])}
var Detail_staticRenderFns = []
var Detail_esExports = { render: Detail_render, staticRenderFns: Detail_staticRenderFns }
/* harmony default export */ var guide_vistel_Detail = (Detail_esExports);
// CONCATENATED MODULE: ./src/views/guide/vistel/Detail.vue
function Detail_injectStyle (ssrContext) {
  __webpack_require__("bZsH")
}
var Detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Detail___vue_template_functional__ = false
/* styles */
var Detail___vue_styles__ = Detail_injectStyle
/* scopeId */
var Detail___vue_scopeId__ = "data-v-59d7e6f6"
/* moduleIdentifier (server only) */
var Detail___vue_module_identifier__ = null
var Detail_Component = Detail_normalizeComponent(
  vistel_Detail,
  guide_vistel_Detail,
  Detail___vue_template_functional__,
  Detail___vue_styles__,
  Detail___vue_scopeId__,
  Detail___vue_module_identifier__
)

/* harmony default export */ var views_guide_vistel_Detail = (Detail_Component.exports);

// CONCATENATED MODULE: ./src/views/mixins/guide/DepartmentMixin.js


/* harmony default export */ var DepartmentMixin = ({
  name: 'Department',
  data: function data() {
    return {
      department: '',
      source: '',
      address: '',
      orgUid: '',
      isShowQrCode: false,
      isShowQuestionnaire: false
    };
  },

  methods: {
    initPage: function initPage() {
      this.department = this.$route.query.department;
      this.address = this.$route.query.address;
    },
    goBack: function goBack() {
      this.$router.push({ path: this.source });
    },
    goQuestionnaire: function goQuestionnaire() {
      // 河南省立眼科医院的调查问卷
      window.location.href = HNSRMYY_QUESTIONNAIRE_URL;
    }
  },
  mounted: function mounted() {
    this.source = this.$route.query.source;
    this.orgUid = this.$route.params.orgUid;
    // 为河南省立眼科医院时，显示公众号二维码
    this.isShowQrCode = this.orgUid === HNSRMYY_ORGANIZATION_UID;
    this.initPage();
    // 当为河南省立眼科医院且当前科室为“干眼门诊”时，显示调查问卷
    this.isShowQuestionnaire = this.orgUid === HNSRMYY_ORGANIZATION_UID && this.department === DRY_EYE_CLINIC_CN_NAME;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Department.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Department = ({
  name: 'Department',
  mixins: [DepartmentMixin]
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/vistel/Department.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var vistel_Department = ({
  name: 'Department',
  mixins: [DepartmentMixin]
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20db97d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/vistel/Department.vue
var Department_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header"},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("推荐您前往以下科室挂号")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_vm._v(_vm._s(_vm.department))]),_vm._v(" "),_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.goBack()}}},[_c('svg',{staticStyle:{"width":"19px","height":"19px"},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-go-back"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","color":"rgba(255,173,51,1)","margin-left":"10px"}},[_vm._v("返回首页")])])])])}
var Department_staticRenderFns = []
var Department_esExports = { render: Department_render, staticRenderFns: Department_staticRenderFns }
/* harmony default export */ var guide_vistel_Department = (Department_esExports);
// CONCATENATED MODULE: ./src/views/guide/vistel/Department.vue
function Department_injectStyle (ssrContext) {
  __webpack_require__("iiI+")
}
var Department_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Department___vue_template_functional__ = false
/* styles */
var Department___vue_styles__ = Department_injectStyle
/* scopeId */
var Department___vue_scopeId__ = "data-v-20db97d6"
/* moduleIdentifier (server only) */
var Department___vue_module_identifier__ = null
var Department_Component = Department_normalizeComponent(
  vistel_Department,
  guide_vistel_Department,
  Department___vue_template_functional__,
  Department___vue_styles__,
  Department___vue_scopeId__,
  Department___vue_module_identifier__
)

/* harmony default export */ var views_guide_vistel_Department = (Department_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/components/Questionnaire.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Questionnaire = ({
  name: 'Questionnaire',
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['closeQuestionnaireDialog']), {
    setBodyPosition: function setBodyPosition() {
      // 防止滑动弹窗时父页面也被拉动
      var iframe = document.querySelector('#iFrame');
      if (iframe.attachEvent) {
        // 处理兼容行问题 - IE
        iframe.attachEvent('onload', function () {
          document.body.style.position = 'fixed';
        });
      } else {
        iframe.onload = function () {
          document.body.style.position = 'fixed';
        };
      }
    }
  }),
  mounted: function mounted() {
    this.setBodyPosition();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/components/Questionnaire.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_Questionnaire = ({
  name: 'Questionnaire',
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['closeQuestionnaireDialog']), {
    setBodyPosition: function setBodyPosition() {
      // 防止滑动弹窗时父页面也被拉动
      var iframe = document.querySelector('#iFrame');
      if (iframe.attachEvent) {
        // 处理兼容行问题 - IE
        iframe.attachEvent('onload', function () {
          document.body.style.position = 'fixed';
        });
      } else {
        iframe.onload = function () {
          document.body.style.position = 'fixed';
        };
      }
    }
  }),
  mounted: function mounted() {
    this.setBodyPosition();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3210e56f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhongshan/components/Questionnaire.vue
var Questionnaire_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"close-btn",on:{"click":function($event){_vm.closeQuestionnaireDialog()}}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-outline close-icon",attrs:{"type":"ios-close-outline","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"}},[_c('path',{staticClass:"st0",attrs:{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z"}})])])])}
var Questionnaire_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"scroll-wrapper"},[_c('iframe',{staticClass:"content-iFrame",attrs:{"id":"iFrame","src":"https://wj.qq.com/s2/5527396/b3dd/","frameborder":"0"}})])])}]
var Questionnaire_esExports = { render: Questionnaire_render, staticRenderFns: Questionnaire_staticRenderFns }
/* harmony default export */ var zhongshan_components_Questionnaire = (Questionnaire_esExports);
// CONCATENATED MODULE: ./src/views/zhongshan/components/Questionnaire.vue
function Questionnaire_injectStyle (ssrContext) {
  __webpack_require__("9Z+l")
}
var Questionnaire_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Questionnaire___vue_template_functional__ = false
/* styles */
var Questionnaire___vue_styles__ = Questionnaire_injectStyle
/* scopeId */
var Questionnaire___vue_scopeId__ = "data-v-3210e56f"
/* moduleIdentifier (server only) */
var Questionnaire___vue_module_identifier__ = null
var Questionnaire_Component = Questionnaire_normalizeComponent(
  components_Questionnaire,
  zhongshan_components_Questionnaire,
  Questionnaire___vue_template_functional__,
  Questionnaire___vue_styles__,
  Questionnaire___vue_scopeId__,
  Questionnaire___vue_module_identifier__
)

/* harmony default export */ var views_zhongshan_components_Questionnaire = (Questionnaire_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/index.vue

//
//
//
//
//
//





/* harmony default export */ var views_zhongshan = ({
  name: 'Layout',
  components: {
    Questionnaire: views_zhongshan_components_Questionnaire
  },
  data: function data() {
    return {
      timeout: null
    };
  },

  methods: extends_default()({
    useTimer: function useTimer() {
      // 用户有点击使用后开始统计使用时间，超过15秒后就弹出调查问卷
      // 已经弹出过调查问卷窗口，24h则不再弹出
      if (this.timeout === null && !this.hasShowQuestionnaire) {
        // TODO：关闭调查问卷，与小程序不兼容
        this.timeout = setTimeout(this.openQuestionnaireDialog, MIN_USE_TIME);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['openQuestionnaireDialog'])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['hasShowQuestionnaire', 'showQuestionnaire']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/zhongshan/index.vue

//
//
//
//
//
//





/* harmony default export */ var selectortype_script_index_0_src_views_zhongshan = ({
  name: 'Layout',
  components: {
    Questionnaire: views_zhongshan_components_Questionnaire
  },
  data: function data() {
    return {
      timeout: null
    };
  },

  methods: extends_default()({
    useTimer: function useTimer() {
      // 用户有点击使用后开始统计使用时间，超过15秒后就弹出调查问卷
      // 已经弹出过调查问卷窗口，24h则不再弹出
      if (this.timeout === null && !this.hasShowQuestionnaire) {
        // TODO：关闭调查问卷，与小程序不兼容
        this.timeout = setTimeout(this.openQuestionnaireDialog, MIN_USE_TIME);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['openQuestionnaireDialog'])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['hasShowQuestionnaire', 'showQuestionnaire']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bf5540","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhongshan/index.vue
var zhongshan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},on:{"click":function($event){_vm.useTimer()}}},[_c('router-view'),_vm._v(" "),(_vm.showQuestionnaire)?_c('questionnaire'):_vm._e()],1)}
var zhongshan_staticRenderFns = []
var zhongshan_esExports = { render: zhongshan_render, staticRenderFns: zhongshan_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_zhongshan = (zhongshan_esExports);
// CONCATENATED MODULE: ./src/views/zhongshan/index.vue
var zhongshan_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var zhongshan___vue_template_functional__ = false
/* styles */
var zhongshan___vue_styles__ = null
/* scopeId */
var zhongshan___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var zhongshan___vue_module_identifier__ = null
var zhongshan_Component = zhongshan_normalizeComponent(
  selectortype_script_index_0_src_views_zhongshan,
  selectortype_template_index_0_src_views_zhongshan,
  zhongshan___vue_template_functional__,
  zhongshan___vue_styles__,
  zhongshan___vue_scopeId__,
  zhongshan___vue_module_identifier__
)

/* harmony default export */ var src_views_zhongshan = (zhongshan_Component.exports);

// CONCATENATED MODULE: ./src/router/modules/zhongshan.js








// 中山眼科定制专用，这里zhongshan为中山眼科机构ID
var zhongShanRoutes = [{
  path: '/' + TEMPLATE_ZHONG_SHAN,
  component: src_views_zhongshan,
  children: [{
    path: 'chat/:orgUid',
    component: src_views_zhongshan_Chat
  }, {
    path: ':orgUid',
    component: src_views_zhongshan_Home,
    meta: {
      template: TEMPLATE_ZHONG_SHAN
    }
  }, {
    path: 'symptom/:orgUid',
    component: views_guide_vistel_Symptom,
    meta: {
      template: TEMPLATE_ZHONG_SHAN
    }
  }, {
    path: 'detail/:orgUid',
    component: views_guide_vistel_Detail,
    meta: {
      template: TEMPLATE_ZHONG_SHAN
    }
  }, {
    path: 'department/:orgUid',
    component: views_guide_vistel_Department,
    meta: {
      template: TEMPLATE_ZHONG_SHAN
    }
  }]
}];
/* harmony default export */ var modules_zhongshan = (zhongShanRoutes);
// CONCATENATED MODULE: ./src/views/mixins/HomeMixin.js
/* harmony default export */ var HomeMixin = ({
  data: function data() {
    return {
      diseaseCategory: [],
      position: 'default',
      showPositionValue: false,
      tips: '',
      showLoading: false,
      content: '',
      orgUid: '',
      orgInfo: {},
      poweredByStyle: {
        position: 'absolute'
      }
    };
  },

  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    alert: function alert(tips) {
      this.position = 'bottom'; //显示位置，可选值 default, top, middle, bottom
      this.showPositionValue = true;
      this.tips = tips;
    },
    loading: function loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    chat: function chat(cnName, enName, id) {
      this.$router.push({ path: '/' + this.template + '/chat/' + this.orgUid, query: { cnName: cnName, enName: enName, id: id } });
    },
    getOrganization: function getOrganization() {
      var _this = this;

      var url = 'organization/' + this.orgUid;
      this.$http.get(url, null, function (res) {
        _this.orgInfo = res.data;
        _this.$route.meta.title = _this.orgInfo.name + '智能问答';
        var entId = Number(_this.orgInfo.entId);
        if (!window._MEIQIA && entId > 0) {
          var scriptNode = document.createElement('script');
          scriptNode.innerHTML = '(function(m,ei,q,i,a,j,s){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};j=ei.createElement(q),s=ei.getElementsByTagName(q)[0];j.async=true;j.charset=\'UTF-8\';j.src=\'https://static.meiqia.com/dist/meiqia.js?_=t\';s.parentNode.insertBefore(j,s);})(window,document,\'script\',\'_MEIQIA\');_MEIQIA(\'entId\', ' + entId + ')';
          var header = document.querySelector("head");
          header.appendChild(scriptNode);
        }
      }, function () {
        _this.alert('连接不上服务器，请检查网络');
      });
    },
    getAllShowDisease: function getAllShowDisease() {
      var _this2 = this;

      this.loading(true, '');
      var url = 'department/all/' + this.orgUid + '?show=1';
      this.$http.get(url, null, function (res) {
        _this2.diseaseCategory = res.data;
        _this2.loading(false, '');
        _this2.$nextTick(function () {
          var clientHeight = document.documentElement.clientHeight;
          var contentHeight = _this2.$refs.mainRef.offsetHeight;
          if (clientHeight - contentHeight < 109) {
            _this2.poweredByStyle.position = 'relative';
          }
        });
      }, function (error) {
        console.log(error);
        _this2.loading(false, '');
        _this2.alert('连接不上服务器，请检查网络');
      });
    },
    initPage: function initPage() {
      this.orgUid = this.$route.params.orgUid;
      this.getOrganization();
      this.getAllShowDisease();
    },
    more: function more() {
      this.$router.push({ path: '/' + this.template + '/search/' + this.orgUid });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/HomeVistel.vue












/* harmony default export */ var HomeVistel = ({
  name: 'HomeVistel',
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNames,
      isShowGuideService: false
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme'])),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/HomeVistel.vue












/* harmony default export */ var vistel_HomeVistel = ({
  name: 'HomeVistel',
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNames,
      isShowGuideService: false
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme'])),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f789e24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vistel/HomeVistel.vue
var HomeVistel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"home"},[_c('div',{ref:"mainRef",staticClass:"main"},[_vm._m(0),_vm._v(" "),(_vm.isShowGuideService)?_c('guide-service'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"department"},[_c('div',{staticClass:"department-title"},[_vm._v("请选择您想咨询的病种：")]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},[_vm._l((_vm.diseaseCategory),function(item,index){return (index < 15)?_c('flexbox-item',{key:index,attrs:{"span":1/3}},[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.chat(item.cnName, item.enName, item.id)}}},[_c('div',{staticClass:"department-icon"},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.iconNames[index]}})])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.cnName))])])]):_vm._e()}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/3}},[_c('div',{staticClass:"department-item",on:{"click":_vm.more}},[_c('div',{staticClass:"department-icon"},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-more'}})])]),_vm._v(" "),_c('p',[_vm._v("更多病种")])])])],2)],1)],1),_vm._v(" "),(_vm.orgInfo.id)?[(!['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("WzKy")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title"},[_vm._v("Powered by 致远慧图")])]):(['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("/Qki")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title",staticStyle:{"color":"#155caa"}},[_vm._v("Powered by 览视医疗")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],2)}
var HomeVistel_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"greeting"},[_vm._v("Hi，您好")]),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("智能问答小慧很高兴为您服务")])])}]
var HomeVistel_esExports = { render: HomeVistel_render, staticRenderFns: HomeVistel_staticRenderFns }
/* harmony default export */ var views_vistel_HomeVistel = (HomeVistel_esExports);
// CONCATENATED MODULE: ./src/views/vistel/HomeVistel.vue
function HomeVistel_injectStyle (ssrContext) {
  __webpack_require__("wAJW")
}
var HomeVistel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HomeVistel___vue_template_functional__ = false
/* styles */
var HomeVistel___vue_styles__ = HomeVistel_injectStyle
/* scopeId */
var HomeVistel___vue_scopeId__ = "data-v-2f789e24"
/* moduleIdentifier (server only) */
var HomeVistel___vue_module_identifier__ = null
var HomeVistel_Component = HomeVistel_normalizeComponent(
  vistel_HomeVistel,
  views_vistel_HomeVistel,
  HomeVistel___vue_template_functional__,
  HomeVistel___vue_styles__,
  HomeVistel___vue_scopeId__,
  HomeVistel___vue_module_identifier__
)

/* harmony default export */ var src_views_vistel_HomeVistel = (HomeVistel_Component.exports);

// CONCATENATED MODULE: ./src/views/mixins/ChatMixin.js




/* harmony default export */ var ChatMixin = ({
  data: function data() {
    return {
      message: '',
      chattingRecords: [],
      keywords: [],
      questions: [],
      disease: '',
      diseaseId: '',
      questionShow: true,
      top: 0,
      paddingBottom: 115,
      showLoading: false,
      content: '',
      position: 'default',
      showPositionValue: false,
      tips: '',
      orgUid: '',
      title: '',
      questionKeyWord: ''
    };
  },

  methods: {
    send: function send() {
      if (this.message) {
        var timestamp = new Date().getTime();
        this.addMessage(2, "", this.message, timestamp);
        this.keyword(this.message, timestamp);
        this.message = '';
      }
    },
    removeSpecialCharacter: function removeSpecialCharacter(key) {
      return key.replace(/\?/g, "").replace(/ /g, "");
    },
    keyword: function keyword(key, timestamp) {
      if (key) {
        var that = this;
        var url = 'solr/allContent/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=' + this.orgUid;
        this.sendRequest(url, timestamp, function (req) {
          document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
          if (req.data && req.data.length > 0) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(req.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                that.addMessage(1, item.title, item.content_html, null);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            that.addMessage(1, "这个问题我回答不上来，您可以使用其他关键字来咨询噢", "", null);
          }
        });
      }
    },
    question: function question(key) {
      var _this = this;

      if (key) {
        var timestamp = new Date().getTime();
        this.addMessage(2, "", key, timestamp);
        var that = this;
        var url = 'solr/title?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=' + this.orgUid + '&key=' + this.removeSpecialCharacter(key);
        this.sendRequest(url, timestamp, function (req) {
          if (req.data && req.data.length > 0) {
            document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
            that.addMessage(3, req.data[0].title, req.data[0].content_html, null);
          } else {
            _this.tags(key, timestamp);
          }
        });
      }
    },
    tags: function tags(key, timestamp) {
      if (key) {
        var that = this;
        var url = 'solr/' + this.removeSpecialCharacter(key) + '/0/5?category=' + this.disease + '&departmentId=' + this.diseaseId + '&orgUid=' + this.orgUid;
        this.sendRequest(url, timestamp, function (req) {
          if (req.data && req.data.length > 0) {
            document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(req.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                that.addMessage(1, item.title, item.content_html, null);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            that.keyword(key, timestamp);
          }
        });
      }
    },
    sendRequest: function sendRequest(url, timestamp, successCallback) {
      this.$http.get(url, null, function (req) {
        successCallback(req);
      }, function (error) {
        console.log(error);
        document.getElementById(timestamp + '-loading').style.cssText = 'display:none';
        document.getElementById(timestamp + '-fail').style.cssText = 'display: flex;padding-right: 5px';
      });
    },
    addMessage: function addMessage(type, title, content, id) {
      // filter the full answer
      // such as：title='<h2>弱视</h2>' (answer's title), this.title='弱视' (department's title), 9 means length of '<h2></h2>'
      if (title.indexOf(this.title) < 0 || title.length != this.title.length + 9) {
        this.chattingRecords.push({ type: type, title: title, content: content, id: id });
      }
    },
    getParams: function getParams() {
      var _this2 = this;

      this.orgUid = this.$route.params.orgUid;
      this.disease = this.$route.query.enName;
      this.diseaseId = this.$route.query.id;
      this.questionKeyWord = this.$route.query.keyword;
      if (!this.diseaseId) {
        //报告H5那边仅传英文名，没有传id和中文名
        var url = 'department/' + this.disease + '/' + this.orgUid;
        this.$http.get(url, null, function (res) {
          _this2.diseaseId = res.data.id;
          _this2.title = res.data.cnName;
          _this2.$route.meta.title = _this2.title;
          _this2.getData();
        }, function (error) {});
      } else {
        this.title = this.$route.query.cnName;
        this.$route.meta.title = this.title;
        this.getData();
      }
      // 兼容H5报告解读时返回到报告详情页
      if (this.$route.query.redirect) {
        this.$router.go(-1);
      }
    },
    getData: function getData() {
      var _this3 = this;

      this.loading(true, '');
      //获取猜你想问关键字
      var url = 'keyword/list?departmentId=' + this.diseaseId;
      this.$http.get(url, null, function (res) {
        _this3.keywords = res.data;
        _this3.getQuestion();
        //如果有传问题关键字，则自动搜索答案
        if (_this3.questionKeyWord) {
          _this3.question(_this3.questionKeyWord);
        }
      }, function (error) {
        _this3.loading(false, '');
      });
    },
    getQuestion: function getQuestion() {
      var _this4 = this;

      //获取猜您想问问题
      var questionUrl = 'question/list?departmentId=' + this.diseaseId;
      this.$http.get(questionUrl, null, function (res) {
        _this4.loading(false, '');
        _this4.questions = res.data;
        if (_this4.questions.length > 0) {
          _this4.questionShow = false;
          _this4.resetChatContentBoxStyle();
        }
      }, function (error) {
        _this4.loading(false, '');
      });
    },
    resetChatContentBoxStyle: function resetChatContentBoxStyle() {
      this.top = responsiveStyleValue.SHOW_QUESTIONS_RELATIVE_TOP;
      //设置聊天内容box的padding-bottom
      this.paddingBottom = responsiveStyleValue.SHOW_KEYWORDS_PADDING_BOTTOM;
      if (!this.showKeyword()) {
        this.paddingBottom = responsiveStyleValue.HIDDEN_KEYWORDS_PADDING_BOTTOM;
      }
    },
    blurOrFocus: function blurOrFocus() {
      //点击Input输入框外面的区域弹出的键盘隐藏
      var obj = document.getElementsByTagName('input')[0];
      var docTouchend = function docTouchend(event) {
        if (event.target != obj) {
          setTimeout(function () {
            obj.blur();
            document.removeEventListener('touchend', docTouchend, false);
          }, 100);
        }
      };
      if (obj) {
        obj.addEventListener('touchstart', function () {
          document.addEventListener('touchend', docTouchend, false);
        }, false);
      }
    },
    preventAndStopEvent: function preventAndStopEvent() {
      //当点击发送图标时，阻止时间冒泡，防止input失去焦点
      var that = this;
      var preventAndStop = function preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
        that.send();
      };
      document.querySelector('.input-send').addEventListener('touchend', preventAndStop, false);
    },
    loading: function loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    showKeyword: function showKeyword() {
      return hasTag(this.keywords, this.title);
    }
  },
  watch: {
    chattingRecords: function chattingRecords(newQuestion, oldQuestion) {
      this.$nextTick(function () {
        var container = document.querySelector("#chatContainer");
        container.scrollTop = container.scrollHeight;
      });
    },

    $route: 'getParams'
  },
  mounted: function mounted() {
    //页面一加载就滚动到页面底部
    this.$nextTick(function () {
      var container = document.querySelector("#chatContainer");
      container.scrollTop = container.scrollHeight;
    });
    this.getParams();
    this.blurOrFocus();
    this.preventAndStopEvent();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/ChatVistel.vue












/* harmony default export */ var ChatVistel = ({
  mixins: [ChatMixin],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    Loading: vux_src_components_loading,
    Toast: toast["a" /* default */],
    InlineLoading: vux_src_components_inline_loading
  },
  methods: {
    adjustInputPosition: function adjustInputPosition() {

      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/ChatVistel.vue












/* harmony default export */ var vistel_ChatVistel = ({
  mixins: [ChatMixin],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    Loading: vux_src_components_loading,
    Toast: toast["a" /* default */],
    InlineLoading: vux_src_components_inline_loading
  },
  methods: {
    adjustInputPosition: function adjustInputPosition() {

      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b44c2528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vistel/ChatVistel.vue
var ChatVistel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat vistel",attrs:{"id":"chatContainer"}},[_c('div',{staticClass:"chat-header",class:{questionShow: _vm.questionShow}},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-doctor"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("您好，请用一句话描述您的问题。")])]),_vm._v(" "),(_vm.questions.length > 0)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-content"},[_c('p',{staticClass:"questions-title"},[_vm._v("您可能想问：")]),_vm._v(" "),_vm._l((_vm.questions),function(item,index){return _c('p',{staticClass:"questions-item",on:{"click":function($event){_vm.question(item.question)}}},[_vm._v(_vm._s(item.question))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"},style:({top: _vm.top + 'px', 'padding-bottom': _vm.paddingBottom +'px'})},_vm._l((_vm.chattingRecords),function(record){return _c('div',[(record.type == 2)?_c('div',{staticClass:"chat-user-question"},[_c('div',{staticStyle:{"align-self":"center","margin-bottom":"3px"},attrs:{"id":record.id + '-loading'}},[_c('inline-loading')],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":record.id + '-fail'}},[_c('svg',{staticClass:"exclamation-mark",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-exclamation-mark"}})])]),_vm._v(" "),_c('div',{staticClass:"chat-user-question-content"},[_vm._v("\n          "+_vm._s(record.content)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]):_vm._e(),_vm._v(" "),(record.type == 1)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item",on:{"click":function($event){_vm.addMessage(3, record.title, record.content)}}},[_c('p',{domProps:{"innerHTML":_vm._s(record.content)}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(record.type == 3)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[(record.title)?_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}):_vm._e(),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item-detail",class:{adjustPadding: record.title == null},domProps:{"innerHTML":_vm._s(record.content)}}):_vm._e()])]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"hidden","width":"100%"}},[_c('div',{staticClass:"chat-bottom"},[(_vm.showKeyword())?_c('div',{staticClass:"guest"},[_c('div',{staticClass:"guest-title"},[_vm._v("猜您想问")]),_vm._v(" "),_c('div',{staticClass:"guest-option"},_vm._l((_vm.keywords),function(item,index){return (item.name != _vm.title)?_c('div',{key:index,staticClass:"guest-btn-item",on:{"click":function($event){_vm.question(item.name)}}},[_c('x-button',{staticClass:"guest-button",attrs:{"mini":"","plain":"","type":"warn"}},[_vm._v(_vm._s(item.name))])],1):_vm._e()}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-input"},[_c('div',{staticClass:"chat-form"},[_c('form',{attrs:{"action":"javascript:return true;"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"},{name:"fixedInput",rawName:"v-fixedInput"}],staticClass:"input",attrs:{"type":"text","placeholder":"请简短描述您的问题"},domProps:{"value":(_vm.message)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.send()},"focus":function($event){_vm.adjustInputPosition()},"blur":function($event){_vm.adjustInputPosition()},"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"input-send"},[(!_vm.message)?_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("uWuI")}}):_vm._e(),_vm._v(" "),(_vm.message)?_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("6vqz")}}):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"back",on:{"click":function($event){_vm.$router.back(-1)}}},[_c('div',[_vm._v("返回")])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],1)}
var ChatVistel_staticRenderFns = []
var ChatVistel_esExports = { render: ChatVistel_render, staticRenderFns: ChatVistel_staticRenderFns }
/* harmony default export */ var views_vistel_ChatVistel = (ChatVistel_esExports);
// CONCATENATED MODULE: ./src/views/vistel/ChatVistel.vue
function ChatVistel_injectStyle (ssrContext) {
  __webpack_require__("iPO7")
}
var ChatVistel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatVistel___vue_template_functional__ = false
/* styles */
var ChatVistel___vue_styles__ = ChatVistel_injectStyle
/* scopeId */
var ChatVistel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatVistel___vue_module_identifier__ = null
var ChatVistel_Component = ChatVistel_normalizeComponent(
  vistel_ChatVistel,
  views_vistel_ChatVistel,
  ChatVistel___vue_template_functional__,
  ChatVistel___vue_styles__,
  ChatVistel___vue_scopeId__,
  ChatVistel___vue_module_identifier__
)

/* harmony default export */ var src_views_vistel_ChatVistel = (ChatVistel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9205242a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();_vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){_vm.onComposition($event, 'start')},"compositionend":function($event){_vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){_vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){_vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("Ngll")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./src/views/mixins/SearchMixin.js
/* harmony default export */ var SearchMixin = ({
  data: function data() {
    return {
      results: [],
      value: '',
      allDiseases: [],
      searchDisease: [],
      showResult: false,
      tips: '空空如也~',
      showLoading: false,
      content: '',
      orgUid: '',
      orgInfo: {}
    };
  },

  computed: {
    template: function template() {
      return this.$route.meta.template;
    }
  },
  methods: {
    getResult: function getResult(val) {
      var _this = this;

      console.log('on-change', val);
      if (val) {
        var url = 'disease/search/' + this.value + '/0/30?orgUid=' + this.orgUid;
        this.$http.get(url, null, function (res) {
          console.log(res);
          _this.searchDisease = res.data;
        }, function (error) {
          console.log(error);
        });
      } else {
        this.searchDisease = [];
        this.tips = '空空如也~';
      }
    },
    onSubmit: function onSubmit() {
      this.$refs.search.setBlur();
      if (this.searchDisease.length === 0) {
        this.tips = '检索不到相关的内容...';
      }
    },
    onFocus: function onFocus() {
      this.showResult = true;
      this.tips = '空空如也~';
      setTimeout(function () {
        document.body.scrollTop = 0;
      }, 50);
    },
    onCancel: function onCancel() {
      this.showResult = false;
    },
    getAllDisease: function getAllDisease() {
      var _this2 = this;

      this.loading(true, '');
      var url = 'department/all/' + this.orgUid;
      this.$http.get(url, null, function (res) {
        _this2.loading(false, '');
        console.log(res);
        _this2.allDiseases = res.data;
      }, function (error) {
        _this2.loading(false, '');
        console.log(error);
      });
    },
    chat: function chat(cnName, enName, id) {
      console.log(cnName);
      this.$router.push({ path: '/' + this.template + '/chat/' + this.orgUid, query: { cnName: cnName, enName: enName, id: id } });
    },
    loading: function loading(show, content) {
      this.showLoading = show;
      this.content = content;
    },
    getOrganization: function getOrganization() {
      var _this3 = this;

      var url = 'organization/' + this.orgUid;
      this.$http.get(url, null, function (res) {
        console.log(res);
        _this3.orgInfo = res.data;
        _this3.$route.meta.title = _this3.orgInfo.name + '智能问答';
      }, function () {
        _this3.alert('连接不上服务器，请检查网络');
      });
    }
  },
  mounted: function mounted() {
    this.orgUid = this.$route.params.orgUid;
    this.getOrganization();
    this.getAllDisease();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/Search.vue








/* harmony default export */ var Search = ({
  mixins: [SearchMixin],
  components: {
    Search: vux_src_components_search,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Loading: vux_src_components_loading
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/vistel/Search.vue








/* harmony default export */ var vistel_Search = ({
  mixins: [SearchMixin],
  components: {
    Search: vux_src_components_search,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Loading: vux_src_components_loading
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41626f65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vistel/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"search vistel"},[_c('div',{staticClass:"search-header"},[_c('div',{staticClass:"search-header-welcome"},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-doctor"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome-search"},[_vm._v("请选择您想咨询的病种")])]),_vm._v(" "),_c('search',{ref:"search",attrs:{"results":_vm.results,"position":"absolute","auto-scroll-to-top":"","top":"78px"},on:{"on-change":_vm.getResult,"on-focus":_vm.onFocus,"on-cancel":_vm.onCancel,"on-submit":_vm.onSubmit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),(_vm.showResult)?_c('div',{staticClass:"search-result"},[_c('div',{staticClass:"search-result-title"},[_vm._v("\n      # 搜索结果\n    ")]),_vm._v(" "),(_vm.searchDisease.length > 0)?_c('div',_vm._l((_vm.searchDisease),function(item,index){return _c('cell',{key:index,attrs:{"title":item.cn_name,"link":{path: ("/" + _vm.template + "/chat/" + _vm.orgUid), query: {cnName: item.cn_name, enName: item.en_name, id: item.id}}}})}),1):_c('div',[_c('svg',{staticClass:"icon-none",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-none"}})]),_vm._v(" "),_c('div',{staticClass:"search-result-none-tips"},[_vm._v(_vm._s(_vm.tips))])])]):_c('div',{staticClass:"search-all-disease"},[_c('div',{staticClass:"search-all-disease-title"},[_vm._v("\n      # 全部病种\n    ")]),_vm._v(" "),_c('div',_vm._l((_vm.allDiseases),function(item,index){return _c('cell',{key:index,attrs:{"title":item.cnName,"link":{path: ("/" + _vm.template + "/chat/" + _vm.orgUid), query: {cnName: item.cnName, enName: item.enName, id: item.id}}}})}),1)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],1)}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var views_vistel_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/views/vistel/Search.vue
function Search_injectStyle (ssrContext) {
  __webpack_require__("kmEy")
}
var Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = Search_injectStyle
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  vistel_Search,
  views_vistel_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var src_views_vistel_Search = (Search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManualCustomerService.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ManualCustomerService = ({
  name: 'Service',
  props: ['serviceUrl'],
  methods: {
    openLink: function openLink() {
      window.location.href = this.serviceUrl;
    }
  },
  watch: {
    serviceUrl: function serviceUrl(newVal) {
      this.serviceUrl = newVal;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ManualCustomerService.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_ManualCustomerService = ({
  name: 'Service',
  props: ['serviceUrl'],
  methods: {
    openLink: function openLink() {
      window.location.href = this.serviceUrl;
    }
  },
  watch: {
    serviceUrl: function serviceUrl(newVal) {
      this.serviceUrl = newVal;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32c06b86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManualCustomerService.vue
var ManualCustomerService_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service",on:{"click":_vm.openLink}},[_vm._m(0)])}
var ManualCustomerService_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-box"},[_c('div',{staticClass:"service-bg"},[_c('span',{staticClass:"service-icon",attrs:{"width":"32px","height":"32px"}})])])}]
var ManualCustomerService_esExports = { render: ManualCustomerService_render, staticRenderFns: ManualCustomerService_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_ManualCustomerService = (ManualCustomerService_esExports);
// CONCATENATED MODULE: ./src/components/ManualCustomerService.vue
function ManualCustomerService_injectStyle (ssrContext) {
  __webpack_require__("r8kD")
}
var ManualCustomerService_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ManualCustomerService___vue_template_functional__ = false
/* styles */
var ManualCustomerService___vue_styles__ = ManualCustomerService_injectStyle
/* scopeId */
var ManualCustomerService___vue_scopeId__ = "data-v-32c06b86"
/* moduleIdentifier (server only) */
var ManualCustomerService___vue_module_identifier__ = null
var ManualCustomerService_Component = ManualCustomerService_normalizeComponent(
  components_ManualCustomerService,
  selectortype_template_index_0_src_components_ManualCustomerService,
  ManualCustomerService___vue_template_functional__,
  ManualCustomerService___vue_styles__,
  ManualCustomerService___vue_scopeId__,
  ManualCustomerService___vue_module_identifier__
)

/* harmony default export */ var src_components_ManualCustomerService = (ManualCustomerService_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/index.vue
//
//
//
//
//
//
//




/* harmony default export */ var layout = ({
  name: 'Layout',
  components: {
    ManualCustomerService: src_components_ManualCustomerService
  },
  data: function data() {
    return {
      orgUid: '',
      showService: false,
      serviceUrl: ''
    };
  },

  mounted: function mounted() {
    this.orgUid = this.$route.params.orgUid;
    // 康明眼科医院 - 定制人工客服
    if (this.orgUid === 'kmyk') {
      this.showService = true;
      this.serviceUrl = KMYK_SERVICE_URL;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/index.vue
//
//
//
//
//
//
//




/* harmony default export */ var selectortype_script_index_0_src_layout = ({
  name: 'Layout',
  components: {
    ManualCustomerService: src_components_ManualCustomerService
  },
  data: function data() {
    return {
      orgUid: '',
      showService: false,
      serviceUrl: ''
    };
  },

  mounted: function mounted() {
    this.orgUid = this.$route.params.orgUid;
    // 康明眼科医院 - 定制人工客服
    if (this.orgUid === 'kmyk') {
      this.showService = true;
      this.serviceUrl = KMYK_SERVICE_URL;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96ce551c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
var layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('router-view'),_vm._v(" "),(_vm.showService)?_c('manual-customer-service',{attrs:{"service-url":_vm.serviceUrl}}):_vm._e()],1)}
var layout_staticRenderFns = []
var layout_esExports = { render: layout_render, staticRenderFns: layout_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_layout = (layout_esExports);
// CONCATENATED MODULE: ./src/layout/index.vue
var layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var layout___vue_template_functional__ = false
/* styles */
var layout___vue_styles__ = null
/* scopeId */
var layout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var layout___vue_module_identifier__ = null
var layout_Component = layout_normalizeComponent(
  selectortype_script_index_0_src_layout,
  selectortype_template_index_0_src_layout,
  layout___vue_template_functional__,
  layout___vue_styles__,
  layout___vue_scopeId__,
  layout___vue_module_identifier__
)

/* harmony default export */ var src_layout = (layout_Component.exports);

// CONCATENATED MODULE: ./src/router/modules/vistel.js









// 医院通用模版
var vistelDefaultRoutes = [{
  path: '/' + TEMPLATE_VISTEL,
  component: src_layout,
  children: [{
    path: ':orgUid',
    component: src_views_vistel_HomeVistel,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }, {
    path: 'chat/:orgUid',
    component: src_views_vistel_ChatVistel,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }, {
    path: 'search/:orgUid',
    component: src_views_vistel_Search,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }, {
    path: 'symptom/:orgUid',
    component: views_guide_vistel_Symptom,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }, {
    path: 'detail/:orgUid',
    component: views_guide_vistel_Detail,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }, {
    path: 'department/:orgUid',
    component: views_guide_vistel_Department,
    meta: {
      template: TEMPLATE_VISTEL
    }
  }]
}];
/* harmony default export */ var vistel = (vistelDefaultRoutes);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Home.vue












/* harmony default export */ var colortheme_Home = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_COLOR_THEME_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Home.vue












/* harmony default export */ var views_colortheme_Home = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_COLOR_THEME_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdca5a4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/colortheme/Home.vue
var colortheme_Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"home"},[_c('div',{ref:"mainRef",staticClass:"main"},[_c('div',{staticClass:"header",style:({background: ("linear-gradient(to right," + _vm.bannerColorStart + ", " + _vm.bannerColorEnd + ")") })},[_c('div',{staticClass:"greeting"},[_vm._v("Hi，您好")]),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("智能问答小慧很高兴为您服务")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),(_vm.isShowGuideService)?_c('div',{staticClass:"department",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"department-title"},[_vm._v("了解挂号科室，您可能需要")]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"orient":"vertical"}},[_c('flexbox-item',[_c('div',{staticClass:"department-item",staticStyle:{"text-align":"center","display":"flex","justify-content":"center","padding":"20px","margin-bottom":"0px"},on:{"click":function($event){_vm.guide()}}},[_c('svg',{staticStyle:{"width":"30px","height":"30px"},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"20px","color":"#020325","margin-left":"10px"}},[_vm._v("导诊服务")])])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"department"},[_c('div',{staticClass:"department-title"},[_vm._v("请选择您想咨询的内容：")]),_vm._v(" "),_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},[_vm._l((_vm.diseaseCategory),function(item,index){return (index < 15)?_c('flexbox-item',{key:index,attrs:{"span":1/2}},[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.chat(item.cnName, item.enName, item.id)}}},[_c('div',{staticClass:"department-icon",style:({background: _vm.iconColor})},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.iconNames[index]}})])]),_vm._v(" "),_c('div',{staticClass:"department-content"},[_c('p',[_vm._v(_vm._s(item.cnName))]),_vm._v(" "),_c('p',[_c('span',[_vm._v("点击询问")]),_vm._v(" "),_c('span',{staticClass:"x-icon"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"12","xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])])])])]):_vm._e()}),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1/2}},[_c('div',{staticClass:"department-item",on:{"click":_vm.more}},[_c('div',{staticClass:"department-icon",style:({background: _vm.iconColor})},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-more1'}})])]),_vm._v(" "),_c('div',{staticClass:"department-content"},[_c('p',[_vm._v("更多病种")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("点击询问")]),_vm._v(" "),_c('span',{staticClass:"x-icon"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"12","xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])])])])])],2)],1)]),_vm._v(" "),(_vm.orgInfo.id)?[(!['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("WzKy")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title"},[_vm._v("Powered by 致远慧图")])]):(['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("/Qki")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title",staticStyle:{"color":"#155caa"}},[_vm._v("Powered by 览视医疗")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],2)}
var colortheme_Home_staticRenderFns = []
var colortheme_Home_esExports = { render: colortheme_Home_render, staticRenderFns: colortheme_Home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_colortheme_Home = (colortheme_Home_esExports);
// CONCATENATED MODULE: ./src/views/colortheme/Home.vue
function colortheme_Home_injectStyle (ssrContext) {
  __webpack_require__("5Aig")
}
var colortheme_Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Home___vue_template_functional__ = false
/* styles */
var colortheme_Home___vue_styles__ = colortheme_Home_injectStyle
/* scopeId */
var colortheme_Home___vue_scopeId__ = "data-v-cdca5a4a"
/* moduleIdentifier (server only) */
var colortheme_Home___vue_module_identifier__ = null
var colortheme_Home_Component = colortheme_Home_normalizeComponent(
  views_colortheme_Home,
  selectortype_template_index_0_src_views_colortheme_Home,
  colortheme_Home___vue_template_functional__,
  colortheme_Home___vue_styles__,
  colortheme_Home___vue_scopeId__,
  colortheme_Home___vue_module_identifier__
)

/* harmony default export */ var src_views_colortheme_Home = (colortheme_Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Chat.vue














/* harmony default export */ var colortheme_Chat = ({
  mixins: [ChatMixin],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    Loading: vux_src_components_loading,
    Toast: toast["a" /* default */],
    InlineLoading: vux_src_components_inline_loading
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: {
    inputClicked: function inputClicked() {
      if (this.$refs.phoneInput) {
        this.$refs.phoneInput.focus();
        this.$refs.phoneInput.style.borderColor = this.fontColor;
      }
    },
    adjustInputPosition: function adjustInputPosition(flag) {
      if (flag) {
        this.$refs.phoneInput.style.borderColor = this.fontColor;
      } else {
        this.$refs.phoneInput.style.borderColor = 'rgba(232,232,232,1)';
      }

      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Chat.vue














/* harmony default export */ var views_colortheme_Chat = ({
  mixins: [ChatMixin],
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Scroller: vux_src_components_scroller,
    Loading: vux_src_components_loading,
    Toast: toast["a" /* default */],
    InlineLoading: vux_src_components_inline_loading
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: {
    inputClicked: function inputClicked() {
      if (this.$refs.phoneInput) {
        this.$refs.phoneInput.focus();
        this.$refs.phoneInput.style.borderColor = this.fontColor;
      }
    },
    adjustInputPosition: function adjustInputPosition(flag) {
      if (flag) {
        this.$refs.phoneInput.style.borderColor = this.fontColor;
      } else {
        this.$refs.phoneInput.style.borderColor = 'rgba(232,232,232,1)';
      }

      setTimeout(function () {
        document.body.scrollTop = document.body.scrollHeight;
      }, 300);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d7e63d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/colortheme/Chat.vue
var colortheme_Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat colortheme",attrs:{"id":"chatContainer"}},[_c('div',{staticClass:"chat-header",class:{questionShow: _vm.questionShow},style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("您好，请用一句话描述您的问题。")]),_vm._v(" "),_c('div',{staticClass:"search-bg"})]),_vm._v(" "),(_vm.questions.length > 0)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-content"},[_c('p',{staticClass:"questions-title"},[_vm._v("您可能想问：")]),_vm._v(" "),_vm._l((_vm.questions),function(item,index){return _c('p',{staticClass:"questions-item",style:({color: _vm.fontColor}),on:{"click":function($event){_vm.question(item.question)}}},[_vm._v(_vm._s(item.question))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"},style:({top: _vm.top + 'px', 'padding-bottom': _vm.paddingBottom +'px'})},_vm._l((_vm.chattingRecords),function(record){return _c('div',[(record.type == 2)?_c('div',{staticClass:"chat-user-question"},[_c('div',{staticStyle:{"align-self":"center","margin-bottom":"3px"},attrs:{"id":record.id + '-loading'}},[_c('inline-loading')],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":record.id + '-fail'}},[_c('svg',{staticClass:"exclamation-mark",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-exclamation-mark"}})])]),_vm._v(" "),_c('div',{staticClass:"chat-user-question-content",style:({background:_vm.fontColor})},[_vm._v("\n          "+_vm._s(record.content)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})]):_vm._e(),_vm._v(" "),(record.type == 1)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item",on:{"click":function($event){_vm.addMessage(3, record.title, record.content)}}},[_c('p',{style:({color: _vm.fontColor}),domProps:{"innerHTML":_vm._s(record.content)}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(record.type == 3)?_c('div',{staticClass:"chat-robot-answer-box"},[_c('div',{staticClass:"answer"},[(record.title)?_c('div',{staticClass:"answer-title",domProps:{"innerHTML":_vm._s(record.title)}}):_vm._e(),_vm._v(" "),(record.content)?_c('div',{staticClass:"answer-content-item-detail",class:{adjustPadding: record.title == null},domProps:{"innerHTML":_vm._s(record.content)}}):_vm._e()])]):_vm._e()])}),0),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"hidden","width":"100%"}},[_c('div',{staticClass:"chat-bottom"},[(_vm.showKeyword())?_c('div',{staticClass:"guest"},[_c('div',{staticClass:"guest-option"},_vm._l((_vm.keywords),function(item,index){return (item.name != _vm.title)?_c('div',{key:index,staticClass:"guest-btn-item",on:{"click":function($event){_vm.question(item.name)}}},[_c('x-button',{staticClass:"guest-button",attrs:{"mini":"","type":"primary"}},[_vm._v(_vm._s(item.name))])],1):_vm._e()}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chat-input"},[_c('div',{staticClass:"chat-form",on:{"click":_vm.inputClicked}},[_c('form',{attrs:{"action":"javascript:return true;"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"},{name:"fixedInput",rawName:"v-fixedInput"}],ref:"phoneInput",staticClass:"input",style:({caretColor: _vm.fontColor}),attrs:{"type":"text","placeholder":"请简短描述您的问题"},domProps:{"value":(_vm.message)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.send()},"focus":function($event){_vm.adjustInputPosition(true)},"blur":function($event){_vm.adjustInputPosition()},"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"input-send"},[(!_vm.message)?_c('i',{staticClass:"iconfont send-no"},[_vm._v("")]):_vm._e(),_vm._v(" "),(_vm.message)?_c('i',{staticClass:"iconfont",style:({color: _vm.fontColor})},[_vm._v("")]):_vm._e()])])])]),_vm._v(" "),_c('div',{ref:"move_div",staticClass:"back",style:({background: _vm.fontColor}),on:{"click":function($event){_vm.$router.back(-1)}}},[_c('div',[_vm._v("返回")])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],1)}
var colortheme_Chat_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doctor"},[_c('img',{attrs:{"src":__webpack_require__("QLFm")}})])}]
var colortheme_Chat_esExports = { render: colortheme_Chat_render, staticRenderFns: colortheme_Chat_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_colortheme_Chat = (colortheme_Chat_esExports);
// CONCATENATED MODULE: ./src/views/colortheme/Chat.vue
function colortheme_Chat_injectStyle (ssrContext) {
  __webpack_require__("Kcix")
  __webpack_require__("7IJ1")
}
var colortheme_Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Chat___vue_template_functional__ = false
/* styles */
var colortheme_Chat___vue_styles__ = colortheme_Chat_injectStyle
/* scopeId */
var colortheme_Chat___vue_scopeId__ = "data-v-21d7e63d"
/* moduleIdentifier (server only) */
var colortheme_Chat___vue_module_identifier__ = null
var colortheme_Chat_Component = colortheme_Chat_normalizeComponent(
  views_colortheme_Chat,
  selectortype_template_index_0_src_views_colortheme_Chat,
  colortheme_Chat___vue_template_functional__,
  colortheme_Chat___vue_styles__,
  colortheme_Chat___vue_scopeId__,
  colortheme_Chat___vue_module_identifier__
)

/* harmony default export */ var src_views_colortheme_Chat = (colortheme_Chat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Search.vue










/* harmony default export */ var colortheme_Search = ({
  mixins: [SearchMixin],
  components: {
    Search: vux_src_components_search,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Loading: vux_src_components_loading
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/colortheme/Search.vue










/* harmony default export */ var views_colortheme_Search = ({
  mixins: [SearchMixin],
  components: {
    Search: vux_src_components_search,
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    Loading: vux_src_components_loading
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b926fe7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/colortheme/Search.vue
var colortheme_Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"search colortheme"},[_c('div',{staticClass:"search-header"},[_c('div',{staticClass:"search-header-welcome",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome-search"},[_vm._v("请选择您想咨询的病种")]),_vm._v(" "),_c('div',{staticClass:"search-bg"})]),_vm._v(" "),_c('search',{ref:"search",attrs:{"results":_vm.results,"position":"absolute","auto-scroll-to-top":"","top":"119px"},on:{"on-change":_vm.getResult,"on-focus":_vm.onFocus,"on-cancel":_vm.onCancel,"on-submit":_vm.onSubmit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),(_vm.showResult)?_c('div',{staticClass:"search-result"},[_c('div',{staticClass:"search-result-title"},[_vm._v("\n      # 检索结果\n    ")]),_vm._v(" "),(_vm.searchDisease.length > 0)?_c('div',_vm._l((_vm.searchDisease),function(item,index){return _c('cell',{key:index,attrs:{"title":item.cn_name,"link":{path: ("/" + _vm.template + "/chat/" + _vm.orgUid), query: {cnName: item.cn_name, enName: item.en_name, id: item.id}}}})}),1):_c('div',{staticClass:"search-result-none"},[_c('svg',{staticClass:"icon-none",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-none"}})]),_vm._v(" "),_c('div',{staticClass:"search-result-none-tips"},[_vm._v(_vm._s(_vm.tips))])])]):_c('div',{staticClass:"search-all-disease"},[_c('div',{staticClass:"search-all-disease-title"},[_vm._v("\n      # 全部病种\n    ")]),_vm._v(" "),_c('div',_vm._l((_vm.allDiseases),function(item,index){return _c('cell',{key:index,attrs:{"title":item.cnName,"link":{path: ("/" + _vm.template + "/chat/" + _vm.orgUid), query: {cnName: item.cnName, enName: item.enName, id: item.id}}}})}),1)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],1)}
var colortheme_Search_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doctor"},[_c('img',{attrs:{"src":__webpack_require__("QLFm")}})])}]
var colortheme_Search_esExports = { render: colortheme_Search_render, staticRenderFns: colortheme_Search_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_colortheme_Search = (colortheme_Search_esExports);
// CONCATENATED MODULE: ./src/views/colortheme/Search.vue
function colortheme_Search_injectStyle (ssrContext) {
  __webpack_require__("UoU9")
  __webpack_require__("bFR+")
}
var colortheme_Search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Search___vue_template_functional__ = false
/* styles */
var colortheme_Search___vue_styles__ = colortheme_Search_injectStyle
/* scopeId */
var colortheme_Search___vue_scopeId__ = "data-v-0b926fe7"
/* moduleIdentifier (server only) */
var colortheme_Search___vue_module_identifier__ = null
var colortheme_Search_Component = colortheme_Search_normalizeComponent(
  views_colortheme_Search,
  selectortype_template_index_0_src_views_colortheme_Search,
  colortheme_Search___vue_template_functional__,
  colortheme_Search___vue_styles__,
  colortheme_Search___vue_scopeId__,
  colortheme_Search___vue_module_identifier__
)

/* harmony default export */ var src_views_colortheme_Search = (colortheme_Search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Symptom.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var colortheme_Symptom = ({
  name: 'Symptom',
  mixins: [SymptomMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Symptom.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var guide_colortheme_Symptom = ({
  name: 'Symptom',
  mixins: [SymptomMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e32bbfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/colortheme/Symptom.vue
var colortheme_Symptom_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("请选择与您的情况最相符的一项")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"box"},_vm._l((_vm.departmentList),function(department){return _c('div',{staticClass:"answer",on:{"click":function($event){_vm.detail(department.describe, department.children)}}},[_vm._v(_vm._s(department.describe))])}),0)])}
var colortheme_Symptom_staticRenderFns = []
var colortheme_Symptom_esExports = { render: colortheme_Symptom_render, staticRenderFns: colortheme_Symptom_staticRenderFns }
/* harmony default export */ var views_guide_colortheme_Symptom = (colortheme_Symptom_esExports);
// CONCATENATED MODULE: ./src/views/guide/colortheme/Symptom.vue
function colortheme_Symptom_injectStyle (ssrContext) {
  __webpack_require__("txe0")
}
var colortheme_Symptom_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Symptom___vue_template_functional__ = false
/* styles */
var colortheme_Symptom___vue_styles__ = colortheme_Symptom_injectStyle
/* scopeId */
var colortheme_Symptom___vue_scopeId__ = "data-v-9e32bbfa"
/* moduleIdentifier (server only) */
var colortheme_Symptom___vue_module_identifier__ = null
var colortheme_Symptom_Component = colortheme_Symptom_normalizeComponent(
  guide_colortheme_Symptom,
  views_guide_colortheme_Symptom,
  colortheme_Symptom___vue_template_functional__,
  colortheme_Symptom___vue_styles__,
  colortheme_Symptom___vue_scopeId__,
  colortheme_Symptom___vue_module_identifier__
)

/* harmony default export */ var src_views_guide_colortheme_Symptom = (colortheme_Symptom_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Detail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var colortheme_Detail = ({
  name: 'SymptomDetail',
  mixins: [SymptomDetailMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Detail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var guide_colortheme_Detail = ({
  name: 'SymptomDetail',
  mixins: [SymptomDetailMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e4f6dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/colortheme/Detail.vue
var colortheme_Detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("请选择与您的情况最相符的一项")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"answer"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.parent))]),_vm._v(" "),_vm._l((_vm.departments),function(item){return _c('div',{staticClass:"item",on:{"click":function($event){_vm.showDepartment(item)}}},[_vm._v(_vm._s(item.describe))])})],2)])])}
var colortheme_Detail_staticRenderFns = []
var colortheme_Detail_esExports = { render: colortheme_Detail_render, staticRenderFns: colortheme_Detail_staticRenderFns }
/* harmony default export */ var views_guide_colortheme_Detail = (colortheme_Detail_esExports);
// CONCATENATED MODULE: ./src/views/guide/colortheme/Detail.vue
function colortheme_Detail_injectStyle (ssrContext) {
  __webpack_require__("/zcj")
}
var colortheme_Detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Detail___vue_template_functional__ = false
/* styles */
var colortheme_Detail___vue_styles__ = colortheme_Detail_injectStyle
/* scopeId */
var colortheme_Detail___vue_scopeId__ = "data-v-25e4f6dc"
/* moduleIdentifier (server only) */
var colortheme_Detail___vue_module_identifier__ = null
var colortheme_Detail_Component = colortheme_Detail_normalizeComponent(
  guide_colortheme_Detail,
  views_guide_colortheme_Detail,
  colortheme_Detail___vue_template_functional__,
  colortheme_Detail___vue_styles__,
  colortheme_Detail___vue_scopeId__,
  colortheme_Detail___vue_module_identifier__
)

/* harmony default export */ var src_views_guide_colortheme_Detail = (colortheme_Detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Department.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var colortheme_Department = ({
  name: 'Department',
  mixins: [DepartmentMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/colortheme/Department.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var guide_colortheme_Department = ({
  name: 'Department',
  mixins: [DepartmentMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97132820","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/colortheme/Department.vue
var colortheme_Department_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("推荐您前往以下科室挂号")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"department-box"},[_c('div',[_vm._v(_vm._s(_vm.department))]),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"500","font-size":"14px"}},[_vm._v(_vm._s(_vm.address))])]),_vm._v(" "),(_vm.isShowQrCode)?_c('div',{staticClass:"qrcode-bg"}):_vm._e(),_vm._v(" "),(_vm.isShowQrCode)?_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":__webpack_require__("PBF0")}}),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"go-back-box",on:{"click":function($event){_vm.goBack()}}},[_c('svg',{staticClass:"go-back-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-go-back"}})]),_vm._v(" "),_c('span',{staticClass:"go-back-btn"},[_vm._v("返回首页")])])])])}
var colortheme_Department_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-tips"},[_c('span',[_vm._v("请长按二维码")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v("关注公众号")]),_vm._v(" "),_c('span',[_vm._v("进行")]),_vm._v(" "),_c('span',{staticClass:"highlight"},[_vm._v("挂号")])])}]
var colortheme_Department_esExports = { render: colortheme_Department_render, staticRenderFns: colortheme_Department_staticRenderFns }
/* harmony default export */ var views_guide_colortheme_Department = (colortheme_Department_esExports);
// CONCATENATED MODULE: ./src/views/guide/colortheme/Department.vue
function colortheme_Department_injectStyle (ssrContext) {
  __webpack_require__("SEDx")
}
var colortheme_Department_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var colortheme_Department___vue_template_functional__ = false
/* styles */
var colortheme_Department___vue_styles__ = colortheme_Department_injectStyle
/* scopeId */
var colortheme_Department___vue_scopeId__ = "data-v-97132820"
/* moduleIdentifier (server only) */
var colortheme_Department___vue_module_identifier__ = null
var colortheme_Department_Component = colortheme_Department_normalizeComponent(
  guide_colortheme_Department,
  views_guide_colortheme_Department,
  colortheme_Department___vue_template_functional__,
  colortheme_Department___vue_styles__,
  colortheme_Department___vue_scopeId__,
  colortheme_Department___vue_module_identifier__
)

/* harmony default export */ var src_views_guide_colortheme_Department = (colortheme_Department_Component.exports);

// CONCATENATED MODULE: ./src/router/modules/colortheme.js









// 可换颜色模版
var colorThemeRoutes = [{
  path: '/' + TEMPLATE_COLOR_THEME,
  component: src_layout,
  children: [{
    path: ':orgUid',
    component: src_views_colortheme_Home,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }, {
    path: 'chat/:orgUid',
    component: src_views_colortheme_Chat,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }, {
    path: 'search/:orgUid',
    component: src_views_colortheme_Search,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }, {
    path: 'symptom/:orgUid',
    component: src_views_guide_colortheme_Symptom,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }, {
    path: 'detail/:orgUid',
    component: src_views_guide_colortheme_Detail,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }, {
    path: 'department/:orgUid',
    component: src_views_guide_colortheme_Department,
    meta: {
      template: TEMPLATE_COLOR_THEME
    }
  }]
}];
/* harmony default export */ var modules_colortheme = (colorThemeRoutes);
// CONCATENATED MODULE: ./src/router/modules/color-guide.js



// 基于可换颜色模版增加导诊模块的模版
var colorGuideRoutes = [{
  path: '/' + TEMPLATE_COLOR_THEME_GUIDE,
  component: src_layout,
  children: [{
    path: ':orgUid',
    redirect: '/' + TEMPLATE_COLOR_THEME + '/:orgUid'
  }]
}];
/* harmony default export */ var color_guide = (colorGuideRoutes);
// CONCATENATED MODULE: ./src/router/modules/vistel-guide.js



// 基于vistel模版增加导诊模块的模版
var vistelGuideRoutes = [{
  path: '/' + TEMPLATE_GUIDE,
  component: src_layout,
  children: [{
    path: ':orgUid',
    redirect: '/' + TEMPLATE_VISTEL + '/:orgUid'
  }]
}];
/* harmony default export */ var vistel_guide = (vistelGuideRoutes);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/liyanke/Home.vue












/* harmony default export */ var liyanke_Home = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'fontColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      this.$router.push({ path: '/' + this.template + '/symptom/' + this.orgUid, query: { source: this.$route.path } });
    },
    consult: function consult() {
      this.$router.push({ path: '/' + this.template + '/consult/' + this.orgUid });
    }
  }),
  mounted: function mounted() {
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/liyanke/Home.vue












/* harmony default export */ var views_liyanke_Home = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'fontColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      this.$router.push({ path: '/' + this.template + '/symptom/' + this.orgUid, query: { source: this.$route.path } });
    },
    consult: function consult() {
      this.$router.push({ path: '/' + this.template + '/consult/' + this.orgUid });
    }
  }),
  mounted: function mounted() {
    this.initPage();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e8b3a4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/liyanke/Home.vue
var liyanke_Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"home"},[_c('div',{ref:"mainRef",staticClass:"main"},[_c('div',{staticClass:"header",style:({background: ("linear-gradient(to right," + _vm.bannerColorStart + ", " + _vm.bannerColorEnd + ")") })},[_c('div',{staticClass:"greeting"},[_vm._v("Hi，您好")]),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("智能问答小慧很高兴为您服务")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"department"},[_c('flexbox',{attrs:{"gutter":10,"orient":"vertical"}},[_c('flexbox-item',[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.guide()}}},[_c('svg',{staticClass:"department-item-svg",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})]),_vm._v(" "),_c('span',{style:({color: _vm.fontColor})},[_vm._v("智能导诊")])])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.consult()}}},[_c('svg',{staticClass:"department-item-svg",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-consult"}})]),_vm._v(" "),_c('span',{style:({color: _vm.fontColor})},[_vm._v("术后咨询")])])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.more()}}},[_c('svg',{staticClass:"department-item-svg",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-popularization"}})]),_vm._v(" "),_c('span',{style:({color: _vm.fontColor})},[_vm._v("眼病科普")])])])],1)],1)]),_vm._v(" "),(_vm.orgInfo.id)?[(!['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("WzKy")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title"},[_vm._v("Powered by 致远慧图")])]):(['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("/Qki")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title",staticStyle:{"color":"#155caa"}},[_vm._v("Powered by 览视医疗")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],2)}
var liyanke_Home_staticRenderFns = []
var liyanke_Home_esExports = { render: liyanke_Home_render, staticRenderFns: liyanke_Home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_liyanke_Home = (liyanke_Home_esExports);
// CONCATENATED MODULE: ./src/views/liyanke/Home.vue
function liyanke_Home_injectStyle (ssrContext) {
  __webpack_require__("KjuC")
}
var liyanke_Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var liyanke_Home___vue_template_functional__ = false
/* styles */
var liyanke_Home___vue_styles__ = liyanke_Home_injectStyle
/* scopeId */
var liyanke_Home___vue_scopeId__ = "data-v-6e8b3a4e"
/* moduleIdentifier (server only) */
var liyanke_Home___vue_module_identifier__ = null
var liyanke_Home_Component = liyanke_Home_normalizeComponent(
  views_liyanke_Home,
  selectortype_template_index_0_src_views_liyanke_Home,
  liyanke_Home___vue_template_functional__,
  liyanke_Home___vue_styles__,
  liyanke_Home___vue_scopeId__,
  liyanke_Home___vue_module_identifier__
)

/* harmony default export */ var src_views_liyanke_Home = (liyanke_Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/liyanke/Consult.vue












/* harmony default export */ var Consult = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_COLOR_THEME_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/liyanke/Consult.vue












/* harmony default export */ var liyanke_Consult = ({
  mixins: [HomeMixin],
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    Toast: toast["a" /* default */],
    Loading: vux_src_components_loading,
    GuideService: src_components_GuideService
  },
  data: function data() {
    return {
      iconNames: iconNamesColor,
      isShowGuideService: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['iconColor', 'bannerColorStart', 'bannerColorEnd'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getTheme']), {
    guide: function guide() {
      var path = this.$route.path;
      var orgUid = this.$route.params.orgUid;
      this.$router.push({ path: '/' + this.template + '/symptom/' + orgUid, query: { source: path } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.initPage();
    this.getTheme(this.orgUid).then(function (_ref) {
      var theme = _ref.theme;

      if (theme === TEMPLATE_COLOR_THEME_GUIDE) {
        _this.isShowGuideService = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba6bdba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/liyanke/Consult.vue
var Consult_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"home"},[_c('div',{ref:"mainRef",staticClass:"main"},[_c('div',{staticClass:"chat-header",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-consult"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("请选择您想咨询的内容")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"department"},[_c('flexbox',{attrs:{"gutter":0,"wrap":"wrap"}},_vm._l((_vm.diseaseCategory),function(item,index){return (index < 15)?_c('flexbox-item',{key:index,attrs:{"span":1/2}},[_c('div',{staticClass:"department-item",on:{"click":function($event){_vm.chat(item.cnName, item.enName, item.id)}}},[_c('div',{staticClass:"department-icon",style:({background: _vm.iconColor})},[_c('svg',{staticClass:"icon_disease",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.iconNames[index]}})])]),_vm._v(" "),_c('div',{staticClass:"department-content"},[_c('p',[_vm._v(_vm._s(item.cnName))]),_vm._v(" "),_c('p',[_c('span',[_vm._v("点击询问")]),_vm._v(" "),_c('span',{staticClass:"x-icon"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",attrs:{"type":"ios-arrow-right","size":"12","xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])])])])]):_vm._e()}),1)],1)]),_vm._v(" "),(_vm.orgInfo.id)?[(!['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("WzKy")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title"},[_vm._v("Powered by 致远慧图")])]):(['tkxlglyy', 'jrrmyy'].includes(_vm.orgInfo.id))?_c('div',{staticClass:"powered-by",style:(_vm.poweredByStyle)},[_c('img',{staticClass:"powered-by-logo",attrs:{"src":__webpack_require__("/Qki")}}),_vm._v(" "),_c('div',{staticClass:"powered-by-title",staticStyle:{"color":"#155caa"}},[_vm._v("Powered by 览视医疗")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":2000,"width":"20em","is-show-mask":"","text":_vm.tips,"position":_vm.position},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.showLoading,"text":_vm.content}})],2)}
var Consult_staticRenderFns = []
var Consult_esExports = { render: Consult_render, staticRenderFns: Consult_staticRenderFns }
/* harmony default export */ var views_liyanke_Consult = (Consult_esExports);
// CONCATENATED MODULE: ./src/views/liyanke/Consult.vue
function Consult_injectStyle (ssrContext) {
  __webpack_require__("9yqV")
}
var Consult_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Consult___vue_template_functional__ = false
/* styles */
var Consult___vue_styles__ = Consult_injectStyle
/* scopeId */
var Consult___vue_scopeId__ = "data-v-7ba6bdba"
/* moduleIdentifier (server only) */
var Consult___vue_module_identifier__ = null
var Consult_Component = Consult_normalizeComponent(
  liyanke_Consult,
  views_liyanke_Consult,
  Consult___vue_template_functional__,
  Consult___vue_styles__,
  Consult___vue_scopeId__,
  Consult___vue_module_identifier__
)

/* harmony default export */ var src_views_liyanke_Consult = (Consult_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/liyanke/Department.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var liyanke_Department = ({
  name: 'Department',
  mixins: [DepartmentMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/guide/liyanke/Department.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var guide_liyanke_Department = ({
  name: 'Department',
  mixins: [DepartmentMixin],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['fontColor', 'bannerColorStart', 'bannerColorEnd']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187451f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/guide/liyanke/Department.vue
var liyanke_Department_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"chat"},[_c('div',{staticClass:"chat-header",style:({background: 'linear-gradient(to right,'+_vm.bannerColorStart+','+_vm.bannerColorEnd+')'})},[_c('div',{staticClass:"doctor"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-guide-green"}})])]),_vm._v(" "),_c('div',{staticClass:"welcome-before"}),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._v("推荐您前往以下科室挂号")]),_vm._v(" "),_c('div',{staticClass:"header-bg"})]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"department-box"},[_c('div',{staticClass:"department-title"},[_vm._v("科室地址：")]),_vm._v(" "),_c('div',{staticClass:"department-name"},[_vm._v(_vm._s(_vm.department))]),_vm._v(" "),_c('div',{staticClass:"department-address"},[_vm._v(_vm._s(_vm.address))]),_vm._v(" "),_c('img',{staticClass:"department-bg",attrs:{"src":__webpack_require__("B3lY")}})])]),_vm._v(" "),(_vm.isShowQuestionnaire)?_c('div',{staticClass:"questionnaire"},[_c('div',{staticClass:"questionnaire-tips"},[_vm._v("做个干眼小调查吧，让医生更清楚您的情况")]),_vm._v(" "),_c('button',{staticClass:"questionnaire-btn",on:{"click":function($event){_vm.goQuestionnaire()}}},[_vm._v("填写调查问卷")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottom"},[(_vm.isShowQrCode)?_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":__webpack_require__("PBF0")}}),_vm._v(" "),_c('div',{staticClass:"qrcode-tips"},[_vm._v("请长按二维码关注公众号进行挂号")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"go-back-box",on:{"click":function($event){_vm.goBack()}}},[_c('svg',{staticClass:"go-back-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-go-back"}})]),_vm._v(" "),_c('span',{staticClass:"go-back-btn"},[_vm._v("返回首页")])])])])}
var liyanke_Department_staticRenderFns = []
var liyanke_Department_esExports = { render: liyanke_Department_render, staticRenderFns: liyanke_Department_staticRenderFns }
/* harmony default export */ var views_guide_liyanke_Department = (liyanke_Department_esExports);
// CONCATENATED MODULE: ./src/views/guide/liyanke/Department.vue
function liyanke_Department_injectStyle (ssrContext) {
  __webpack_require__("g4D9")
}
var liyanke_Department_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var liyanke_Department___vue_template_functional__ = false
/* styles */
var liyanke_Department___vue_styles__ = liyanke_Department_injectStyle
/* scopeId */
var liyanke_Department___vue_scopeId__ = "data-v-187451f1"
/* moduleIdentifier (server only) */
var liyanke_Department___vue_module_identifier__ = null
var liyanke_Department_Component = liyanke_Department_normalizeComponent(
  guide_liyanke_Department,
  views_guide_liyanke_Department,
  liyanke_Department___vue_template_functional__,
  liyanke_Department___vue_styles__,
  liyanke_Department___vue_scopeId__,
  liyanke_Department___vue_module_identifier__
)

/* harmony default export */ var src_views_guide_liyanke_Department = (liyanke_Department_Component.exports);

// CONCATENATED MODULE: ./src/router/modules/liyanke.js










// 可换颜色模版
var liyankeRoutes = [{
  path: '/' + TEMPLATE_LI_YAN_KE,
  component: src_layout,
  children: [{
    path: ':orgUid',
    component: src_views_liyanke_Home,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'consult/:orgUid',
    component: src_views_liyanke_Consult,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'chat/:orgUid',
    component: src_views_colortheme_Chat,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'search/:orgUid',
    component: src_views_colortheme_Search,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'symptom/:orgUid',
    component: src_views_guide_colortheme_Symptom,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'detail/:orgUid',
    component: src_views_guide_colortheme_Detail,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }, {
    path: 'department/:orgUid',
    component: src_views_guide_liyanke_Department,
    meta: {
      template: TEMPLATE_LI_YAN_KE
    }
  }]
}];
/* harmony default export */ var liyanke = (liyankeRoutes);
// CONCATENATED MODULE: ./src/router/index.js














vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

// 兼容旧路由
var legacyRoutes = [{
  path: '/',
  redirect: '/zhongshan'
}, {
  path: '/:orgUid',
  meta: {
    isEntrance: true
  }
}, {
  path: '/chat/:orgUid',
  meta: {
    redirect: 'chat'
  }
}, {
  path: '/search/:orgUid',
  meta: {
    redirect: 'search'
  }
}];

var router_router = new vue_router_esm["a" /* default */]({
  routes: [].concat(legacyRoutes, toConsumableArray_default()(modules_zhongshan), toConsumableArray_default()(vistel), toConsumableArray_default()(modules_colortheme), toConsumableArray_default()(color_guide), toConsumableArray_default()(vistel_guide), toConsumableArray_default()(liyanke))
});

router_router.beforeEach(function (to, from, next) {
  // 若机构模版需从后台获取，则需配置：1. 路由的meta.template为对应模版值 2. constant中配置模版
  if (to.meta.template || to.meta.isEntrance || to.meta.redirect) {
    var orgUid = to.params.orgUid;
    src_store.dispatch('getTheme', orgUid).then(function (_ref) {
      var theme = _ref.theme;

      // 转换包含导诊模块的模板为对应基础模板
      theme = theme === TEMPLATE_GUIDE && TEMPLATE_VISTEL || theme === TEMPLATE_COLOR_THEME_GUIDE && TEMPLATE_COLOR_THEME || theme;
      if (theme === to.meta.template) {
        next();
      } else if (theme === 'error') {
        vm.$vux.toast.show({
          type: 'text',
          text: '连接不上服务器，请检查网络',
          width: '15em',
          position: 'middle',
          isShowMask: true
        });
        next(false);
      } else if (to.meta.isEntrance) {
        // 跳转到对应模板首页
        next({
          path: '/' + theme + '/' + orgUid
        });
      } else if (to.meta.redirect) {
        // 兼容旧url访问，跳转到对应模板页面
        var query = to.query || {};
        query.redirect = true;
        var params = keys_default()(query).map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(query[key]);
        }).join("&");
        next({
          path: '/' + theme + '/' + to.meta.redirect + '/' + orgUid + '?' + params
        });
      } else {
        next({
          path: '/' + orgUid
        });
      }
    });
  } else {
    next();
  }
});

/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./src/assets/icon/iconfont.js
var iconfont = __webpack_require__("LUZl");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd29b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("3XPw")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js + 1 modules
var plugins_toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/main.js
__webpack_require__("BjtM");












vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);



vue_esm["a" /* default */].prototype.$http = api;

vue_esm["a" /* default */].use(vue_wechat_title_default.a);

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: "UA-157434648-1",
  router: src_router
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

var windowHeight = window.innerHeight;
vue_esm["a" /* default */].directive('fixedInput', function (el, binding) {
  el.addEventListener('blur', function () {
    if (!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return;
    }
    var windowFocusHeight = window.innerHeight;
    if (windowHeight == windowFocusHeight) {
      return;
    }
    var currentPosition = void 0;
    var speed = 1;
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= speed;
    window.scrollTo(0, currentPosition);
    currentPosition += speed;
    window.scrollTo(0, currentPosition);
  });
});

/* eslint-disable no-new */
window.vm = new vue_esm["a" /* default */]({
  router: src_router,
  store: src_store,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Ngll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PBF0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/offiaccount-qrcode@3x.d104a95.png";

/***/ }),

/***/ "QLFm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doctor.20bf869.png";

/***/ }),

/***/ "QOUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rc8k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SEDx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UoU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WzKy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vistel-logo.c8a89c8.png";

/***/ }),

/***/ "bFR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bZsH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqo/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d4qF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d9PG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g4D9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPO7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iiI+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kllH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kmEy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8kD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("kllH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txe0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWuI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFaUlEQVRoQ9VaXYhVVRT+1o2bMjpckwhMgzQHp4YY7ezdhA+BJmRKUSY9RP9qUBRIv0akUg9BzShERlGa0c9DURBlGuFE1EO59/HOIJcKG+fF8qGkGdQZ5947s2LdzrncmTnXOX93ZPbLMNy9vrW+tdfea6+1DyGFYYxZQkQ3AegAcCOAGwBcWgvNzOeJqIeZfyYiI3+11ieSqqe4ANbaLIB7ATwH4LqYOMcAdAH4RClVioMRmYC1tomIHmVmMXxBHKUBMn8yc1epVHp75cqVw1EwQxMQwwE8BmAbgMujKIkw928ArxWLxT1hiYQiYIxZRkQHAFwTwZgkU/uYeb3W+vepQKYkYIxZR0SfApgzFVjKv59j5nu01t9cCPeCBIwxDxDR+wAyKRsXFm6MmbdorffVE6hLwBiziYjeC6upkfOI6H7HcT4K0hFIwBhzGxF9fRE9P85WZh4FcLvW+uBEEpMIWGtlo/YAmNtIr8bAPgtguVKqr1Z2HIHjx4/PGhwczAO4NoaC6RD5LZfLLW9paRnxlY0j4LruDmbeOR2WJNCxQyn18iQCPT09C8vlsizPrATgVVFmPk1EewBcBuDJNDA9jJFsNru0vb39pPxfXQFr7esAnklDETOfzGQyqxzH+UPwrLWSwd9KA9vD6FRKPVsl0NvbO6dYLJ4iouYUlIjRNyulTtVipUmCmc80NTVd2dbWdrayAq7rPsTMkrCSjmOjo6OrOjo6TgcBua67lZl3J1VS8TzRw47j7K8QsNYeBrA6CTAzH2lubl7T2tp6ZiJOf3//7MWLF5/3dMll8NUkukSWmQ9rrdeQtTYH4N/a/RAD/Ptisbjev0HKcTwwMLBda/2ibzQRHXEcp9v7X06Rl2LoqRXhbDbbTK7rbmDmzxOAScbe4Bck3n76lohmK6WU4BpjdhLRNiJa55Mwxuwmoq0J9EoY3S0rIBXRUzGBPnAc5xEiGhP5fD4/r1wudxPRCtlaEwjsADBSS8JaKyeTnFBxxy4hcAjArVERmPlNrXX1fLfWSnUmIdLqYQURkJ8ki65RSv3khVNsEsx8iIwxfUS0JAoBZt6jtX7Cl8nn81eXy+UfiWhRDU49AjJlSJzmkzDG7JNTJYoN3kbuFwKSMedHEc5ms0va29v7PQ+Kx38AcMUEjAsRGEeCmWUvStG0MYodlWxvrZX4nbIyG7f9mTdrrfcePXpUjY2NfQdgXoDiqQj4JFYrpX6x1m4G8G4UAgDGhEARgLRIIg1mLhDRwjrGC1YYAr5OF4CEsdybooyiEJAcEOTBKEBBc6MQiKWrEkJxNnFIbdNB4IQQOEhEa0MaFWXadBA4JCHUCeDpKJaFnNtwAgB2yfF1FzN/EdKoKNMaToCZ76RCoTB/eHj4n6hHaQgmjSbw/2XOS0aJr9Mx80AIP9Sd0q2UuqVCwBgjF7K9SdCmmwAzb5KOXYVAoVCYOzQ09FdKJWU1OQXcRlPx0aSS0gujJNfqSYYxc4/WWq7VUvG9kXJnokspVWlAVO9Avb29i0qlkhTkqbRVAJSI6D4AZWb+EIC8L6QxgtsqnqekzKs2jdLQ1gCM7UqpV3zcmdZa/DWXy62o21r0VmHmNnf9ZbHWrmfmL4nokgaEQGRIr71+R9BrTd1Cxlr7IID9kbU1QCDyA4dvg5fgpEqaeU9M1WzkumuZ+bOL8OBxjog2Oo4jXZO6I1QtbK2Vwv0rAEsbECFBkOk9s9ZsbElEjwN4fsY9dNe6yHux3+IRSe1TAyLqHBkZeSfsC31gIosSHv7HHsz8AhEtiyLrz5XORiaT6WTmj6ftY48gQ2s+t7memRcS0VXMvMDr1Pkv/NJSzKf9uc1/cFqUmyyl/r8AAAAASUVORK5CYII="

/***/ }),

/***/ "wAJW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.63b908a71b0d77c12d98.js